(() => {
  // TEMPORARY DEN CONSTRUCTION GATE.
  // Leave this guard in place. When #nw-den-construction-gate is removed
  // from the Den HTML, the original Den automatically initializes again.
  if (document.getElementById('nw-den-construction-gate')) {
    return;
  }

  const API_BASE = window.__DEN_API_BASE__ || "https://letters.thenaturewolf.com";
  const AWARD_SOUND_URL = "https://cdn.shopify.com/s/files/1/0686/5764/3564/files/shine-8-268901.mp3?v=1763096264";
  const PACK_XP_COLLECT_SOUND_URL = "https://cdn.shopify.com/s/files/1/0686/5764/3564/files/packxpsound.mp3?v=1777495174";

  const awardAudio = new Audio(AWARD_SOUND_URL);
  const packXpCollectAudio = new Audio(PACK_XP_COLLECT_SOUND_URL);
  awardAudio.preload = 'auto';
  packXpCollectAudio.preload = 'auto';
  packXpCollectAudio.volume = 0.95;

  const TRAILS_BIOME_ORDER = ['forest', 'ocean', 'desert', 'arctic', 'jungle', 'mountains', 'savannah', 'freshwater'];
  const TRAILS_BIOME_LABELS = {
    forest: 'Forest',
    ocean: 'Ocean',
    desert: 'Desert',
    arctic: 'Arctic',
    jungle: 'Jungle',
    mountains: 'Mountains',
    savannah: 'Savannah / Grassland',
    freshwater: 'Freshwater'
  };

  const TRAILS_BIOME_BACKGROUNDS = {
    forest: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/forestbackground.png?v=1760641436',
    ocean: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/Endless_blue_sea_under_soft_clouds.png?v=1775324713',
    desert: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/Expansive_desert_under_a_clear_sky.png?v=1775324961',
    arctic: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/Icy_bay_and_rugged_mountains.png?v=1775324608',
    jungle: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/Lush_jungle_with_misty_sunlight_beams.png?v=1775324961',
    mountains: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/Snow-capped_peaks_and_evergreen_forest.png?v=1775324436',
    savannah: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/Savannah_meets_grassy_meadow_at_sunset.png?v=1775324017',
    freshwater: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/freshwater.png?v=1775779562'
  };
  const state = {
    me: null,
    pack: [],
    fullPack: [],
    catalog: [],
    selectedItemId: null,
    selectedWolfId: null,
    wolves: [],
    editorLayout: [],
    drag: null,
    layerDragItemId: null,
    authEmailChecked: false,
    authRequiresPackName: false,
    pendingPackName: '',
    lastAuthEmail: '',
    packPage: 1,
    packPageSize: 50,
    packHasNext: false,
    packTotal: 0,
    selectedPackMember: null,
    combinedModalTab: 'wolves',
    // Pending rewards awaiting claim
    pendingAwards: [],
    currentAward: null,
    challengesList: [],
    gcActiveTab: 'games',
    gcShowCompleted: false,
    gcChallengeFilter: 'all',
    activeShareLetter: null,
    activeShareData: null,
    archivePosts: [],
    archiveFiltered: [],
archiveTypeFilter: 'all',
archivePage: 1,
    archivePageSize: 5,
    archiveLoaded: false,
    archiveExpanded: false,
    lastRenderedRankKey: null,
    queuedRankUnlock: null,
    queuedWolfUnlocks: [],
    queuedSwagUnlocks: [],
currentSwagUnlock: null,
activeSwagUnlockQueue: [],
activeSwagUnlockIndex: 0,
swagUnlockTimers: [],
    treasureChest: null,
    treasureChestTimerId: null,
    heartChest: null,
    heartChestTimerId: null,
    treasureChestRevealTimerId: null,
    treasureChestPendingCredit: null,
    treasureChestRewardRevealed: false,
    trailsState: null,
    trailsQuestion: null,
    trailsTimerId: null,
    trailsSubmitting: false,
    trailsRoundSummary: null,
    trailsBiomeSummary: null,
    trailsPendingSwagClaim: null,
    simPendingSwagClaim: null,
    trailsStatsExpanded: false,
    currentAwardSource: null,
    currentAwardTriggerBtn: null,
    firstDenActionTracked: false
  };

  const els = {
    denRoot: document.getElementById('nw-pack-den'),
    alert: document.getElementById('nw-alert'),
    authCard: document.getElementById('nw-auth-card'),
    guestJoinCard: document.getElementById('nw-guest-join-card'),
    email: document.getElementById('nw-email'),
    packNameWrap: document.getElementById('nw-pack-name-wrap'),
    packName: document.getElementById('nw-pack-name'),
    checkEmail: document.getElementById('nw-check-email'),
    sendCode: document.getElementById('nw-send-code'),
    stepRequest: document.getElementById('nw-step-request'),
    stepVerify: document.getElementById('nw-step-verify'),
    code: document.getElementById('nw-code'),
    verify: document.getElementById('nw-verify-code'),
    back: document.getElementById('nw-back'),
    app: document.getElementById('nw-app'),
    denSummary: document.getElementById('nw-den-summary'),
    denSummaryToggle: document.getElementById('nw-den-summary-toggle'),
    denSummaryBody: document.getElementById('nw-den-summary-body'),
    denSummaryChevron: document.getElementById('nw-den-summary-chevron'),
    editorBaseWolf: document.getElementById('nw-editor-base-wolf'),
    profileWelcome: document.getElementById('nw-profile-welcome'),
    packNameDisplay: document.getElementById('nw-pack-name-display'),
    starsDisplay: document.getElementById('nw-stars-display'),
    ownedCount: document.getElementById('nw-owned-count'),
equippedCount: document.getElementById('nw-equipped-count'),
collectionOwnedCount: document.getElementById('nw-collection-owned-count'),
collectionSwagOwnedCount: document.getElementById('nw-collection-swag-owned-count'),
    nextRank: document.getElementById('nw-next-rank'),
    progressCopy: document.getElementById('nw-progress-copy'),
    progressBar: document.getElementById('nw-progress-bar'),
    homePackRail: document.getElementById('nw-home-pack-rail'),
    editorStage: document.getElementById('nw-editor-stage'),
    packList: document.getElementById('nw-pack-list'),
    packModalList: document.getElementById('nw-pack-modal-list'),
    openPackModal: document.getElementById('nw-open-pack-modal'),
    summaryViewLeaderboard: document.getElementById('nw-summary-view-leaderboard'),
    packModal: document.getElementById('nw-pack-modal'),
    packMemberModal: document.getElementById('nw-pack-member-modal'),
    packMemberTitle: document.getElementById('nw-pack-member-title'),
    packMemberMeta: document.getElementById('nw-pack-member-meta'),
    packMemberStatus: document.getElementById('nw-pack-member-status'),
    packMemberWolves: document.getElementById('nw-pack-member-wolves'),
    packMemberClose: document.getElementById('nw-pack-member-close'),
    packPrev: document.getElementById('nw-pack-prev'),
    packNext: document.getElementById('nw-pack-next'),
    packPageCopy: document.getElementById('nw-pack-page-copy'),
    openCustomize: document.getElementById('nw-open-customize'),
    openStore: document.getElementById('nw-open-store'),
    previewOpenStyling: document.getElementById('nw-preview-open-styling'),
    previewOpenShop: document.getElementById('nw-preview-open-shop'),
    openTriviaMain: document.getElementById('nw-open-trivia-main'),
    openAchievementsMain: document.getElementById('nw-open-achievements-main'),
    triviaShortcutTitle: document.getElementById('nw-trivia-shortcut-title'),
    triviaShortcutStat: document.getElementById('nw-trivia-shortcut-stat'),
    achievementsShortcutBadge: document.getElementById('nw-achievements-shortcut-badge'),
    achievementsShortcutNote: document.getElementById('nw-achievements-shortcut-note'),
    packReferralCard: document.getElementById('nw-pack-referral-card'),
    packReferralUrl: document.getElementById('nw-pack-referral-url'),
    packReferralCopy: document.getElementById('nw-pack-referral-copy'),
    packReferralStatus: document.getElementById('nw-pack-referral-status'),
    backdrop: document.getElementById('nw-modal-backdrop'),
    customizeModal: document.getElementById('nw-customize-modal'),
    combinedModalTitle: document.getElementById('nw-combined-modal-title'),
    combinedTabWolves: document.getElementById('nw-combined-tab-wolves'),
    combinedTabShop: document.getElementById('nw-combined-tab-shop'),
    combinedPanelWolves: document.getElementById('nw-combined-panel-wolves'),
    combinedPanelShop: document.getElementById('nw-combined-panel-shop'),
    storeModal: document.getElementById('nw-store-modal'),
    storeCloseSide: document.getElementById('nw-store-close-side'),
    wolfList: document.getElementById('nw-wolf-list'),
    ownedList: document.getElementById('nw-owned-list'),
    storeGrid: document.getElementById('nw-store-grid'),
    removeSelected: document.getElementById('nw-remove-selected'),
    clearAll: document.getElementById('nw-clear-all'),
    saveWolfLayout: document.getElementById('nw-save-wolf-layout'),
    customizeCloseBottom: document.getElementById('nw-customize-close-bottom'),
    editorAutosaveNote: document.getElementById('nw-editor-autosave-note'),
    editorLayerStrip: document.getElementById('nw-editor-layer-strip')
    ,
    // Award-related elements
    awardPopup: document.getElementById('nw-award-popup'),
    awardPopupMessage: document.getElementById('nw-award-popup-message'),
    awardStarAnimation: document.getElementById('nw-award-star-animation'),
    awardPopupReceive: document.getElementById('nw-award-popup-receive'),
    awardPopupClose: document.getElementById('nw-award-popup-close'),
    rankUnlockPopup: document.getElementById('nw-rank-unlock-popup'),
    rankUnlockTitle: document.getElementById('nw-rank-unlock-title'),
    rankUnlockMessage: document.getElementById('nw-rank-unlock-message'),
    rankUnlockImage: document.getElementById('nw-rank-unlock-image'),
    rankUnlockRankName: document.getElementById('nw-rank-unlock-rank-name'),
    rankUnlockStars: document.getElementById('nw-rank-unlock-stars'),
    rankUnlockClose: document.getElementById('nw-rank-unlock-close'),
    rankUnlockOpenCustomize: document.getElementById('nw-rank-unlock-open-customize'),
    rankUnlockContinue: document.getElementById('nw-rank-unlock-continue'),
    swagUnlockPopup: document.getElementById('nw-swag-unlock-popup'),
    swagUnlockClose: document.getElementById('nw-swag-unlock-close'),
    swagUnlockTitle: document.getElementById('nw-swag-unlock-title'),
    swagUnlockMessage: document.getElementById('nw-swag-unlock-message'),
    swagUnlockImage: document.getElementById('nw-swag-unlock-image'),
    swagUnlockName: document.getElementById('nw-swag-unlock-name'),
    swagUnlockSource: document.getElementById('nw-swag-unlock-source'),
    swagUnlockOpenStore: document.getElementById('nw-swag-unlock-open-store'),
swagUnlockContinue: document.getElementById('nw-swag-unlock-continue'),
swagUnlockNext: document.getElementById('nw-swag-unlock-next'),
collectionNextSwag: document.getElementById('nw-collection-next-swag'),
    collectionNextSwagCard: document.getElementById('nw-collection-next-swag-card'),
    starsAvailable: document.getElementById('nw-stars-available'),
    starsAlltime: document.getElementById('nw-stars-alltime'),
    heartsAvailable: document.getElementById('nw-hearts-available'),
    packXpDisplay: document.getElementById('nw-pack-xp-display'),
    shopStarsAvailable: document.getElementById('nw-shop-stars-available')
    ,
    // Games & Challenges elements
    openGoals: document.getElementById('nw-open-goals'),
    goalsModal: document.getElementById('nw-goals-modal'),
    goalsList: document.getElementById('nw-goals-list'),
    goalsClose: document.getElementById('nw-goals-close'),
    goalsStarsAvailable: document.getElementById('nw-goals-stars-available'),
    goalsHeartsAvailable: document.getElementById('nw-goals-hearts-available'),
    goalsPackXp: document.getElementById('nw-goals-pack-xp'),
    goalsStarAnimation: document.getElementById('nw-goals-star-animation'),
    gcTabGames: document.getElementById('nw-gc-tab-games'),
    gcTabChallenges: document.getElementById('nw-gc-tab-challenges'),
   gcGamesPanel: document.getElementById('nw-gc-games-panel'),
    gcChallengesPanel: document.getElementById('nw-gc-challenges-panel'),
    gcGamesList: document.getElementById('nw-gc-games-list'),
    gcShowCompleted: document.getElementById('nw-gc-show-completed'),
    gcChallengeFilter: document.getElementById('nw-gc-challenge-filter'),

    trailsModal: document.getElementById('nw-trails-modal'),
    trailsClose: document.getElementById('nw-trails-close'),
    trailsScreenMenu: document.getElementById('nw-trails-screen-menu'),
    trailsScreenGame: document.getElementById('nw-trails-screen-game'),
    trailsHeadRound: document.getElementById('nw-trails-head-round'),
    trailsHeadHearts: document.getElementById('nw-trails-head-hearts'),
    trailsHeadStars: document.getElementById('nw-trails-head-stars'),
    trailsHeadPackXp: document.getElementById('nw-trails-head-pack-xp'),
    trailsMenuRound: document.getElementById('nw-trails-menu-round'),
    trailsMenuCorrect: document.getElementById('nw-trails-menu-correct'),
    trailsMenuPool: document.getElementById('nw-trails-menu-pool'),
    trailsMenuScoreNote: document.getElementById('nw-trails-menu-score-note'),
    trailsMenuStreak: document.getElementById('nw-trails-menu-streak'),
    trailsRouteCopy: document.getElementById('nw-trails-route-copy'),
    trailsRouteLineFill: document.getElementById('nw-trails-route-line-fill'),
    trailsBestGrid: document.getElementById('nw-trails-best-grid'),
    trailsBoardList: document.getElementById('nw-trails-board-list'),
    trailsBiomeGrid: document.getElementById('nw-trails-biome-grid'),
    trailsLifetimeToggle: document.getElementById('nw-trails-lifetime-toggle'),
    trailsLifetimeChevron: document.getElementById('nw-trails-lifetime-chevron'),
    trailsLifetimePanel: document.getElementById('nw-trails-lifetime-panel'),
    trailsLifetimeSummary: document.getElementById('nw-trails-lifetime-summary'),
    trailsLifetimeGrid: document.getElementById('nw-trails-lifetime-grid'),
    trailsMenuNote: document.getElementById('nw-trails-menu-note'),
    trailsStartBtn: document.getElementById('nw-trails-start-btn'),
    trailsBackBtn: document.getElementById('nw-trails-back-btn'),
    trailsStage: document.getElementById('nw-trails-stage'),
    trailsGameRound: document.getElementById('nw-trails-game-round'),
    trailsGameBiome: document.getElementById('nw-trails-game-biome'),
    trailsGameQuestionNumber: document.getElementById('nw-trails-game-question-number'),
    trailsGameNextBiome: document.getElementById('nw-trails-game-next-biome'),
    trailsTimerCount: document.getElementById('nw-trails-timer-count'),
    trailsQuestionText: document.getElementById('nw-trails-question'),
    trailsAnswers: document.getElementById('nw-trails-answers'),
    trailsFeedback: document.getElementById('nw-trails-feedback'),
    trailsNextBtn: document.getElementById('nw-trails-next-btn'),
    trailsMenuBtn: document.getElementById('nw-trails-menu-btn'),
    trailsRoundComplete: document.getElementById('nw-trails-round-complete'),
    trailsRoundCompleteRound: document.getElementById('nw-trails-round-complete-round'),
    trailsRoundCompleteAccuracy: document.getElementById('nw-trails-round-complete-accuracy'),
    trailsRoundCompleteScore: document.getElementById('nw-trails-round-complete-score'),
    trailsRoundCompleteBonus: document.getElementById('nw-trails-round-complete-bonus'),
    trailsRoundCompleteTotal: document.getElementById('nw-trails-round-complete-total'),
    trailsRoundCompleteLabel: document.getElementById('nw-trails-round-complete-label'),
    trailsRoundCompleteContinue: document.getElementById('nw-trails-round-complete-continue'),
    trailsRoundCompleteClose: document.getElementById('nw-trails-round-complete-close'),
    trailsRoundClaimSwag: document.getElementById('nw-trails-round-claim-swag'),
    trailsBiomeComplete: document.getElementById('nw-trails-biome-complete'),
    trailsBiomeCompleteTitle: document.getElementById('nw-trails-biome-complete-title'),
    trailsBiomeCompleteLabel: document.getElementById('nw-trails-biome-complete-label'),
    trailsBiomeCompleteAccuracy: document.getElementById('nw-trails-biome-complete-accuracy'),
    trailsBiomeCompleteScore: document.getElementById('nw-trails-biome-complete-score'),
    trailsBiomeCompleteStars: document.getElementById('nw-trails-biome-complete-stars'),
    trailsBiomeCompleteNext: document.getElementById('nw-trails-biome-complete-next'),
trailsBiomeCompleteContinue: document.getElementById('nw-trails-biome-complete-continue'),
    simModal: document.getElementById('nw-sim-modal'),
    simClose: document.getElementById('nw-sim-close'),
    simScreenMenu: document.getElementById('nw-sim-screen-menu'),
    simScreenGame: document.getElementById('nw-sim-screen-game'),
    simScreenResult: document.getElementById('nw-sim-screen-result'),
    simHearts: document.getElementById('nw-sim-hearts'),
    simPackXp: document.getElementById('nw-sim-pack-xp'),
    simStartBtn: document.getElementById('nw-sim-start-btn'),
    simBackBtn: document.getElementById('nw-sim-back-btn'),
    simCanvas: document.getElementById('nw-sim-canvas'),
    simHud: document.getElementById('nw-sim-hud'),
    simHudPrey: document.getElementById('nw-sim-hud-prey'),
    simHudTimer: document.getElementById('nw-sim-hud-timer'),
    simHudWolves: document.getElementById('nw-sim-hud-wolves'),
    simResultTitle: document.getElementById('nw-sim-result-title'),
    simResultBody: document.getElementById('nw-sim-result-body'),
    simResultClose: document.getElementById('nw-sim-result-close'),
    simResultClaimSwag: document.getElementById('nw-sim-result-claim-swag')

    ,
    // Subscription step elements
    stepSubscribe: document.getElementById('nw-step-subscribe'),
    subscribeCancel: document.getElementById('nw-subscribe-cancel'),

    setupStep: document.getElementById('nw-step-setup'),
    setupEmail: document.getElementById('nw-setup-email'),
    setupPackName: document.getElementById('nw-setup-pack-name'),
    setupSend: document.getElementById('nw-setup-send'),
    setupBack: document.getElementById('nw-setup-back'),

    joinForm: document.getElementById('nw-den-shopify-form'),
    joinEmail: document.getElementById('nw-shopify-newsletter-email'),
    joinSubmit: document.getElementById('nw-den-shopify-submit'),
    joinNote: document.getElementById('nw-den-shopify-note'),
    joinCardMain: document.getElementById('nw-den-join-card-main'),
    afterSubscribe: document.getElementById('nw-den-after-subscribe'),
    startDenSetup: document.getElementById('nw-start-den-setup'),
    skipDenSetup: document.getElementById('nw-skip-den-setup'),

    // Logout button
    logout: document.getElementById('nw-logout'),

    // Newsletter archive
    archiveShell: document.getElementById('nw-archive-shell'),
    archivePanel: document.getElementById('nw-archive-panel'),
    archiveSearch: document.getElementById('nw-archive-search'),
archiveTypeFilters: document.getElementById('nw-archive-type-filters'),
archiveList: document.getElementById('nw-archive-list'),
    archiveStatus: document.getElementById('nw-archive-status'),
    archivePrev: document.getElementById('nw-archive-prev'),
    archiveNext: document.getElementById('nw-archive-next'),
    archivePageCopy: document.getElementById('nw-archive-page-copy'),
    archiveMemberLogin: document.getElementById('nw-archive-member-login'),
    archiveToggle: document.getElementById('nw-archive-toggle'),
    archiveBody: document.getElementById('nw-archive-body'),
    archiveToggleBadge: document.getElementById('nw-archive-toggle-badge'),
    archiveToggleChevron: document.getElementById('nw-archive-toggle-chevron'),
    shareModal: document.getElementById('nw-share-modal'),
    shareClose: document.getElementById('nw-share-close'),
    shareTitle: document.getElementById('nw-share-title'),
    shareLinkInput: document.getElementById('nw-share-link-input'),
    shareStatus: document.getElementById('nw-share-status'),
    shareCopy: document.getElementById('nw-share-copy'),
    shareNative: document.getElementById('nw-share-native'),
    shareEmail: document.getElementById('nw-share-email'),
    shareSms: document.getElementById('nw-share-sms'),
    shareFacebook: document.getElementById('nw-share-facebook'),
    shareX: document.getElementById('nw-share-x'),
    shareWhatsapp: document.getElementById('nw-share-whatsapp'),
    shareReddit: document.getElementById('nw-share-reddit'),
    shareLinkedin: document.getElementById('nw-share-linkedin'),

    guestLandingShell: document.getElementById('nw-guest-landing-shell'),
    publicPreviewShell: document.getElementById('nw-public-preview-shell'),
    publicOpenTrivia: document.getElementById('nw-public-open-trivia'),
    publicOpenAchievements: document.getElementById('nw-public-open-achievements'),
    publicOpenWolves: document.getElementById('nw-public-open-wolves'),
    publicOpenStore: document.getElementById('nw-public-open-store'),
    publicTreasureChestButton: document.getElementById('nw-public-treasure-chest-button'),
    publicHeartChestButton: document.getElementById('nw-public-heart-chest-button'),
    guestPreviewModal: document.getElementById('nw-guest-preview-modal'),
    guestPreviewTitle: document.getElementById('nw-guest-preview-title'),
    guestPreviewCopy: document.getElementById('nw-guest-preview-copy'),
    guestPreviewBody: document.getElementById('nw-guest-preview-body'),
    guestPreviewClose: document.getElementById('nw-guest-preview-close'),
    guestPreviewLogin: document.getElementById('nw-guest-preview-login'),

    treasureChestWrap: document.getElementById('nw-treasure-chest-wrap'),
    treasureChestButton: document.getElementById('nw-treasure-chest-button'),
    treasureChestTimer: document.getElementById('nw-treasure-chest-timer'),
    treasureChestStatus: document.getElementById('nw-treasure-chest-status'),
    heartChestWrap: document.getElementById('nw-heart-chest-wrap'),
    heartChestButton: document.getElementById('nw-heart-chest-button'),
    heartChestTimer: document.getElementById('nw-heart-chest-timer'),
    heartChestStatus: document.getElementById('nw-heart-chest-status'),
    treasureChestModal: document.getElementById('nw-treasure-chest-modal'),
    treasureChestClose: document.getElementById('nw-treasure-chest-close'),
    treasureChestVideo: document.getElementById('nw-treasure-chest-video'),
    treasureChestFade: document.getElementById('nw-treasure-chest-fade'),
    treasureChestReward: document.getElementById('nw-treasure-chest-reward'),
    treasureChestRewardIcon: document.getElementById('nw-treasure-chest-reward-icon'),
    treasureChestRewardText: document.getElementById('nw-treasure-chest-reward-text')
  };

  function forceUnlockPageAfterModalClose() {
    document.documentElement.classList.remove('nw-modal-open', 'modal-open', 'is-locked', 'no-scroll');
    document.body.classList.remove('nw-modal-open', 'modal-open', 'is-locked', 'no-scroll');

    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

    document.documentElement.style.position = '';
    document.body.style.position = '';

    if (els.backdrop) {
      els.backdrop.hidden = true;
      els.backdrop.classList.remove('is-open', 'is-active', 'open', 'show');
    }
  }

  function showAlert(message) {
    if (!els.alert) return;
    els.alert.textContent = message;
    els.alert.hidden = false;
  }

  function hideAlert() {
    if (!els.alert) return;
    els.alert.hidden = true;
    els.alert.textContent = '';
  }

  function requireComingSoonPassword() {
    const adminPassword = window.prompt('COMING SOON\n\nAdmin password');
    if (adminPassword === null) return false;

    if (String(adminPassword).trim() !== 'unlockwolf') {
      window.alert('Incorrect password.');
      return false;
    }

    return true;
  }

  function setDenSummaryOpen(isOpen) {
    if (!els.denSummary || !els.denSummaryToggle || !els.denSummaryBody) return;
    els.denSummary.classList.add('is-open');
    els.denSummaryBody.hidden = false;
    els.denSummaryToggle.setAttribute('aria-expanded', 'true');
  }

  function bindDenSummaryToggle() {
    if (els.denSummaryToggle && !els.denSummaryToggle.__nwBound) {
      els.denSummaryToggle.__nwBound = true;
    }

    const packHub = document.getElementById('nw-den-summary-body');
    const packHubToggle = document.getElementById('nw-pack-hub-toggle');

    function setPackHubCollapsed(isCollapsed) {
      if (!packHub) return;

      packHub.classList.toggle('is-collapsed', !!isCollapsed);
      packHub.setAttribute('data-pack-hub-collapsed', isCollapsed ? 'true' : 'false');

      if (packHubToggle) {
        packHubToggle.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
        packHubToggle.setAttribute('aria-label', isCollapsed ? 'Expand Pack Hub' : 'Collapse Pack Hub');
        packHubToggle.textContent = isCollapsed ? '▾' : '▴';
      }
    }

    if (packHub && packHubToggle && !packHubToggle.__nwBound) {
      packHubToggle.__nwBound = true;

      setPackHubCollapsed(false);

      packHubToggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const nextCollapsedState = !packHub.classList.contains('is-collapsed');
        setPackHubCollapsed(nextCollapsedState);
      });

      packHub.addEventListener('click', (event) => {
        if (!packHub.classList.contains('is-collapsed')) return;
        if (event.target.closest('button, a, input, select, textarea')) return;

        setPackHubCollapsed(false);
      });
    }

    const accountPackHubJump = document.getElementById('nw-account-pack-hub-jump');
    if (accountPackHubJump && !accountPackHubJump.__nwBound) {
      accountPackHubJump.__nwBound = true;

      accountPackHubJump.addEventListener('click', (event) => {
        event.preventDefault();

        setPackHubCollapsed(false);

        if (packHub) {
          packHub.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    const archiveBtn = document.getElementById('nw-open-archive-main');
    if (archiveBtn && !archiveBtn.__nwBound) {
      archiveBtn.__nwBound = true;
      archiveBtn.addEventListener('click', async (event) => {
        event.preventDefault();

        if (els.archiveShell) els.archiveShell.hidden = false;
        setArchiveExpanded(true);
        await ensureArchivePanelOpen({ force: true });

        if (els.archiveShell) {
          els.archiveShell.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    const secondaryRankingsBtn = document.getElementById('nw-open-pack-modal-secondary');
    if (secondaryRankingsBtn && !secondaryRankingsBtn.__nwBound) {
      secondaryRankingsBtn.__nwBound = true;
      secondaryRankingsBtn.addEventListener('click', (event) => {
        event.preventDefault();
        openModal('pack');
      });
    }
  }
    function closeGuestPreviewModal() {
    if (els.guestPreviewModal) els.guestPreviewModal.hidden = true;
    if (els.backdrop) els.backdrop.hidden = true;
  }

  function openGuestPreviewModal(kind) {
    const pupWolfUrl = 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/wolf_pup.nw.png?v=1755606028';
    const chestGraphicUrl = 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/treasure_chest_image.png?v=1774740698';
    const packCollectionGraphicUrl = 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/ChatGPT_Image_Feb_10_2026_03_07_59_PM.png?v=1770789672';
    const natureLogoUrl = 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/thenaturewolf_logo.png?v=1777213351';

    const map = {
      trivia: {
        title: 'Nature Games',
        copy: 'Wildlife challenges that turn learning into Pack XP, rewards, and progress inside the Den.',
        eyebrow: 'Nature games',
        headline: 'Test your wildlife knowledge and bring rewards back to your Pack.',
        body: 'Nature Games are where the Den becomes interactive. Play Trivia Trails, enter Pack Simulator runs, use hearts for select challenges, earn Pack XP, and unlock reward chances for your Pack Collection.',
        graphicUrl: natureLogoUrl,
        graphicAlt: 'The Nature Wolf logo graphic',
        stats: [
          { label: 'Modes', value: 'Trivia Trails + Simulator' },
          { label: 'Earn', value: 'Pack XP' },
          { label: 'Rewards', value: 'Swag claims' }
        ],
        features: [
          { title: 'Trivia Trails', text: 'Move biome by biome through timed wildlife questions and learn as the trail unfolds.' },
          { title: 'Pack Simulator', text: 'Send your Pack into timed wildlife runs where prey, pressure, and progress shape the outcome.' },
          { title: 'Pack XP progression', text: 'Earn Pack XP from games, rewards, referrals, and achievements to grow your place in the Den.' },
          { title: 'Wild learning', text: 'The games are built to make nature knowledge feel active, useful, and worth returning to.' }
        ],
        ctaTitle: 'Join the Pack to open Nature Games.',
        ctaCopy: 'Subscribers unlock the real game modes, reward flow, Pack XP progress, and future Den challenges.'
      },
      achievements: {
        title: 'Pack Progress',
        copy: 'Pack XP tracks your growth inside the Den and helps unlock wolves, rewards, and rankings.',
        eyebrow: 'Pack progress',
        headline: 'Your Pack XP shows how your place in the Den grows.',
        body: 'Pack XP is the main progress trail inside the Den. Read, play, collect, claim rewards, and invite new members to build your Pack rank and move closer to future wolf unlocks.',
        graphicUrl: chestGraphicUrl,
        graphicAlt: 'Nature Wolf treasure chest reward graphic',
        stats: [
          { label: 'Rank', value: 'Pack XP' },
          { label: 'Unlocks', value: 'Wolves + rewards' },
          { label: 'Milestones', value: 'Claimable XP' }
        ],
        features: [
          { title: 'Pack rank', text: 'Your Pack XP helps determine where you stand in the Pack.' },
          { title: 'Wolf unlocks', text: 'As your Pack XP grows, new wolves open along your collection path.' },
          { title: 'Achievements', text: 'Milestones give your Den activity a clear reason to build over time.' },
          { title: 'Reward claims', text: 'Completed progress can turn into Pack XP rewards you can claim inside the Den.' }
        ],
        ctaTitle: 'Join the Pack to start building Pack XP.',
        ctaCopy: 'Subscribers unlock the real progress path, achievement tracking, wolf unlocks, and reward claims inside the Den.'
      },
      store: {
        title: 'Pack Collection',
        copy: 'Your wolf identity, unlock path, styling room, and Pack progress in one place.',
        eyebrow: 'Pack identity',
        headline: 'Build the part of the Den that belongs to you.',
        body: 'Every member starts with a wolf. As your Pack XP grows, more wolves and swag claims open along your path. Your saved styling gives your Pack a visible identity inside the Den.',
        graphicUrl: packCollectionGraphicUrl,
        graphicAlt: 'Nature Wolf wolf swag graphic',
        stats: [
          { label: 'Start', value: 'Wolf Pup' },
          { label: 'Unlock', value: 'Wolves + swag' },
          { label: 'Style', value: 'Your Pack look' }
        ],
        features: [
          { title: 'Wolf unlock path', text: 'Pack XP opens new wolves over time, so your collection grows with your Den activity.' },
          { title: 'Wolf swag', text: 'Swag can unlock through Pack XP claims, games, achievements, and Pack rewards.' },
          { title: 'Saved identity', text: 'Each wolf keeps its own saved styling, giving your Pack profile a look that feels personal.' },
          { title: 'Pack showcase', text: 'Your wolves can appear across rankings, member previews, games, and future Pack experiences.' }
        ],
        ctaTitle: 'Join the Pack to claim your first wolf.',
        ctaCopy: 'Subscribers unlock the real collection, styling room, wolf path, swag claims, and member showcase inside the Den.'
      },
      wolves: null,
      treasure: {
        title: 'Treasure Chest',
        copy: 'A daily Pack XP reward for members returning to the Den.',
        eyebrow: 'Daily rewards',
        headline: 'Open the chest and keep your Pack moving.',
        body: 'The Treasure Chest gives members a simple way to build Pack XP between letters, games, and archive visits. It is a small daily return point that helps your Den progress keep growing.',
        graphicUrl: chestGraphicUrl,
        graphicAlt: 'Nature Wolf treasure chest reward graphic',
        stats: [
          { label: 'Claim', value: 'Daily' },
          { label: 'Reward', value: 'Pack XP' },
          { label: 'Builds', value: 'Progress' }
        ],
        features: [
          { title: 'Daily rhythm', text: 'Return to the Den and pick up progress without needing a long session.' },
          { title: 'Pack XP', text: 'Treasure rewards help build the progress that powers rank and future wolf unlocks.' },
          { title: 'Between letters', text: 'The Den gives members small ways to keep moving between Nature Wolf letters and new updates.' }
        ],
        ctaTitle: 'Log in to claim available rewards.',
        ctaCopy: 'Subscribers can open real reward chests and keep their Pack progress growing.'
      },
      heart: {
        title: 'Heart Chest',
        copy: 'A daily heart reward that helps power Den games and challenges.',
        eyebrow: 'Bonus rewards',
        headline: 'Collect hearts for the game trail ahead.',
        body: 'Hearts help members enter select games and challenges inside the Den. The Heart Chest gives your Pack another simple way to stay ready for wildlife games, challenge modes, and future Pack events.',
        graphicUrl: chestGraphicUrl,
        graphicAlt: 'Nature Wolf reward chest graphic',
        stats: [
          { label: 'Claim', value: 'Daily' },
          { label: 'Reward', value: 'Hearts' },
          { label: 'Powers', value: 'Games' }
        ],
        features: [
          { title: 'Game entries', text: 'Hearts can be used for select game modes and challenge systems.' },
          { title: 'Daily refill', text: 'The chest gives members a simple way to stay ready for the next challenge.' },
          { title: 'Future events', text: 'Hearts give the Den room for richer Pack events without overloading the experience.' }
        ],
        ctaTitle: 'Log in to check your available rewards.',
        ctaCopy: 'Subscribers can claim hearts, enter supported games, and keep their Pack ready for what comes next.'
      }
    };

    map.wolves = map.store;
    const config = map[kind] || map.trivia;

    if (els.guestPreviewTitle) els.guestPreviewTitle.textContent = config.title;
    if (els.guestPreviewCopy) els.guestPreviewCopy.textContent = config.copy;

    if (els.guestPreviewBody) {
      const statsHtml = (config.stats || []).map(stat => `
        <div class="nw-guest-preview-stat-card">
          <span>${stat.label}</span>
          <strong>${stat.value}</strong>
        </div>
      `).join('');

      const featuresHtml = (config.features || []).map(item => `
        <article class="nw-guest-preview-feature-card">
          <strong>${item.title}</strong>
          <p>${item.text}</p>
        </article>
      `).join('');

      els.guestPreviewBody.innerHTML = `
        <div class="nw-guest-preview-experience nw-guest-preview-experience--${kind || 'trivia'}">
          <section class="nw-guest-preview-hero-panel">
            <div class="nw-guest-preview-visual-panel">
              <div class="nw-guest-preview-hero-icon">
                <img src="${config.graphicUrl}" alt="${config.graphicAlt}">
              </div>
              <div class="nw-guest-preview-visual-lines" aria-hidden="true">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>

            <div class="nw-guest-preview-copy-block">
              <span class="nw-guest-preview-eyebrow">${config.eyebrow}</span>
              <h4>${config.headline}</h4>
              <p class="nw-guest-preview-lede">${config.body}</p>
            </div>
          </section>

          <div class="nw-guest-preview-stat-grid">
            ${statsHtml}
          </div>

          <div class="nw-guest-preview-feature-grid">
            ${featuresHtml}
          </div>

          <div class="nw-guest-preview-cta-strip">
            <strong>${config.ctaTitle}</strong>
            <span>${config.ctaCopy}</span>
          </div>
        </div>
      `;
    }

    if (els.backdrop) els.backdrop.hidden = false;
    if (els.guestPreviewModal) els.guestPreviewModal.hidden = false;
  }

  function focusAuthCard() {
    if (els.authCard && typeof els.authCard.scrollIntoView === 'function') {
      els.authCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setTimeout(() => {
      if (els.email) els.email.focus();
    }, 220);
  }

  function showRankUnlockPopup(payload) {
    if (!payload || !els.rankUnlockPopup) return;

    const rankName = payload.rank_name || payload.name || 'New Wolf';
    const requiredPackXp = Number(payload.required_pack_xp ?? 0);
    const currentPackXp = Number(payload.pack_xp ?? state.me?.pack_xp ?? 0);

    if (els.rankUnlockTitle) els.rankUnlockTitle.textContent = `${rankName} has joined your Pack`;
    if (els.rankUnlockMessage) {
      els.rankUnlockMessage.textContent = `You reached ${requiredPackXp.toLocaleString()} Pack XP. This wolf has been unlocked automatically and added safely to your Pack. Open the Styling Room to customize it.`;
    }
    if (els.rankUnlockImage) {
      els.rankUnlockImage.src = payload.image_url || payload.base_image_url || '';
      els.rankUnlockImage.alt = rankName;
    }
    if (els.rankUnlockRankName) els.rankUnlockRankName.textContent = rankName;
    if (els.rankUnlockStars) els.rankUnlockStars.textContent = `${currentPackXp.toLocaleString()} Pack XP`;

    els.rankUnlockPopup.classList.add('nw-rank-unlock-card--wolf-xp');

    if (els.backdrop) els.backdrop.hidden = false;
    els.rankUnlockPopup.hidden = false;

    requestAnimationFrame(() => {
      const card = els.rankUnlockPopup.querySelector('.nw-rank-unlock-card');
      if (card) {
        card.classList.remove('nw-wolf-unlock-pop');
        void card.offsetWidth;
        card.classList.add('nw-wolf-unlock-pop');
      }
    });

    if (typeof playSound === 'function' && typeof awardAudio !== 'undefined') {
      playSound(awardAudio);
    }
  }

  function hideRankUnlockPopup() {
    if (els.rankUnlockPopup) els.rankUnlockPopup.hidden = true;
    if (els.backdrop && (!els.awardPopup || els.awardPopup.hidden) && (!els.swagUnlockPopup || els.swagUnlockPopup.hidden)) els.backdrop.hidden = true;
  }

  function clearSwagUnlockTimers() {
    (state.swagUnlockTimers || []).forEach((timerId) => clearTimeout(timerId));
    state.swagUnlockTimers = [];
  }

  function queueSwagUnlocks(unlocks) {
    const incoming = Array.isArray(unlocks) ? unlocks : [];
    if (!incoming.length) return;

    const seenIds = new Set((state.queuedSwagUnlocks || []).map((item) => Number(item.item_id || item.id || 0)));

    incoming.forEach((item) => {
      const itemId = Number(item.item_id || item.id || 0);
      if (!itemId || seenIds.has(itemId)) return;
      seenIds.add(itemId);
      state.queuedSwagUnlocks.push(item);
    });
  }

  function normalizeSwagUnlockQueue(payload) {
  if (Array.isArray(payload)) return payload.filter(Boolean);
  if (payload && Array.isArray(payload.swag_unlocks)) return payload.swag_unlocks.filter(Boolean);
  return payload ? [payload] : [];
}

function showSwagUnlockRandomizer(payload, explicitIndex = null) {
  const queue = normalizeSwagUnlockQueue(payload);
  if (!queue.length || !els.swagUnlockPopup) return;

  const activeIndex = explicitIndex == null
    ? 0
    : Math.max(0, Math.min(queue.length - 1, Number(explicitIndex || 0)));

  const currentPayload = queue[activeIndex];

  clearSwagUnlockTimers();
  state.activeSwagUnlockQueue = queue;
  state.activeSwagUnlockIndex = activeIndex;
  state.currentSwagUnlock = currentPayload;

  const total = queue.length;
  const displayIndex = activeIndex + 1;

  const finalItem = {
    id: Number(currentPayload.item_id || currentPayload.id || 0),
    name: currentPayload.name || 'Wolf Swag',
    image_url: currentPayload.image_url || '',
    source_label: currentPayload.source_label || 'Pack progress'
  };

  const reelItems = Array.isArray(currentPayload.reel_items) && currentPayload.reel_items.length
    ? currentPayload.reel_items
    : [finalItem];

  const kicker = els.swagUnlockPopup.querySelector('.nw-swag-unlock-kicker');
  if (kicker) {
    kicker.textContent = total > 1 ? `${total} wolf swag items unlocked` : 'Wolf swag unlocked';
  }

  if (els.swagUnlockTitle) {
    els.swagUnlockTitle.textContent = total > 1
      ? `Mystery Swag Drop ${displayIndex} of ${total}`
      : 'Mystery Swag Drop';
  }

  if (els.swagUnlockMessage) {
    els.swagUnlockMessage.textContent = total > 1
      ? `The Den is revealing item ${displayIndex} of ${total}. Unlock each reward one at a time.`
      : 'The Den is cycling through your locked wolf swag. Whatever it lands on becomes available in the store.';
  }

  if (els.swagUnlockSource) els.swagUnlockSource.textContent = finalItem.source_label;
  if (els.swagUnlockName) els.swagUnlockName.textContent = 'Cycling locked swag...';

  if (els.swagUnlockImage) {
    els.swagUnlockImage.src = reelItems[0]?.image_url || finalItem.image_url || '';
    els.swagUnlockImage.alt = 'Locked wolf swag silhouette';
    els.swagUnlockImage.classList.add('is-silhouette');
    els.swagUnlockImage.classList.remove('is-revealed');
  }

  if (els.swagUnlockNext) {
    els.swagUnlockNext.hidden = true;
    els.swagUnlockNext.disabled = true;
    els.swagUnlockNext.textContent = 'Unlock Next';
  }

  if (els.swagUnlockOpenStore) els.swagUnlockOpenStore.hidden = true;
  if (els.swagUnlockContinue) els.swagUnlockContinue.hidden = true;
  if (els.swagUnlockClose) els.swagUnlockClose.hidden = total > 1;

  if (els.backdrop) els.backdrop.hidden = false;
  els.swagUnlockPopup.hidden = false;
  els.swagUnlockPopup.classList.add('is-frontmost');
  document.documentElement.classList.add('nw-modal-open');
  document.body.classList.add('nw-modal-open');

  if (typeof playSound === 'function' && typeof awardAudio !== 'undefined') {
    playSound(awardAudio);
  }

  let tick = 0;
  const maxTicks = 30;

  const cycle = () => {
    const reelItem = reelItems[tick % reelItems.length] || finalItem;

    if (els.swagUnlockImage) {
      els.swagUnlockImage.src = reelItem.image_url || finalItem.image_url || '';
      els.swagUnlockImage.alt = 'Locked wolf swag silhouette';
      els.swagUnlockImage.classList.add('is-silhouette');
      els.swagUnlockImage.classList.remove('is-revealed');
    }

    if (els.swagUnlockName) {
      els.swagUnlockName.textContent = 'Locked swag...';
    }

    tick += 1;

    if (tick < maxTicks) {
      const timerId = setTimeout(cycle, Math.min(120, 42 + tick * 3));
      state.swagUnlockTimers.push(timerId);
      return;
    }

    const revealTimer = setTimeout(() => {
      if (els.swagUnlockImage) {
        els.swagUnlockImage.src = finalItem.image_url || '';
        els.swagUnlockImage.alt = finalItem.name;
        els.swagUnlockImage.classList.remove('is-silhouette');
        els.swagUnlockImage.classList.add('is-revealed');
      }

      if (els.swagUnlockTitle) {
        els.swagUnlockTitle.textContent = total > 1
          ? `Swag ${displayIndex} of ${total} Unlocked`
          : 'New Swag Unlocked';
      }

      if (els.swagUnlockMessage) {
        if (total > 1 && displayIndex < total) {
          els.swagUnlockMessage.textContent = `${finalItem.name} is now yours. It has been added to your Pack Collection. Unlock the next reward to continue.`;
        } else if (total > 1) {
          els.swagUnlockMessage.textContent = `All ${total} wolf swag items are now yours. They have been added to your Pack Collection.`;
        } else {
          els.swagUnlockMessage.textContent = 'This item is now yours. It has been added to your Pack Collection and can be used in the styling room.';
        }
      }

      if (els.swagUnlockName) els.swagUnlockName.textContent = finalItem.name;
      if (els.swagUnlockSource) els.swagUnlockSource.textContent = finalItem.source_label;

      const hasNextReward = displayIndex < total;

      if (els.swagUnlockNext) {
        els.swagUnlockNext.hidden = !hasNextReward;
        els.swagUnlockNext.disabled = !hasNextReward;
        els.swagUnlockNext.textContent = 'Unlock Next';
      }

      if (els.swagUnlockOpenStore) els.swagUnlockOpenStore.hidden = hasNextReward;
      if (els.swagUnlockContinue) els.swagUnlockContinue.hidden = hasNextReward;
      if (els.swagUnlockClose) els.swagUnlockClose.hidden = hasNextReward;

      if (typeof playSound === 'function' && typeof packXpCollectAudio !== 'undefined') {
        playSound(packXpCollectAudio);
      }
    }, 220);

    state.swagUnlockTimers.push(revealTimer);
  };

  cycle();
}

  function hideSwagUnlockPopup() {
    clearSwagUnlockTimers();
    state.currentSwagUnlock = null;
    state.activeSwagUnlockQueue = [];
    state.activeSwagUnlockIndex = 0;

    if (els.swagUnlockNext) {
      els.swagUnlockNext.hidden = true;
      els.swagUnlockNext.disabled = true;
    }

    if (els.swagUnlockOpenStore) els.swagUnlockOpenStore.hidden = false;
    if (els.swagUnlockContinue) els.swagUnlockContinue.hidden = false;
    if (els.swagUnlockClose) els.swagUnlockClose.hidden = false;

    if (els.swagUnlockPopup) {
      els.swagUnlockPopup.hidden = true;
      els.swagUnlockPopup.classList.remove('is-frontmost');
    }

    const anyOtherModalOpen =
      (els.rankUnlockPopup && !els.rankUnlockPopup.hidden) ||
      (els.awardPopup && !els.awardPopup.hidden) ||
      (els.customizeModal && !els.customizeModal.hidden) ||
      (els.goalsModal && !els.goalsModal.hidden) ||
      (els.trailsModal && !els.trailsModal.hidden) ||
      (els.simModal && !els.simModal.hidden) ||
      (els.packModal && !els.packModal.hidden) ||
      (els.packMemberModal && !els.packMemberModal.hidden);

    if (els.backdrop && !anyOtherModalOpen) els.backdrop.hidden = true;

    setTimeout(() => maybeShowQueuedRankUnlock(), 80);
  }

  function queueWolfUnlocks(unlocks) {
    const incoming = Array.isArray(unlocks) ? unlocks : [];
    if (!incoming.length) return;

    const seenKeys = new Set((state.queuedWolfUnlocks || []).map((wolf) => String(wolf.rank_key || wolf.key || '')));
    incoming.forEach((wolf) => {
      const key = String(wolf.rank_key || wolf.key || '');
      if (!key || seenKeys.has(key)) return;
      seenKeys.add(key);
      state.queuedWolfUnlocks.push(wolf);
    });
  }

      function maybeShowQueuedRankUnlock() {
    if (els.swagUnlockPopup && !els.swagUnlockPopup.hidden) return;
    if (els.rankUnlockPopup && !els.rankUnlockPopup.hidden) return;

    const busyModalOpen =
      (els.customizeModal && !els.customizeModal.hidden) ||
      (els.goalsModal && !els.goalsModal.hidden) ||
      (els.trailsModal && !els.trailsModal.hidden) ||
      (els.simModal && !els.simModal.hidden) ||
      (els.packModal && !els.packModal.hidden) ||
      (els.packMemberModal && !els.packMemberModal.hidden);

    if (busyModalOpen) return;

    if (state.queuedSwagUnlocks && state.queuedSwagUnlocks.length) {
      const payload = state.queuedSwagUnlocks.shift();
      showSwagUnlockRandomizer(payload);
      return;
    }

    if (state.queuedWolfUnlocks && state.queuedWolfUnlocks.length) {
      const payload = state.queuedWolfUnlocks.shift();
      showRankUnlockPopup(payload);
      return;
    }

    if (!state.queuedRankUnlock) return;

    const payload = state.queuedRankUnlock;
    state.queuedRankUnlock = null;
    showRankUnlockPopup(payload);
  }


  function playSound(audioEl) {
    if (!audioEl) return;
    try {
      audioEl.currentTime = 0;
      const playPromise = audioEl.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    } catch (err) {}
  }


  async function api(path, method='GET', body=null) {
    const res = await fetch(API_BASE + path, {
      method,
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : null
    });
    const text = await res.text();
    let data = {};
    try { data = text ? JSON.parse(text) : {}; } catch (e) {}
    if (!res.ok) throw new Error(data.error || data.message || 'Request failed');
    return data;
  }

  const NW_TRACKING_ANON_KEY = 'nw_tracking_anonymous_id';
  const NW_TRACKING_SESSION_KEY = 'nw_tracking_session_id';
  const NW_LAST_DEN_VISIT_KEY = 'nw_last_den_member_visit_at';

  function createTrackingId(prefix = 'nw') {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return `${prefix}_${window.crypto.randomUUID()}`;
    }

    return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2)}`;
  }

  function getLocalTrackingId() {
    try {
      let value = localStorage.getItem(NW_TRACKING_ANON_KEY);
      if (!value) {
        value = createTrackingId('anon');
        localStorage.setItem(NW_TRACKING_ANON_KEY, value);
      }
      return value;
    } catch (err) {
      return createTrackingId('anon');
    }
  }

  function getSessionTrackingId() {
    try {
      let value = sessionStorage.getItem(NW_TRACKING_SESSION_KEY);
      if (!value) {
        value = createTrackingId('session');
        sessionStorage.setItem(NW_TRACKING_SESSION_KEY, value);
      }
      return value;
    } catch (err) {
      return createTrackingId('session');
    }
  }

  function getTrackingUrlParams() {
    const params = new URLSearchParams(window.location.search || '');

    return {
      utm_source: String(params.get('utm_source') || params.get('source') || '').trim(),
      utm_medium: String(params.get('utm_medium') || '').trim(),
      utm_campaign: String(params.get('utm_campaign') || '').trim(),
      utm_content: String(params.get('utm_content') || '').trim()
    };
  }

  async function trackEvent(eventName, metadata = {}) {
    const cleanEventName = String(eventName || '').trim();
    if (!cleanEventName) return;

    const utm = getTrackingUrlParams();

    try {
      await api('/api/track', 'POST', {
        event_name: cleanEventName,
        subscriber_id: Number(state.me?.id || state.me?.subscriber_id || 0) || null,
        anonymous_id: getLocalTrackingId(),
        session_id: getSessionTrackingId(),
        url: window.location.href,
        path: window.location.pathname,
        referrer: document.referrer || '',
        utm_source: utm.utm_source,
        utm_medium: utm.utm_medium,
        utm_campaign: utm.utm_campaign,
        utm_content: utm.utm_content,
        metadata
      });
    } catch (err) {}
  }

  function trackFirstDenAction(action, metadata = {}) {
    const cleanAction = String(action || '').trim();
    if (!cleanAction) return;
    if (state.firstDenActionTracked) return;
    if (!state.me) return;

    state.firstDenActionTracked = true;

    trackEvent('den_first_action', {
      action: cleanAction,
      ...metadata
    });
  }

  function trackRepeatDenVisit() {
    if (!state.me) return;

    try {
      const now = Date.now();
      const lastRaw = localStorage.getItem(NW_LAST_DEN_VISIT_KEY);
      const lastVisit = Number(lastRaw || 0);

      localStorage.setItem(NW_LAST_DEN_VISIT_KEY, String(now));

      if (!Number.isFinite(lastVisit) || lastVisit <= 0) return;

      const hoursSinceLastVisit = Math.round((now - lastVisit) / 36e5);
      if (hoursSinceLastVisit < 6) return;

      trackEvent('repeat_den_visit', {
        source: 'refresh_data',
        hours_since_last_visit: hoursSinceLastVisit
      });
    } catch (err) {}
  }

  const REFERRAL_CONTEXT_KEY = 'nw_pending_referral_context';

  function captureReferralContextFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search || '');
      const referralCode = String(params.get('nw_ref') || params.get('nw_referral') || '').trim();
      const clickToken = String(params.get('nw_click') || params.get('nw_ref_click') || '').trim();
      const newsletterSlug = String(params.get('nw_letter') || params.get('newsletter_slug') || '').trim();

      if (!referralCode && !clickToken && !newsletterSlug) return;

      const context = {
        referral_code: referralCode,
        click_token: clickToken,
        newsletter_slug: newsletterSlug,
        source: 'shopify_url_param',
        captured_at: new Date().toISOString()
      };

      localStorage.setItem(REFERRAL_CONTEXT_KEY, JSON.stringify(context));
    } catch (err) {}
  }

  function getReferralContext() {
    try {
      const raw = localStorage.getItem(REFERRAL_CONTEXT_KEY);
      if (!raw) return {};
      const context = JSON.parse(raw);
      if (!context || typeof context !== 'object') return {};
      return context;
    } catch (err) {
      return {};
    }
  }

  async function capturePendingReferralForEmail(email, source = 'shopify_newsletter_form') {
    const cleanEmail = String(email || '').trim();
    if (!cleanEmail) return;

    const referralContext = {
      ...getReferralContext(),
      source
    };

    try {
      await api('/api/referrals/pending', 'POST', {
        email: cleanEmail,
        referral_context: referralContext
      });
    } catch (err) {}
  }

  function getPackReferralUrl() {
    const referralCode = String(state.me?.referral_code || '').trim();
    if (!referralCode) return '';

    const denUrl = String(window.__NW_PUBLIC_DEN_URL__ || 'https://thenaturewolf.com/pages/den').trim();
    const url = new URL(denUrl, window.location.origin);
    url.searchParams.set('nw_ref', referralCode);

    return url.toString();
  }

  function getSuccessfulReferralCount() {
    const challenges = Array.isArray(state.challengesList) ? state.challengesList : [];

    return challenges.filter((challenge) => {
      const id = String(challenge.id || '');
      const title = String(challenge.title || '');
      const rewardKind = String(challenge.metadata?.reward_kind || '');

      return (
        challenge.category === 'referral' &&
        (
          id.startsWith('newsletter_referral_') ||
          title.startsWith('Referral:') ||
          title.startsWith('Pack Invite:') ||
          rewardKind === 'newsletter_referral'
        )
      );
    }).length;
  }

  function renderPackReferralCard() {
    const referralUrl = getPackReferralUrl();

    if (!els.packReferralCard) return;

    if (!referralUrl) {
      els.packReferralCard.hidden = true;
      return;
    }

    els.packReferralCard.hidden = false;

    if (els.packReferralUrl) {
      els.packReferralUrl.value = referralUrl;
    }

    if (els.packReferralStatus) {
      const referralCount = getSuccessfulReferralCount();

      els.packReferralStatus.textContent = referralCount > 0
        ? `${referralCount} successful referral${referralCount === 1 ? '' : 's'} tracked so far.`
        : 'No successful referrals yet. Share your Pack invite link to start growing the Pack.';
    }
  }

  function buildReferralStarterCardHtml() {
    const referralUrl = getPackReferralUrl();

    if (!referralUrl) return '';

    return `
      <section class="nw-achievements-referral-starter" aria-label="Pack referral invite">
        <div class="nw-achievements-referral-starter__copy">
          <span>Pack Invite</span>
          <strong>Bring another reader into the Den.</strong>
          <p>Share your Pack invite link. When someone joins through it and creates their Pack login, your +25 Pack XP referral reward will appear here in Achievements.</p>
        </div>

        <div class="nw-achievements-referral-starter__link-row">
          <input class="nw-achievements-referral-starter__input" type="text" readonly value="${escapeHtml(referralUrl)}">
          <button class="nw-achievements-referral-starter__copy-btn" type="button" data-nw-copy-referral>Copy link</button>
        </div>
      </section>
    `;
  }

  async function copyPackReferralUrl(button = null) {
    const referralUrl = getPackReferralUrl();

    if (!referralUrl) {
      showAlert('Your Pack invite link is still loading.');
      return;
    }

    try {
      await navigator.clipboard.writeText(referralUrl);
    } catch (err) {
      const input = button
        ? button.closest('.nw-pack-hub-referral-card, .nw-achievements-referral-starter')?.querySelector('input')
        : els.packReferralUrl;

      if (input) {
        input.focus();
        input.select();
      }

      showAlert('Copying was blocked by this browser. Select the link and copy it manually.');
      return;
    }

    if (els.packReferralStatus) {
      els.packReferralStatus.textContent = 'Pack invite link copied. Referral rewards appear after a new member creates their Pack login.';
    }

    if (button) {
      const originalText = button.textContent;
      button.textContent = 'Copied';
      window.setTimeout(() => {
        button.textContent = originalText || 'Copy';
      }, 1400);
    }
  }

  function isPackPlusMember() {
    return !!state.me?.is_pack_plus;
  }

  function getPackPlusEmailForCheckout() {
    const direct = document.getElementById('nw-pack-plus-email');
    const loginEmail = document.getElementById('nw-email');
    const shopifyEmail = document.getElementById('nw-shopify-newsletter-email');

    return String(
      state.me?.email ||
      direct?.value ||
      loginEmail?.value ||
      shopifyEmail?.value ||
      ''
    ).trim();
  }

  function formatPackPlusPlan(plan = '') {
    const clean = String(plan || '').trim().toLowerCase();
    if (clean === 'yearly' || clean === 'annual') return 'Yearly';
    if (clean === 'monthly') return 'Monthly';
    return 'Active';
  }

  function shouldShowArchivePackPlusOffer() {
    const loggedIn = !!state.me?.email;
    const active = isPackPlusMember();
    const activeArchiveType = String(state.archiveTypeFilter || 'all').trim().toLowerCase();

    return loggedIn && !active && activeArchiveType === 'deeper_trail';
  }

  function renderArchivePackPlusOffer() {
    const offer = document.getElementById('nw-archive-pack-plus-offer');
    if (!offer) return;

    offer.hidden = !shouldShowArchivePackPlusOffer();
  }

  function renderPackPlusSurface() {
    const loggedIn = !!state.me?.email;
    const active = isPackPlusMember();
    const plan = formatPackPlusPlan(state.me?.pack_plus_plan || '');
    const end = String(state.me?.pack_plus_current_period_end || '').trim();

    if (els.denRoot) {
      els.denRoot.classList.toggle('nw-pack-den--pack-plus', active);
    }

    renderArchivePackPlusOffer();

    if (!loggedIn) return;

    document.querySelectorAll('[data-pack-plus-status]').forEach((el) => {
      if (active) {
        const renews = end ? ` Current period ends ${formatArchiveDate(end)}.` : '';
        el.textContent = `Pack+ active: ${plan}.${renews}`;
      } else {
        el.textContent = 'Pack+ is available for this Pack account.';
      }
    });

    document.querySelectorAll('[data-pack-plus-checkout]').forEach((btn) => {
      btn.hidden = active;
    });

    document.querySelectorAll('[data-pack-plus-portal]').forEach((btn) => {
      btn.hidden = !active || !state.me?.has_pack_plus_billing;
    });
  }

  async function openPackPlusCheckout(plan) {
    const safePlan = String(plan || 'monthly').trim().toLowerCase();
    const email = getPackPlusEmailForCheckout();

    if (!state.me?.email) {
      showAlert('Log in with your Pack email first.');
      return;
    }

    try {
      const res = await api('/api/pack-plus/checkout', 'POST', {
        plan: safePlan,
        email
      });

      if (res?.url) {
        window.location.href = res.url;
        return;
      }

      showAlert('Pack+ checkout did not return a payment link.');
    } catch (err) {
      showAlert(err.message || 'Unable to start Pack+ checkout.');
    }
  }

  async function openPackPlusPortal() {
    try {
      const res = await api('/api/pack-plus/portal', 'POST', {});

      if (res?.url) {
        window.location.href = res.url;
        return;
      }

      showAlert('Pack+ billing portal did not return a link.');
    } catch (err) {
      showAlert(err.message || 'Log in with your Pack email to manage Pack+.');
    }
  }

  function attachPackPlusButtons() {
    if (document.documentElement.dataset.nwPackPlusButtonsBound === '1') return;
    document.documentElement.dataset.nwPackPlusButtonsBound = '1';

    document.addEventListener('click', async (event) => {
      const checkoutBtn = event.target.closest('[data-pack-plus-checkout]');
      if (checkoutBtn) {
        event.preventDefault();
        await openPackPlusCheckout(checkoutBtn.dataset.packPlusCheckout || 'monthly');
        return;
      }

      const portalBtn = event.target.closest('[data-pack-plus-portal]');
      if (portalBtn) {
        event.preventDefault();
        await openPackPlusPortal();
      }
    });
  }

  function attachNewsletterReferralCapture() {
    document.querySelectorAll('form.nw-shopify-newsletter-form').forEach((form) => {
      if (form.dataset.nwReferralCaptureBound === '1') return;
      form.dataset.nwReferralCaptureBound = '1';

      form.addEventListener('submit', async (event) => {
        if (form.dataset.nwReferralSubmitReady === '1') return;

        const emailInput = form.querySelector('input[name="contact[email]"], input[type="email"]');
        const email = emailInput ? String(emailInput.value || '').trim() : '';

        if (!email) return;

        event.preventDefault();

        await capturePendingReferralForEmail(email, 'shopify_newsletter_form_submit');

        form.dataset.nwReferralSubmitReady = '1';

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    });
  }

  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function stripHtml(value) {
    return String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function truncateText(value, max = 180) {
    const text = String(value || '').trim();
    if (!text) return '';
    if (text.length <= max) return text;
    return text.slice(0, max).trimEnd() + '...';
  }

  function formatArchiveDate(value) {
    const clean = String(value || '').trim();
    if (!clean) return '';

    const dateOnlyMatch = clean.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dateOnlyMatch) {
      const [, year, month, day] = dateOnlyMatch;
      const date = new Date(Number(year), Number(month) - 1, Number(day), 12, 0, 0);
      return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }

    const date = new Date(clean);
    if (Number.isNaN(date.getTime())) return '';

    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
function normalizeArchiveLetterType(value) {
  const clean = String(value || '').trim().toLowerCase();
  if (clean === 'deeper_trail') return 'deeper_trail';
  return 'monthly_letter';
}

function normalizeArchiveSectionType(value) {
  const clean = String(value || '').trim().toLowerCase().replace(/_/g, '-');

  if (clean === 'dispatch' || clean === 'pack-dispatch') return 'dispatch';
  if (clean === 'wisdom' || clean === 'nature-wolf-wisdom') return 'wisdom';
  if (clean === 'phenomenon' || clean === 'phenomena' || clean === 'feature' || clean === 'wild-phenomenon') return 'phenomenon';
  if (clean === 'den' || clean === 'den-updates') return 'den';
  if (clean === 'full-letter' || clean === 'full_letter' || clean === 'issue') return 'full_letter';

  return 'full_letter';
}

function getArchiveSectionLabel(value) {
  const type = normalizeArchiveSectionType(value);

  if (type === 'dispatch') return 'Dispatch';
  if (type === 'wisdom') return 'Wisdom';
  if (type === 'phenomenon') return 'Phenomenon';
  if (type === 'den') return 'Den Updates';

  return 'Full Letter';
}

function getArchiveLetterTypeLabel(value) {
  const type = normalizeArchiveLetterType(value);
  if (type === 'deeper_trail') return 'Deeper Trail';
  return 'Nature Letter';
}

function normalizeArchiveAccessTier(value) {
  const clean = String(value || '').trim().toLowerCase();
  if (clean === 'pack_plus') return 'pack_plus';
  return 'subscriber';
}

function getArchiveAccessLabel(post) {
  const type = normalizeArchiveLetterType(post?.letter_type);
  const accessTier = normalizeArchiveAccessTier(post?.access_tier);

  if (accessTier === 'pack_plus') return 'Pack+';
  if (accessTier === 'public' && type === 'deeper_trail') return 'Free Pack+ intro';
  if (type === 'deeper_trail') return 'Free Pack+ intro';
  return 'Pack Archive';
}

function getArchiveCtaLabel(post, isRead) {
  const type = normalizeArchiveLetterType(post?.letter_type);
  const sectionType = normalizeArchiveSectionType(post?.section_type);

  if (type === 'deeper_trail') {
    return isRead ? 'Read again' : 'Read';
  }

  if (sectionType === 'dispatch') return 'Open Dispatch';
  if (sectionType === 'wisdom') return 'Open Wisdom';
  if (sectionType === 'phenomenon') return 'Open Phenomenon';
  if (sectionType === 'den') return 'Open Den Updates';

  return isRead ? 'Read letter again' : 'Open letter';
}

function archivePostHasTrivia(post) {
  const letterType = normalizeArchiveLetterType(post?.letter_type);
  const sectionType = normalizeArchiveSectionType(post?.section_type);

  return (
    letterType === 'monthly_letter' &&
    sectionType === 'full_letter' &&
    Number(post?.newsletter_trivia_enabled || 0) === 1 &&
    String(post?.newsletter_trivia_question || '').trim()
  );
}

function archivePostTriviaAnswered(post) {
  return archivePostHasTrivia(post) && (
    post?.newsletter_trivia_answered === true ||
    Number(post?.newsletter_trivia_answered || 0) === 1
  );
}

function getArchiveTriviaPillHtml(post) {
  if (!archivePostHasTrivia(post)) return '';

  if (archivePostTriviaAnswered(post)) {
    return `<div class="nw-archive-item__pill nw-archive-item__pill--trivia is-complete">Trivia: <span class="nw-archive-item__pill-check" aria-hidden="true">✓</span></div>`;
  }

  return `<div class="nw-archive-item__pill nw-archive-item__pill--trivia">Trivia!</div>`;
}
  function getReadNewsletterSlugSet() {
    const slugs = Array.isArray(state.me?.newsletter_read_slugs)
      ? state.me.newsletter_read_slugs
      : [];
    return new Set(
      slugs
        .map((slug) => String(slug || '').trim().toLowerCase())
        .filter(Boolean)
    );
  }

  function markNewsletterReadLocal(slug) {
    const cleanSlug = String(slug || '').trim().toLowerCase();
    if (!cleanSlug || !state.me) return;

    const existing = Array.isArray(state.me.newsletter_read_slugs)
      ? state.me.newsletter_read_slugs
      : [];

    if (existing.includes(cleanSlug)) return;

    state.me.newsletter_read_slugs = [...existing, cleanSlug];
    state.me.newsletters_read_count = Number(state.me.newsletters_read_count || 0) + 1;

    renderArchiveList();
  }

  async function loadArchivePosts({ force = false } = {}) {
    if (els.archiveStatus) els.archiveStatus.textContent = 'Loading the living archive...';

    const cacheBuster = force ? `?t=${Date.now()}` : '';
    const data = await api(`/api/newsletters${cacheBuster}`);
    const posts = Array.isArray(data.articles) ? data.articles : [];

    state.archivePosts = posts.map(post => {
      const title = post.title || 'Untitled letter';
      const excerpt = truncateText(
        stripHtml(post.excerpt || post.content || post.summary || ''),
        210
      );

      const letterType = normalizeArchiveLetterType(post.letter_type);
      const sectionType = normalizeArchiveSectionType(post.section_type);
      const accessTier = normalizeArchiveAccessTier(post.access_tier);
      const sectionLabel = post.section_label || getArchiveSectionLabel(sectionType);
      const letterTypeLabel = post.letter_type_label || post.letter_badge || getArchiveLetterTypeLabel(letterType);

      return {
        slug: String(post.slug || '').trim().toLowerCase(),
        parent_slug: String(post.parent_slug || post.slug || '').trim().toLowerCase(),
        title,
        url: post.url || '#',
        excerpt,
        published_at: post.published_at || post.created_at || post.issue_date || '',
        published_label: formatArchiveDate(post.published_at || post.created_at || post.issue_date || ''),
        preview_image_url: post.preview_image_url || '',
        letter_type: letterType,
        section_type: sectionType,
        section_label: sectionLabel,
        letter_type_label: letterTypeLabel,
        access_tier: accessTier,
        access_label: post.access_label || getArchiveAccessLabel({ letter_type: letterType, access_tier: accessTier }),
        newsletter_trivia_enabled: Number(post.newsletter_trivia_enabled || 0),
        newsletter_trivia_question: post.newsletter_trivia_question || '',
        newsletter_trivia_answered: Number(post.newsletter_trivia_answered || 0),
        search_blob: `${title} ${excerpt} ${sectionLabel} ${letterTypeLabel} ${accessTier} ${stripHtml(post.content || post.content_text || '')}`.toLowerCase()
      };
    });

    state.archiveLoaded = true;

    const currentSearch = els.archiveSearch ? els.archiveSearch.value : '';
    filterArchivePosts(currentSearch);
  }

  function renderArchiveList() {
    const posts = state.archiveFiltered || [];
    const pageSize = state.archivePageSize || 5;
    const totalPages = Math.max(1, Math.ceil(posts.length / pageSize));
    state.archivePage = clamp(state.archivePage, 1, totalPages);

    const start = (state.archivePage - 1) * pageSize;
    const visible = posts.slice(start, start + pageSize);
    const readSlugs = getReadNewsletterSlugSet();

    if (els.archivePageCopy) {
      els.archivePageCopy.textContent = `Page ${state.archivePage} of ${totalPages}`;
    }

    if (els.archivePrev) {
      els.archivePrev.disabled = state.archivePage <= 1;
    }

    if (els.archiveNext) {
      els.archiveNext.disabled = state.archivePage >= totalPages;
    }

    const activeArchiveType = String(state.archiveTypeFilter || 'all').trim().toLowerCase();
    const archiveResultName = activeArchiveType === 'all'
      ? 'monthly letter'
      : activeArchiveType === 'deeper_trail'
        ? 'Deeper Trail letter'
        : 'section';

    renderArchivePackPlusOffer();

    if (!posts.length) {
      if (els.archiveStatus) els.archiveStatus.textContent = `No ${archiveResultName}s matched that search.`;
      if (els.archiveList) els.archiveList.innerHTML = '';
      return;
    }

    if (els.archiveStatus) {
      els.archiveStatus.textContent = `${posts.length} ${archiveResultName}${posts.length === 1 ? '' : 's'} found`;
    }

    if (!els.archiveList) return;

    els.archiveList.innerHTML = visible.map(post => {
      const slug = String(post.slug || '').trim().toLowerCase();
      const parentSlug = String(post.parent_slug || slug).trim().toLowerCase();
      const isRead = parentSlug && readSlugs.has(parentSlug);
      const letterType = normalizeArchiveLetterType(post.letter_type);
const sectionType = normalizeArchiveSectionType(post.section_type);
const accessTier = normalizeArchiveAccessTier(post.access_tier);
const isFullMonthlyLetter = letterType === 'monthly_letter' && sectionType === 'full_letter';
const isSectionCard = letterType === 'monthly_letter' && sectionType !== 'full_letter';
const typeLabel = post.section_label || post.letter_type_label || getArchiveSectionLabel(sectionType);
const ctaLabel = getArchiveCtaLabel(post, isRead);
const isPackPlus = accessTier === 'pack_plus';
const triviaPillHtml = isFullMonthlyLetter ? getArchiveTriviaPillHtml(post) : '';
const archiveMetaLabelHtml = isSectionCard ? '' : `<span class="nw-archive-item__label">${escapeHtml(typeLabel)}</span>`;
const archivePillWrapHtml = isSectionCard || !triviaPillHtml ? '' : `<div class="nw-archive-item__pill-wrap">${triviaPillHtml}</div>`;

      return `
      <article class="nw-archive-item nw-archive-item--${escapeHtml(letterType)} nw-archive-item--section-${escapeHtml(sectionType)}${isPackPlus ? ' is-pack-plus' : ''}" data-newsletter-slug="${escapeHtml(parentSlug)}" data-section-slug="${escapeHtml(slug)}" data-letter-type="${escapeHtml(letterType)}" data-section-type="${escapeHtml(sectionType)}" data-access-tier="${escapeHtml(accessTier)}">
        <div class="nw-archive-item__media-wrap">
          <a
            class="nw-archive-item__media-link"
            href="${escapeHtml(post.url)}"
            data-newsletter-slug="${escapeHtml(slug)}"
            aria-label="Open ${escapeHtml(post.title)}"
          >
            ${
              post.preview_image_url
                ? `<img class="nw-archive-item__media" src="${escapeHtml(post.preview_image_url)}" alt="${escapeHtml(post.title)} preview image" loading="lazy">`
                : `<div class="nw-archive-item__media nw-archive-item__media--fallback" aria-hidden="true"></div>`
            }
          </a>
        </div>

        <div class="nw-archive-item__content">
          <div class="nw-archive-item__topline">
            <div class="nw-archive-item__meta">
              ${archiveMetaLabelHtml}
              ${post.published_label ? `<time class="nw-archive-item__date" datetime="${escapeHtml(post.published_at || '')}">${escapeHtml(post.published_label)}</time>` : ''}
            </div>
            ${archivePillWrapHtml}
          </div>

          <h4 class="nw-archive-item__title">
            <a href="${escapeHtml(post.url)}" data-newsletter-slug="${escapeHtml(slug)}">${escapeHtml(post.title)}</a>
          </h4>

          <p class="nw-archive-item__excerpt">${escapeHtml(post.excerpt || 'Open this letter to read the full issue.')}</p>

          <div class="nw-archive-item__actions">
            <a
              class="nw-btn nw-btn--primary nw-archive-item__cta"
              href="${escapeHtml(post.url)}"
              data-newsletter-slug="${escapeHtml(slug)}"
            >
              ${escapeHtml(ctaLabel)}
            </a>

            <button
              class="nw-btn nw-btn--ghost nw-archive-item__share"
              type="button"
              data-nw-open-share
              data-newsletter-slug="${escapeHtml(parentSlug || slug)}"
              data-newsletter-title="${escapeHtml(post.title)}"
            >
              Share
            </button>
          </div>
        </div>
      </article>
    `;
    }).join('');
  }

  function filterArchivePosts(keyword) {
  const term = String(keyword || '').trim().toLowerCase();
  const activeType = String(state.archiveTypeFilter || 'all').trim().toLowerCase();

  state.archiveFiltered = (state.archivePosts || []).filter(post => {
    const letterType = normalizeArchiveLetterType(post.letter_type);
    const sectionType = normalizeArchiveSectionType(post.section_type);
    const isFullMonthlyLetter = letterType === 'monthly_letter' && sectionType === 'full_letter';

    let matchesType = false;

    if (activeType === 'all') {
      matchesType = isFullMonthlyLetter;
    } else if (activeType === 'full_letter') {
      matchesType = isFullMonthlyLetter;
    } else if (activeType === 'deeper_trail') {
      matchesType = letterType === 'deeper_trail' && sectionType === 'full_letter';
    } else {
      matchesType = letterType === 'monthly_letter' && sectionType === activeType;
    }

    const matchesSearch = !term || String(post.search_blob || '').includes(term);
    return matchesType && matchesSearch;
  });

  state.archivePage = 1;
  renderArchiveList();
}

  if (els.archiveList) {
    els.archiveList.addEventListener('click', (event) => {
      const shareBtn = event.target.closest('[data-nw-open-share]');

      if (shareBtn) {
        event.preventDefault();
        event.stopPropagation();

        openArchiveShareModal({
          slug: shareBtn.dataset.newsletterSlug || '',
          title: shareBtn.dataset.newsletterTitle || ''
        });

        return;
      }

      const letterLink = event.target.closest('[data-newsletter-slug]');
      if (letterLink && letterLink.href) {
        trackEvent('letter_opened', {
          source: 'archive_list',
          newsletter_slug: letterLink.dataset.newsletterSlug || '',
          letter_url: letterLink.href || ''
        });
      }

      // Read status is now server-verified after the member spends visible time in the letter
      // and reaches the required scroll depth. Do not mark a letter as read from a simple click.
    });
  }

  function setShareStatus(message, isSuccess = false) {
    if (!els.shareStatus) return;
    els.shareStatus.textContent = message || '';
    els.shareStatus.classList.toggle('is-success', !!isSuccess);
  }

  function getArchiveSharePlatformUrl(channel, url, title) {
    const encodedUrl = encodeURIComponent(url || '');
    const encodedTitle = encodeURIComponent(title || 'Nature Wolf letter');
    const text = encodeURIComponent(`${title || 'Nature Wolf letter'} - ${url || ''}`);

    if (channel === 'email') return `mailto:?subject=${encodedTitle}&body=${text}`;
    if (channel === 'sms') return `sms:?&body=${text}`;
    if (channel === 'facebook') return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    if (channel === 'x') return `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`;
    if (channel === 'whatsapp') return `https://api.whatsapp.com/send?text=${text}`;
    if (channel === 'reddit') return `https://www.reddit.com/submit?url=${encodedUrl}&title=${encodedTitle}`;
    if (channel === 'linkedin') return `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;

    return url || '#';
  }

  async function refreshAwardsAfterShare() {
    try {
      const meRes = await api('/api/me');
      state.me = meRes.member || meRes.user || meRes.profile || state.me;
      state.pendingAwards = Array.isArray(meRes.pending_awards) ? meRes.pending_awards : [];
      state.challengesList = Array.isArray(meRes.challenges) ? meRes.challenges : [];
      updateAwardNotification();
      renderGoalsBalances();
    } catch (err) {}
  }

  async function openArchiveShareModal(letter = {}) {
    if (!state.me) {
      showAlert('Log in to the Den first to use Pack share links.');
      return;
    }

    const slug = String(letter.slug || '').trim().toLowerCase();
    if (!slug) return;

    state.activeShareLetter = {
      slug,
      title: letter.title || 'Nature Wolf letter'
    };
    state.activeShareData = null;

    trackEvent('share_started', {
      source: 'archive_share_modal',
      newsletter_slug: slug,
      newsletter_title: state.activeShareLetter.title
    });

    if (els.shareTitle) els.shareTitle.textContent = `Share: ${state.activeShareLetter.title}`;
    if (els.shareLinkInput) els.shareLinkInput.value = 'Loading...';

    setShareStatus('Loading your Pack share link...', false);

    if (els.backdrop) els.backdrop.hidden = false;
    if (els.shareModal) els.shareModal.hidden = false;

    document.documentElement.classList.add('nw-modal-open');
    document.body.classList.add('nw-modal-open');

    if (els.shareNative && !navigator.share) {
      els.shareNative.hidden = true;
    }

    try {
      const data = await api('/api/newsletters/share-link', 'POST', { slug });
      state.activeShareData = data;

      if (els.shareLinkInput) {
        els.shareLinkInput.value = data.referral_url || '';
      }

      setShareStatus(
        data.share_reward_already_earned
          ? 'You already earned the +5 Pack XP share reward for this letter. Your Pack link still works for referrals.'
          : 'Your Pack share link is ready. Use a share button to earn +5 Pack XP once for this letter.',
        !!data.share_reward_already_earned
      );
    } catch (err) {
      setShareStatus(err.message || 'Unable to load your Pack share link.', false);
    }
  }

  function closeArchiveShareModal() {
    if (els.shareModal) els.shareModal.hidden = true;
    state.activeShareLetter = null;
    state.activeShareData = null;

    if (
      els.backdrop &&
      (!els.customizeModal || els.customizeModal.hidden) &&
      (!els.packModal || els.packModal.hidden) &&
      (!els.packMemberModal || els.packMemberModal.hidden) &&
      (!els.goalsModal || els.goalsModal.hidden) &&
      (!els.trailsModal || els.trailsModal.hidden)
    ) {
      forceUnlockPageAfterModalClose();
    }
  }

  async function recordArchiveShare(channel) {
    const slug = state.activeShareLetter?.slug || state.activeShareData?.slug || '';
    if (!slug || channel === 'copy') return;

    const data = await api('/api/newsletters/share/complete', 'POST', {
      slug,
      channel
    });

    state.pendingAwards = Array.isArray(data.pending_awards) ? data.pending_awards : state.pendingAwards;
    state.challengesList = Array.isArray(data.challenges) ? data.challenges : state.challengesList;

    trackEvent('share_completed', {
      source: 'archive_share_modal',
      newsletter_slug: slug,
      channel,
      already_rewarded: !!data.already_rewarded
    });

    setShareStatus(data.message || 'Letter shared. Your +5 Pack XP reward is ready in Achievements.', true);
    await refreshAwardsAfterShare();
  }

  async function copyArchiveReferralLink() {
    const url = state.activeShareData?.referral_url || els.shareLinkInput?.value || '';
    if (!url) return;

    await navigator.clipboard.writeText(url);
    setShareStatus('Pack share link copied. If someone joins through this link and creates their Pack login, you can earn a +25 Pack XP referral reward.', true);
  }

  async function shareArchiveLetter(channel) {
    const shareData = state.activeShareData;
    if (!shareData?.referral_url) {
      setShareStatus('Your Pack share link is still loading.', false);
      return;
    }

    if (channel === 'copy') {
      await copyArchiveReferralLink();
      return;
    }

    if (channel === 'native') {
      if (!navigator.share) {
        setShareStatus('Device sharing is not supported in this browser.', false);
        return;
      }

      await navigator.share({
        title: shareData.title || state.activeShareLetter?.title || 'Nature Wolf letter',
        text: 'Read this Nature Wolf letter.',
        url: shareData.referral_url
      });

      await recordArchiveShare('native');
      return;
    }

    window.open(
      getArchiveSharePlatformUrl(channel, shareData.referral_url, shareData.title || state.activeShareLetter?.title || 'Nature Wolf letter'),
      '_blank',
      'noopener,noreferrer'
    );

    await recordArchiveShare(channel);
  }

  function setArchiveExpanded(isExpanded) {
    state.archiveExpanded = !!isExpanded;

    if (els.archiveBody) {
      els.archiveBody.hidden = !state.archiveExpanded;
    }

    if (els.archivePanel) {
      els.archivePanel.classList.toggle('is-expanded', state.archiveExpanded);
      els.archivePanel.classList.toggle('is-collapsed', !state.archiveExpanded);
    }

    if (els.archiveToggle) {
      els.archiveToggle.classList.toggle('is-open', state.archiveExpanded);
      els.archiveToggle.setAttribute('aria-expanded', state.archiveExpanded ? 'true' : 'false');
    }

    if (els.archiveToggleBadge) {
      els.archiveToggleBadge.textContent = state.archiveExpanded ? 'Close archive' : 'Open archive';
    }

    if (els.archiveToggleChevron) {
      els.archiveToggleChevron.textContent = state.archiveExpanded ? '▴' : '▾';
    }
  }

  async function ensureArchivePanelOpen({ force = false } = {}) {
    if (!els.archivePanel) return;

    els.archivePanel.hidden = false;

    try {
      await loadArchivePosts({ force: force || !state.archiveLoaded });
    } catch (err) {
      if (els.archiveStatus) els.archiveStatus.textContent = err.message || 'Unable to load the letter archive.';
    }
  }

  function clearTreasureChestTimer() {
    if (state.treasureChestTimerId) {
      clearInterval(state.treasureChestTimerId);
      state.treasureChestTimerId = null;
    }
  }

  function clearHeartChestTimer() {
    if (state.heartChestTimerId) {
      clearInterval(state.heartChestTimerId);
      state.heartChestTimerId = null;
    }
  }

  function syncTreasureChestFromClock() {
    if (!state.treasureChest) return;
    if (!state.treasureChest.next_available_at) return;

    const nextAvailableTs = new Date(state.treasureChest.next_available_at).getTime();
    if (!Number.isFinite(nextAvailableTs)) return;

    const remainingMs = Math.max(0, nextAvailableTs - Date.now());
    state.treasureChest.remaining_ms = remainingMs;
    state.treasureChest.available = remainingMs <= 0;

    renderTreasureChest();
  }

  function syncHeartChestFromClock() {
    if (!state.heartChest) return;
    if (!state.heartChest.next_available_at) return;

    const nextAvailableTs = new Date(state.heartChest.next_available_at).getTime();
    if (!Number.isFinite(nextAvailableTs)) return;

    const remainingMs = Math.max(0, nextAvailableTs - Date.now());
    state.heartChest.remaining_ms = remainingMs;
    state.heartChest.available = remainingMs <= 0;

    renderHeartChest();
  }

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      syncTreasureChestFromClock();
      syncHeartChestFromClock();
    }
  });

  window.addEventListener('focus', () => {
    syncTreasureChestFromClock();
    syncHeartChestFromClock();
  });

  function formatTreasureChestRemaining(ms) {
    const totalSeconds = Math.max(0, Math.floor((Number(ms) || 0) / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return [
      String(hours).padStart(2, '0'),
      String(minutes).padStart(2, '0'),
      String(seconds).padStart(2, '0')
    ].join(':');
  }

  function renderTreasureChest() {
    if (!els.treasureChestWrap) return;

    const chest = state.treasureChest || {
      available: true,
      pack_xp: 5,
      remaining_ms: 0,
      next_available_at: null
    };

    let remainingMs = Math.max(0, Number(chest.remaining_ms || 0));

    if (chest.next_available_at) {
      const nextAvailableTs = new Date(chest.next_available_at).getTime();
      if (Number.isFinite(nextAvailableTs)) {
        remainingMs = Math.max(0, nextAvailableTs - Date.now());
        chest.remaining_ms = remainingMs;
      }
    }

    if (remainingMs <= 0) {
      chest.available = true;
      chest.remaining_ms = 0;
    } else {
      chest.available = false;
      chest.remaining_ms = remainingMs;
    }

    els.treasureChestWrap.hidden = false;

    if (els.treasureChestTimer) {
      els.treasureChestTimer.textContent = chest.available
        ? 'Ready to open'
        : formatTreasureChestRemaining(remainingMs);
    }

    if (els.treasureChestStatus) {
      els.treasureChestStatus.textContent = chest.available
        ? `Ready • 🐾 +${Number(chest.pack_xp || 5)} Pack XP`
        : '🔒 Recharging';
    }

    if (els.treasureChestButton) {
      els.treasureChestButton.disabled = !chest.available;
      els.treasureChestButton.classList.toggle('is-ready', chest.available);
      els.treasureChestButton.classList.toggle('is-waiting', !chest.available);
    }

    clearTreasureChestTimer();

    if (!chest.available) {
      state.treasureChestTimerId = setInterval(() => {
        if (!state.treasureChest) {
          clearTreasureChestTimer();
          return;
        }

        const nextAvailableTs = state.treasureChest.next_available_at
          ? new Date(state.treasureChest.next_available_at).getTime()
          : NaN;

        if (!Number.isFinite(nextAvailableTs)) {
          clearTreasureChestTimer();
          renderTreasureChest();
          return;
        }

        const freshRemainingMs = Math.max(0, nextAvailableTs - Date.now());
        state.treasureChest.remaining_ms = freshRemainingMs;
        state.treasureChest.available = freshRemainingMs <= 0;

        if (freshRemainingMs <= 0) {
          clearTreasureChestTimer();
        }

        if (els.treasureChestTimer) {
          els.treasureChestTimer.textContent = state.treasureChest.available
            ? 'Ready to open'
            : formatTreasureChestRemaining(freshRemainingMs);
        }

        if (els.treasureChestStatus) {
          els.treasureChestStatus.textContent = state.treasureChest.available
            ? `Ready • 🐾 +${Number(state.treasureChest.pack_xp || 5)} Pack XP`
            : '🔒 Recharging';
        }

        if (els.treasureChestButton) {
          els.treasureChestButton.disabled = !state.treasureChest.available;
          els.treasureChestButton.classList.toggle('is-ready', state.treasureChest.available);
          els.treasureChestButton.classList.toggle('is-waiting', !state.treasureChest.available);
        }
      }, 1000);
    }
  }

  function renderHeartChest() {
    if (!els.heartChestWrap) return;

    const chest = state.heartChest || {
      available: true,
      hearts: 1,
      remaining_ms: 0,
      next_available_at: null
    };

    let remainingMs = Math.max(0, Number(chest.remaining_ms || 0));

    if (chest.next_available_at) {
      const nextAvailableTs = new Date(chest.next_available_at).getTime();
      if (Number.isFinite(nextAvailableTs)) {
        remainingMs = Math.max(0, nextAvailableTs - Date.now());
        chest.remaining_ms = remainingMs;
      }
    }

    if (remainingMs <= 0) {
      chest.available = true;
      chest.remaining_ms = 0;
    } else {
      chest.available = false;
      chest.remaining_ms = remainingMs;
    }

    els.heartChestWrap.hidden = false;

    if (els.heartChestTimer) {
      els.heartChestTimer.textContent = chest.available
        ? 'Ready to open'
        : formatTreasureChestRemaining(remainingMs);
    }

    if (els.heartChestStatus) {
      els.heartChestStatus.textContent = chest.available
        ? `Ready • +${Number(chest.hearts || 1)} heart`
        : '🔒 Recharging';
    }

    if (els.heartChestButton) {
      els.heartChestButton.disabled = !chest.available;
      els.heartChestButton.classList.toggle('is-ready', chest.available);
      els.heartChestButton.classList.toggle('is-waiting', !chest.available);
    }

    clearHeartChestTimer();

    if (!chest.available) {
      state.heartChestTimerId = setInterval(() => {
        if (!state.heartChest) {
          clearHeartChestTimer();
          return;
        }

        const nextAvailableTs = state.heartChest.next_available_at
          ? new Date(state.heartChest.next_available_at).getTime()
          : NaN;

        if (!Number.isFinite(nextAvailableTs)) {
          clearHeartChestTimer();
          renderHeartChest();
          return;
        }

        const freshRemainingMs = Math.max(0, nextAvailableTs - Date.now());
        state.heartChest.remaining_ms = freshRemainingMs;
        state.heartChest.available = freshRemainingMs <= 0;

        if (freshRemainingMs <= 0) {
          clearHeartChestTimer();
        }

        if (els.heartChestTimer) {
          els.heartChestTimer.textContent = state.heartChest.available
            ? 'Ready to open'
            : formatTreasureChestRemaining(freshRemainingMs);
        }

        if (els.heartChestStatus) {
          els.heartChestStatus.textContent = state.heartChest.available
            ? `Ready • +${Number(state.heartChest.hearts || 1)} heart`
            : '🔒 Recharging';
        }

        if (els.heartChestButton) {
          els.heartChestButton.disabled = !state.heartChest.available;
          els.heartChestButton.classList.toggle('is-ready', state.heartChest.available);
          els.heartChestButton.classList.toggle('is-waiting', !state.heartChest.available);
        }
      }, 1000);
    }
  }

  function resetTreasureChestRewardVisual() {
    state.treasureChestRewardRevealed = false;

    if (els.treasureChestReward) {
      els.treasureChestReward.classList.remove('is-live');
    }
    if (els.treasureChestFade) {
      els.treasureChestFade.classList.remove('is-live');
    }
    if (els.treasureChestRewardIcon) {
      els.treasureChestRewardIcon.textContent = '🐾';
      els.treasureChestRewardIcon.classList.remove('is-heart');
    }
    if (els.treasureChestRewardText) {
      els.treasureChestRewardText.textContent = '+5 Pack XP!';
    }
  }

  function finalizeTreasureChestReward() {
    const pending = state.treasureChestPendingCredit;
    if (!pending || state.treasureChestRewardRevealed) return;

    state.treasureChestRewardRevealed = true;

    if (els.treasureChestReward) {
      els.treasureChestReward.classList.add('is-live');
    }

    if (pending.kind === 'heart') {
      if (typeof safePlay === 'function' && typeof starCollectAudio !== 'undefined') {
        safePlay(starCollectAudio);
      }

      if (!state.trailsState) state.trailsState = {};
      state.trailsState.hearts = Number(pending.newHearts || state.trailsState.hearts || 0);

      if (state.trailsQuestion) {
        state.trailsQuestion.hearts_left = Number(pending.newHearts || state.trailsQuestion.hearts_left || 0);
      }

      if (els.trailsModal && !els.trailsModal.hidden) {
        if (state.trailsQuestion) {
          renderTrailsQuestion();
        } else {
          renderTrailsMenu();
        }
      }

      state.treasureChestPendingCredit = null;
      return;
    }

   if (pending.kind === 'pack_xp') {
      const oldPackXp = Number(pending.oldPackXp || 0);
      const newPackXp = Number(pending.newPackXp || oldPackXp);
      const packXpAwarded = Number(pending.packXp || Math.max(0, newPackXp - oldPackXp));

      if (pending.member) {
        state.me = pending.member;
      } else if (state.me) {
        state.me.pack_xp = newPackXp;
      }

      animatePackXp(packXpAwarded, {
        container: els.goalsStarAnimation || els.awardStarAnimation || els.stage,
        fromMainPackXp: oldPackXp,
        fromGoalsPackXp: oldPackXp,
        toMainPackXp: newPackXp,
        toGoalsPackXp: newPackXp
      }).then(() => {
        renderProfile();
        renderGoalsBalances();
        updateAwardNotification();
        loadPackPage(state.packPage || 1).catch(() => {});
        maybeShowQueuedRankUnlock();
      });

      state.treasureChestPendingCredit = null;
      return;
    }

    state.treasureChestPendingCredit = null;
  }

  function closeTreasureChestModal() {
    if (state.treasureChestRevealTimerId) {
      clearTimeout(state.treasureChestRevealTimerId);
      state.treasureChestRevealTimerId = null;
    }

    if (state.treasureChestPendingCredit && !state.treasureChestRewardRevealed) {
      finalizeTreasureChestReward();
    }

    if (els.treasureChestVideo) {
      try {
        els.treasureChestVideo.pause();
        els.treasureChestVideo.currentTime = 0;
      } catch (err) {}
    }

    if (els.treasureChestVideo) {
      els.treasureChestVideo.ontimeupdate = null;
    }

    if (els.treasureChestFade) {
      els.treasureChestFade.classList.remove('is-live');
    }

    if (els.treasureChestModal) {
      els.treasureChestModal.hidden = true;
    }

    resetTreasureChestRewardVisual();

    if (
      els.backdrop &&
      (!els.customizeModal || els.customizeModal.hidden) &&
      (!els.packModal || els.packModal.hidden) &&
      (!els.packMemberModal || els.packMemberModal.hidden) &&
      (!els.goalsModal || els.goalsModal.hidden) &&
      (!els.triviaModal || els.triviaModal.hidden)
    ) {
      els.backdrop.hidden = true;
    }
  }

  async function handleTreasureChestOpen() {
    const chest = state.treasureChest || null;
    const isAvailable = !!chest?.available || Number(chest?.remaining_ms || 0) <= 0;

    if (!isAvailable) return;
    if (!state.me) return;

    if (els.treasureChestButton) {
      els.treasureChestButton.disabled = true;
    }

    try {
      const oldPackXp = Number(state.me.pack_xp || 0);

      const res = await api('/api/me/chest/open', 'POST');

      state.treasureChest = res.treasure_chest || state.treasureChest;

      if (res.member) {
        state.me = res.member;
        queueWolfUnlocks(state.me?.wolf_unlocks || res.wolf_unlocks || []);
      }

      renderTreasureChest();

      const packXpAwarded = Number(res.pack_xp_awarded || 5);
      const newPackXp = Number(state.me?.pack_xp || res.pack_xp || (oldPackXp + packXpAwarded));

      state.treasureChestPendingCredit = {
        kind: 'pack_xp',
        packXp: packXpAwarded,
        oldPackXp,
        newPackXp,
        member: res.member || null
      };

      resetTreasureChestRewardVisual();

      if (els.treasureChestRewardIcon) {
        els.treasureChestRewardIcon.textContent = '🐾';
        els.treasureChestRewardIcon.classList.remove('is-heart');
      }

      if (els.treasureChestRewardText) {
        els.treasureChestRewardText.textContent = `+${packXpAwarded} Pack XP`;
      }

      if (els.backdrop) els.backdrop.hidden = false;
      if (els.treasureChestModal) els.treasureChestModal.hidden = false;

      if (els.treasureChestVideo) {
        try {
          els.treasureChestVideo.pause();
          els.treasureChestVideo.currentTime = 0;
          els.treasureChestVideo.ontimeupdate = null;
          const playPromise = els.treasureChestVideo.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        } catch (err) {}
      }

      state.treasureChestRevealTimerId = setTimeout(() => {
        finalizeTreasureChestReward();
        state.treasureChestRevealTimerId = null;
      }, 1500);
    } catch (err) {
      showAlert(err.message || 'Unable to open the treasure chest.');
      renderTreasureChest();
    }
  }

  async function handleHeartChestOpen() {
    const chest = state.heartChest || null;
    const isAvailable = !!chest?.available || Number(chest?.remaining_ms || 0) <= 0;

    if (!isAvailable) return;

    if (els.heartChestButton) {
      els.heartChestButton.disabled = true;
    }

    try {
      const oldHearts = Number(state.trailsState?.hearts || 0);

      const res = await api('/api/me/heart-chest/open', 'POST');

      state.heartChest = res.heart_chest || state.heartChest;
      renderHeartChest();

      state.treasureChestPendingCredit = {
        kind: 'heart',
        hearts: Number(res.hearts_awarded || 1),
        oldHearts,
        newHearts: Number(res.available_hearts || (oldHearts + 1))
      };

      resetTreasureChestRewardVisual();

      if (els.treasureChestRewardIcon) {
        els.treasureChestRewardIcon.textContent = '❤️';
        els.treasureChestRewardIcon.classList.add('is-heart');
      }

      if (els.treasureChestRewardText) {
        els.treasureChestRewardText.textContent = `+${Number(res.hearts_awarded || 1)} heart`;
      }

      if (els.backdrop) els.backdrop.hidden = false;
      if (els.treasureChestModal) els.treasureChestModal.hidden = false;

      if (els.treasureChestVideo) {
        try {
          els.treasureChestVideo.pause();
          els.treasureChestVideo.currentTime = 0;
          els.treasureChestVideo.ontimeupdate = null;
          const playPromise = els.treasureChestVideo.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        } catch (err) {}
      }

      state.treasureChestRevealTimerId = setTimeout(() => {
        finalizeTreasureChestReward();
        state.treasureChestRevealTimerId = null;
      }, 1500);
    } catch (err) {
      showAlert(err.message || 'Unable to open the heart chest.');
      renderHeartChest();
    }
  }

  function ownedIds() {
    return new Set((state.me?.owned_items || []).map(item => item.item_id));
  }

  function ownedPurchaseIds() {
    return new Set((state.me?.owned_items || []).map(item => Number(item.purchase_id)));
  }

  function getOwnedItemQuantity(itemId) {
    const safeItemId = Number(itemId || 0);
    if (!safeItemId) return 0;

    return (state.me?.owned_items || []).filter((item) => {
      return Number(item.item_id || 0) === safeItemId;
    }).length;
  }

  function member() {
    return state.me || null;
  }

  function getCollectionOwnedWolvesCount() {
    const me = member();

    if (Array.isArray(state.wolves) && state.wolves.length) {
      return state.wolves.length;
    }

    if (Array.isArray(me?.wolves) && me.wolves.length) {
      return me.wolves.length;
    }

    if (me?.current_wolf || me?.rank) {
      return 1;
    }

    return 0;
  }

  function getCollectionOwnedSwagCount() {
    const me = member();

    if (Array.isArray(me?.owned_items)) {
      return me.owned_items.length;
    }

    return Math.max(0, Number(me?.owned_count || 0));
  }

  function syncCollectionHeaderCounts() {
  const wolvesOwnedCount = getCollectionOwnedWolvesCount();
  const swagOwnedCount = getCollectionOwnedSwagCount();

  if (els.ownedCount) {
    els.ownedCount.textContent = wolvesOwnedCount.toLocaleString();
  }

  if (els.equippedCount) {
    els.equippedCount.textContent = swagOwnedCount.toLocaleString();
  }

  if (els.collectionOwnedCount) {
    els.collectionOwnedCount.textContent = wolvesOwnedCount.toLocaleString();
  }

  if (els.collectionSwagOwnedCount) {
    els.collectionSwagOwnedCount.textContent = swagOwnedCount.toLocaleString();
  }
}

  function renderQuickAccessStates() {
    const pending = Array.isArray(state.pendingAwards) ? state.pendingAwards : [];
    const pendingPackXp = pending.reduce((sum, award) => {
      return sum + Math.max(0, Number(award?.pack_xp || award?.stars || 0));
    }, 0);

    const achievementsDetail = document.getElementById('nw-achievements-shortcut-detail');
    const achievementsSubline = document.getElementById('nw-achievements-shortcut-subline');
    const achievementsCta = document.getElementById('nw-achievements-shortcut-cta');

    if (els.openAchievementsMain) {
      els.openAchievementsMain.classList.toggle('has-notification', pending.length > 0);
      els.openAchievementsMain.classList.toggle('is-quiet', pending.length <= 0);
    }

    if (els.achievementsShortcutBadge) {
      els.achievementsShortcutBadge.hidden = pending.length <= 0;
      els.achievementsShortcutBadge.textContent = pending.length > 0 ? 'Claim' : '';
    }

    if (els.achievementsShortcutNote) {
      els.achievementsShortcutNote.textContent =
        pending.length > 0
          ? `${pending.length} reward${pending.length === 1 ? '' : 's'} ready`
          : 'Achievements';
    }

    if (achievementsDetail) {
      achievementsDetail.textContent =
        pending.length > 0
          ? `${pendingPackXp.toLocaleString()} Pack XP is ready to claim from your completed rewards.`
          : 'Claim rewards, check referrals, and keep track of the Pack XP you have earned.';
    }

    if (achievementsSubline) {
      achievementsSubline.textContent =
        pending.length > 0
          ? 'Open Achievements to collect your Pack XP.'
          : 'No rewards waiting right now.';
    }

    if (achievementsCta) {
      achievementsCta.textContent = pending.length > 0 ? 'Claim XP' : 'Open Achievements';
    }

    if (els.triviaShortcutTitle) {
      els.triviaShortcutTitle.textContent = 'Games';
      els.triviaShortcutTitle.classList.remove('is-complete');
    }

    if (els.triviaShortcutStat) {
      els.triviaShortcutStat.textContent = 'Trivia Trails and Pack Simulator';
      els.triviaShortcutStat.classList.remove('is-complete');
    }
  }

  // ------------------- Award notification & claiming helpers -------------------
  // Show or hide the awards notification bubble based on pending awards
  function updateAwardNotification() {
    renderQuickAccessStates();

    if (typeof updateGoalsList === 'function') updateGoalsList();
  }

  // Open the next pending award popup
  function openNextAward() {
    if (!state.pendingAwards || state.pendingAwards.length === 0) return;
    const award = state.pendingAwards[0];
    state.currentAward = award;
    state.currentAwardSource = 'popup';
    state.currentAwardTriggerBtn = null;
    if (els.awardPopupMessage) {
      els.awardPopupMessage.textContent = award.message || `You've earned ${Number(award.pack_xp || 0)} Pack XP.`;
    }
    if (els.awardStarAnimation) {
      els.awardStarAnimation.innerHTML = '';
    }
    if (els.awardPopup) {
      els.awardPopup.hidden = false;
    }
  }

  function closeAwardPopup() {
    if (els.awardPopup) els.awardPopup.hidden = true;
    state.currentAward = null;
    state.currentAwardSource = null;
    state.currentAwardTriggerBtn = null;
  }

  // Animate number values from start to end over duration
  function animateCounter(el, start, end, duration = 1000) {
    start = Number(start);
    end = Number(end);
    if (!el) return;
    const startTime = performance.now();
    function step(now) {
      const progress = Math.min(1, (now - startTime) / duration);
      const value = Math.floor(start + (end - start) * progress);
      el.textContent = String(value);
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = String(end);
      }
    }
    requestAnimationFrame(step);
  }

  // Animate flying star emojis from the popup to the available star counter
  function animateStars(count, options = {}) {
    return new Promise((resolve) => {
      const safeCount = Number(count || 0);
      const container =
        options.container ||
        els.goalsStarAnimation ||
        els.awardStarAnimation ||
        els.stage;

      if (!container || safeCount <= 0) {
        resolve();
        return;
      }

      const starsToAnimate = Math.min(safeCount, 40);

      const oldAvailGoals = Number(
        options.fromGoalsAvailable ?? els.goalsStarsAvailable?.textContent ?? 0
      );
      const oldAllGoals = Number(
        options.fromGoalsAlltime ?? els.goalsStarsAlltime?.textContent ?? 0
      );
      const oldAvailMain = Number(
        options.fromMainAvailable ?? els.starsAvailable?.textContent ?? 0
      );
      const oldAllMain = Number(
        options.fromMainAlltime ?? els.starsAlltime?.textContent ?? 0
      );

      const targetAvailGoals = Number(
        options.toGoalsAvailable ?? (oldAvailGoals + safeCount)
      );
      const targetAllGoals = Number(
        options.toGoalsAlltime ?? (oldAllGoals + safeCount)
      );
      const targetAvailMain = Number(
        options.toMainAvailable ?? (oldAvailMain + safeCount)
      );
      const targetAllMain = Number(
        options.toMainAlltime ?? (oldAllMain + safeCount)
      );

      const setDisplayValues = (progressCount) => {
        const ratio = starsToAnimate > 0 ? progressCount / starsToAnimate : 1;

        const currentGoalsAvail = Math.round(oldAvailGoals + ((targetAvailGoals - oldAvailGoals) * ratio));
        const currentGoalsAll = Math.round(oldAllGoals + ((targetAllGoals - oldAllGoals) * ratio));
        const currentMainAvail = Math.round(oldAvailMain + ((targetAvailMain - oldAvailMain) * ratio));
        const currentMainAll = Math.round(oldAllMain + ((targetAllMain - oldAllMain) * ratio));

        if (els.goalsStarsAvailable) els.goalsStarsAvailable.textContent = String(currentGoalsAvail);
        if (els.goalsStarsAlltime) els.goalsStarsAlltime.textContent = String(currentGoalsAll);
        if (els.starsAvailable) els.starsAvailable.textContent = String(currentMainAvail);
        if (els.starsAlltime) els.starsAlltime.textContent = String(currentMainAll);
      };

      setDisplayValues(0);

      for (let i = 0; i < starsToAnimate; i++) {
        const starEl = document.createElement('div');
        starEl.className = 'nw-flying-star';
        starEl.textContent = '⭐';

        const offsetX = (Math.random() - 0.5) * 80;
        const offsetY = (Math.random() - 0.5) * 40;
        const dx = (Math.random() - 0.5) * 120;
        const dy = -120 - Math.random() * 80;

        starEl.style.left = `${(container.offsetWidth / 2) + offsetX}px`;
        starEl.style.top = `${34 + offsetY}px`;
        starEl.style.opacity = '1';
        container.appendChild(starEl);

        const delay = i * 55;

        setTimeout(() => {
          if (typeof playRapidStarTick === 'function') {
            playRapidStarTick();
          } else if (typeof safePlay === 'function' && typeof starCollectAudio !== 'undefined') {
            safePlay(starCollectAudio);
          } else if (typeof playSound === 'function' && typeof starCollectAudio !== 'undefined') {
            playSound(starCollectAudio);
          }

          setDisplayValues(i + 1);
        }, delay);

        starEl.animate([
          { transform: 'translate(0px, 0px) scale(1)', opacity: 1 },
          { transform: `translate(${dx}px, ${dy}px) scale(0.35)`, opacity: 0 }
        ], {
          duration: 850,
          delay,
          easing: 'cubic-bezier(0.4,0,0.2,1)'
        }).onfinish = () => {
          starEl.remove();
        };
      }

      setTimeout(() => {
        if (els.goalsStarsAvailable) els.goalsStarsAvailable.textContent = String(targetAvailGoals);
        if (els.goalsStarsAlltime) els.goalsStarsAlltime.textContent = String(targetAllGoals);
        if (els.starsAvailable) els.starsAvailable.textContent = String(targetAvailMain);
        if (els.starsAlltime) els.starsAlltime.textContent = String(targetAllMain);
        resolve();
      }, 850 + starsToAnimate * 55);
    });
  }

  function animatePackXp(count, options = {}) {
    return new Promise((resolve) => {
      const safeCount = Math.max(0, Math.floor(Number(count || 0)));
      const container =
        options.container ||
        els.goalsStarAnimation ||
        els.awardStarAnimation ||
        els.stage;

      const oldMainPackXp = Number(
        options.fromMainPackXp ?? els.packXpDisplay?.textContent ?? state.me?.pack_xp ?? 0
      );
      const oldGoalsPackXp = Number(
        options.fromGoalsPackXp ?? els.goalsPackXp?.textContent ?? oldMainPackXp
      );

      const targetMainPackXp = Number(
        options.toMainPackXp ?? (oldMainPackXp + safeCount)
      );
      const targetGoalsPackXp = Number(
        options.toGoalsPackXp ?? targetMainPackXp
      );

      const setDisplayValues = (progressCount) => {
        const ratio = safeCount > 0 ? progressCount / safeCount : 1;
        const currentMain = Math.round(oldMainPackXp + ((targetMainPackXp - oldMainPackXp) * ratio));
        const currentGoals = Math.round(oldGoalsPackXp + ((targetGoalsPackXp - oldGoalsPackXp) * ratio));

        if (els.packXpDisplay) els.packXpDisplay.textContent = String(currentMain);
        if (els.goalsPackXp) els.goalsPackXp.textContent = String(currentGoals);
        if (els.trailsHeadPackXp) els.trailsHeadPackXp.textContent = String(currentMain);
        if (els.simPackXp) els.simPackXp.textContent = String(currentMain);
      };

      setDisplayValues(0);

      if (!container || safeCount <= 0) {
        setDisplayValues(safeCount);
        resolve();
        return;
      }

      for (let i = 0; i < safeCount; i++) {
        const pawEl = document.createElement('div');
        pawEl.className = 'nw-flying-paw';
        pawEl.textContent = '🐾';

        const offsetX = (Math.random() - 0.5) * 80;
        const offsetY = (Math.random() - 0.5) * 40;
        const dx = (Math.random() - 0.5) * 120;
        const dy = -120 - Math.random() * 80;

        pawEl.style.left = `${(container.offsetWidth / 2) + offsetX}px`;
        pawEl.style.top = `${34 + offsetY}px`;
        pawEl.style.opacity = '1';
        container.appendChild(pawEl);

        const delay = i * 70;

        setTimeout(() => {
          playRapidPackXpTick();
          setDisplayValues(i + 1);
        }, delay);

        pawEl.animate([
          { transform: 'translate(0px, 0px) scale(1)', opacity: 1 },
          { transform: `translate(${dx}px, ${dy}px) scale(0.35)`, opacity: 0 }
        ], {
          duration: 850,
          delay,
          easing: 'cubic-bezier(0.4,0,0.2,1)'
        }).onfinish = () => {
          pawEl.remove();
        };
      }

      setTimeout(() => {
        setDisplayValues(safeCount);
        resolve();
      }, 850 + safeCount * 70);
    });
  }

  async function claimCurrentAward() {
    const award = state.currentAward;
    if (!award) return;

    trackFirstDenAction('reward_claimed', {
      source: state.currentAwardSource || 'award_popup',
      award_id: award.id || null,
      award_reason: award.reason || ''
    });

    trackEvent('reward_claimed', {
      source: state.currentAwardSource || 'award_popup',
      award_id: award.id || null,
      award_reason: award.reason || ''
    });

    const isGoalsClaim = state.currentAwardSource === 'goals';
    const triggerBtn = state.currentAwardTriggerBtn || null;
    const animationContainer = isGoalsClaim
      ? (els.goalsStarAnimation || els.awardStarAnimation || els.stage)
      : (els.awardStarAnimation || els.goalsStarAnimation || els.stage);

    if (els.awardPopupReceive) els.awardPopupReceive.disabled = true;
    if (triggerBtn) triggerBtn.disabled = true;

    try {
      const prevPackXpMain = Number(els.packXpDisplay?.textContent || state.me?.pack_xp || 0);
      const prevPackXpGoals = Number(els.goalsPackXp?.textContent || state.me?.pack_xp || prevPackXpMain);

      const res = await api('/api/me/awards/claim', 'POST', { award_id: award.id });

      if (res.member) {
        state.me = res.member;
      } else if (state.me) {
        state.me.available_stars = 0;
        state.me.star_balance = 0;
        state.me.all_time_stars = 0;
        state.me.pack_xp = Number(res.pack_xp || state.me.pack_xp || 0);
      }

      state.pendingAwards = state.pendingAwards.filter(a => a.id !== award.id);

      const packXpAwarded = Number(res.award?.pack_xp_awarded ?? res.award?.pack_xp ?? award.pack_xp ?? 0);
      const targetPackXp = Number(res.pack_xp ?? state.me?.pack_xp ?? (prevPackXpMain + packXpAwarded));


      await animatePackXp(packXpAwarded, {
        container: animationContainer,
        fromMainPackXp: prevPackXpMain,
        fromGoalsPackXp: prevPackXpGoals,
        toMainPackXp: targetPackXp,
        toGoalsPackXp: targetPackXp
      });

      updateAwardNotification();
      renderProfile();
      renderGoalsBalances();

      // Refresh rankings immediately so the Pack list updates without a page refresh
      await loadPackPage(state.packPage || 1);

      closeAwardPopup();
    } catch (err) {
      showAlert(err.message);
    } finally {
      if (els.awardPopupReceive) els.awardPopupReceive.disabled = false;
      if (triggerBtn) triggerBtn.disabled = false;
    }
  }

  // ------------------- Games & Challenges helpers -------------------
  function getSharedAvailableStars() {
    return 0;
  }

  function getSharedAllTimeStars() {
    return 0;
  }

  function getSharedPackXp() {
    const me = member();
    return Number(
      me?.pack_xp ??
      0
    );
  }

  function getSharedHeartBalance() {
    return Number(
      state.me?.hearts ??
      state.me?.trivia_trails?.hearts ??
      state.trailsState?.hearts ??
      0
    );
  }

  function syncVisibleBalances() {
    const packXp = getSharedPackXp();
    const hearts = getSharedHeartBalance();

    if (els.heartsAvailable) els.heartsAvailable.textContent = String(hearts);
    if (els.packXpDisplay) els.packXpDisplay.textContent = String(packXp);

    if (els.goalsHeartsAvailable) els.goalsHeartsAvailable.textContent = String(hearts);
    if (els.goalsPackXp) els.goalsPackXp.textContent = String(packXp);

    if (els.trailsHeadPackXp) els.trailsHeadPackXp.textContent = String(packXp);
    if (els.simPackXp) els.simPackXp.textContent = String(packXp);
  }

  function renderGoalsBalances() {
    syncVisibleBalances();
  }

  function setGcTab(tab) {
    state.gcActiveTab = tab;

    const isAchievements = tab === 'challenges';
    const heroEyebrow = els.goalsModal ? els.goalsModal.querySelector('.nw-gc-hero__eyebrow') : null;
    const heroTitle = els.goalsModal ? els.goalsModal.querySelector('.nw-gc-hero h3') : null;
    const heroCopy = els.goalsModal ? els.goalsModal.querySelector('#nw-gc-hero-copy') : null;
    const navCopy = els.goalsModal ? els.goalsModal.querySelector('.nw-gc-nav-copy') : null;

    if (heroEyebrow) heroEyebrow.textContent = isAchievements ? 'Pack progression' : 'Pack arcade';
    if (heroTitle) heroTitle.textContent = isAchievements ? 'Achievements' : 'Pack Arcade';
    if (heroCopy) {
      heroCopy.textContent = isAchievements
        ? 'Claim Pack XP, review referral rewards, and track the milestones that shape your place in the Pack.'
        : 'Launch wildlife game modes, spend hearts to play, earn Pack XP, unlock swag claims, and keep your Pack moving forward.';
    }
    if (navCopy) {
      navCopy.textContent = isAchievements
        ? 'Ready rewards rise to the top. Completed rewards stay tucked away unless you choose to show them.'
        : 'Games, rewards, and Pack progression in one place.';
    }

    if (els.gcTabGames) {
      els.gcTabGames.classList.toggle('is-active', tab === 'games');
      els.gcTabGames.classList.toggle('nw-btn--ghost', tab === 'games');
      els.gcTabGames.classList.toggle('nw-btn--primary', tab !== 'games');
    }

    if (els.gcTabChallenges) {
      els.gcTabChallenges.classList.toggle('is-active', tab === 'challenges');
      els.gcTabChallenges.classList.toggle('nw-btn--ghost', tab === 'challenges');
      els.gcTabChallenges.classList.toggle('nw-btn--primary', tab !== 'challenges');
    }

    if (els.gcGamesPanel) els.gcGamesPanel.hidden = tab !== 'games';
    if (els.gcChallengesPanel) els.gcChallengesPanel.hidden = tab !== 'challenges';

    updateGoalsList();
  }

  

  const triviaTickAudio = new Audio('https://cdn.shopify.com/s/files/1/0686/5764/3564/files/clockticking.mp3?v=1774703323');
  triviaTickAudio.loop = true;
  triviaTickAudio.preload = 'auto';
  triviaTickAudio.volume = 0.5;

  const triviaCorrectAudio = new Audio('https://cdn.shopify.com/s/files/1/0686/5764/3564/files/dingcorrect.mp3?v=1774308175');
  triviaCorrectAudio.preload = 'auto';
  triviaCorrectAudio.volume = 0.9;

  const triviaIncorrectAudio = new Audio('https://cdn.shopify.com/s/files/1/0686/5764/3564/files/incorrectanswersound.mp3?v=1774308331');
  triviaIncorrectAudio.preload = 'auto';
  triviaIncorrectAudio.volume = 0.9;

  const triviaEndAudio = new Audio('https://cdn.shopify.com/s/files/1/0686/5764/3564/files/spin-complete-295086.mp3?v=1761256623');
  triviaEndAudio.preload = 'auto';
  triviaEndAudio.volume = 0.9;

  const starCollectAudio = new Audio('https://cdn.shopify.com/s/files/1/0686/5764/3564/files/shine-8-268901.mp3?v=1763096264');
  starCollectAudio.preload = 'auto';
  starCollectAudio.volume = 0.95;

  function safePlay(audio) {
    if (!audio) return;
    try {
      audio.currentTime = 0;
      const p = audio.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    } catch (err) {}
  }

  function playRapidStarTick() {
    if (typeof starCollectAudio === 'undefined' || !starCollectAudio) return;
    try {
      const tick = starCollectAudio.cloneNode(true);
      tick.volume = starCollectAudio.volume;
      tick.preload = 'auto';
      const p = tick.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    } catch (err) {}
  }

  function playRapidPackXpTick() {
    if (typeof packXpCollectAudio === 'undefined' || !packXpCollectAudio) return;
    try {
      const tick = packXpCollectAudio.cloneNode(true);
      tick.volume = packXpCollectAudio.volume;
      tick.preload = 'auto';
      const p = tick.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    } catch (err) {}
  }

  function stopAudio(audio) {
    if (!audio) return;
    try {
      audio.pause();
      audio.currentTime = 0;
    } catch (err) {}
  }

  function playTriviaTick() {
    try {
      triviaTickAudio.currentTime = 0;
      const p = triviaTickAudio.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    } catch (err) {}
  }

  function revealTriviaAnswerResult(buttons, result, selectedIndex) {
    const correctIndex = Number(result?.correct_answer_index);
    const chosenIndex = Number(selectedIndex);

    buttons.forEach((btn) => {
      const idx = Number(btn.dataset.index);
      btn.classList.add('disabled');

      if (idx === correctIndex) {
        btn.classList.add('correct', 'reveal-pop');
      }

      if (!result?.correct && idx === chosenIndex && chosenIndex !== correctIndex) {
        btn.classList.add('incorrect', 'reveal-shake');
      }
    });
  }



  let editorSaveBusy = false;
  let editorHasUnsavedChanges = false;
  let editorAutosaveTimer = null;
  let editorInteractionDepth = 0;
  let editorSaveQueued = false;
  let editorLastSaveToken = 0;

  function clearEditorAutosaveTimer() {
    if (editorAutosaveTimer) {
      clearTimeout(editorAutosaveTimer);
      editorAutosaveTimer = null;
    }
  }

  async function refreshMemberState() {
    const meRes = await api('/api/me');
    state.me = meRes.member || meRes.user || meRes.profile || state.me;
    state.pendingAwards = Array.isArray(meRes.pending_awards) ? meRes.pending_awards : state.pendingAwards;
    state.challengesList = Array.isArray(meRes.challenges) ? meRes.challenges : state.challengesList;
    state.treasureChest = meRes.treasure_chest || state.treasureChest;
    queueWolfUnlocks(state.me?.wolf_unlocks || meRes.wolf_unlocks || []);
    queueSwagUnlocks(state.me?.swag_unlocks || meRes.swag_unlocks || []);
    state.wolves = Array.isArray(meRes.wolves)
      ? meRes.wolves
      : Array.isArray(state.me?.wolves)
        ? state.me.wolves
        : state.wolves;

    const selectedWolf = Array.isArray(state.wolves)
      ? state.wolves.find((wolf) => Number(wolf.id) === Number(state.selectedWolfId))
      : null;

    const currentRankKey = state.me?.rank?.key || null;

    if (selectedWolf) {
      state.editorLayout = JSON.parse(JSON.stringify(selectedWolf.equipped_items || []));
      if (state.me && selectedWolf.rank_key === currentRankKey && Number(selectedWolf.is_current) === 1) {
        state.me.equipped_items = JSON.parse(JSON.stringify(selectedWolf.equipped_items || []));
        state.me.equipped_count = (selectedWolf.equipped_items || []).length;
      }
      if (els.editorBaseWolf) {
        els.editorBaseWolf.src = selectedWolf.base_image_url || '';
        els.editorBaseWolf.alt = selectedWolf.rank_name || 'Wolf';
      }
    }

    normalizeEditorLayerOrder();
    renderProfile();
    renderWolfList();
    renderOwnedList();
    renderStore();
    finalizeCollectionStoreRender();
    renderHomePackRail();
    renderStage(els.editorStage, state.editorLayout, true);
    renderEditorLayerStrip();
    renderGoalsBalances();
    renderQuickAccessStates();
    updateAwardNotification();
    maybeShowQueuedRankUnlock();
  }

  function beginEditorInteraction() {
    editorInteractionDepth += 1;
    clearEditorAutosaveTimer();

    if (els.editorAutosaveNote && editorHasUnsavedChanges) {
      els.editorAutosaveNote.textContent = 'Editing...';
      els.editorAutosaveNote.classList.remove('is-saving');
    }
  }

  function endEditorInteraction() {
    editorInteractionDepth = Math.max(0, editorInteractionDepth - 1);
    if (editorInteractionDepth === 0) {
      scheduleEditorAutosave();
    }
  }

  function scheduleEditorAutosave() {
    clearEditorAutosaveTimer();

    if (!editorHasUnsavedChanges || !state.selectedWolfId) return;
    if (editorInteractionDepth > 0) return;

    if (editorSaveBusy) {
      editorSaveQueued = true;
      return;
    }

    if (els.editorAutosaveNote) {
      els.editorAutosaveNote.textContent = 'Changes pending...';
      els.editorAutosaveNote.classList.remove('is-saving');
    }

    editorAutosaveTimer = setTimeout(async () => {
      editorAutosaveTimer = null;
      if (!editorHasUnsavedChanges) return;
      if (editorInteractionDepth > 0) return scheduleEditorAutosave();
      await saveEditorLayout({ silent: true });
    }, 900);
  }

  async function flushEditorAutosave({ silent = true } = {}) {
    clearEditorAutosaveTimer();
    if (!editorHasUnsavedChanges) return;
    await saveEditorLayout({ silent });
  }

  function resetEditorAutosaveState(statusText = 'All changes saved') {
    clearEditorAutosaveTimer();
    editorHasUnsavedChanges = false;
    editorSaveQueued = false;
    editorInteractionDepth = 0;

    if (els.editorAutosaveNote) {
      els.editorAutosaveNote.textContent = statusText;
      els.editorAutosaveNote.classList.remove('is-saving');
    }

    if (els.saveWolfLayout) {
      els.saveWolfLayout.disabled = false;
      els.saveWolfLayout.textContent = 'Save now';
    }
  }

  function syncSelectedWolfInState() {
    if (!Array.isArray(state.wolves) || !state.selectedWolfId) return;
    state.wolves = state.wolves.map((wolf) => {
      if (Number(wolf.id) !== Number(state.selectedWolfId)) return wolf;
      return {
        ...wolf,
        equipped_items: JSON.parse(JSON.stringify(state.editorLayout || []))
      };
    });
  }

  async function saveEditorLayout({ silent = false } = {}) {
    if (!state.selectedWolfId) return;

    if (editorSaveBusy) {
      editorSaveQueued = true;
      return;
    }

    clearEditorAutosaveTimer();
    editorSaveBusy = true;
    editorSaveQueued = false;

    const saveToken = ++editorLastSaveToken;
    let saveSucceeded = false;

    if (els.editorAutosaveNote) {
      els.editorAutosaveNote.textContent = 'Saving...';
      els.editorAutosaveNote.classList.add('is-saving');
    }

    if (els.saveWolfLayout) {
      els.saveWolfLayout.disabled = true;
      els.saveWolfLayout.textContent = 'Saving...';
    }

    try {
      normalizeEditorLayerOrder();

      const payload = state.editorLayout.map((item) => {
        return {
          purchase_id: Number(item.purchase_id || 0) || null,
          item_id: item.item_id,
          name: item.name || '',
          image_url: item.image_url || '',
          slot: item.slot || 'swag',
          x: Number(item.x.toFixed(2)),
          y: Number(item.y.toFixed(2)),
          w: Number(item.w.toFixed(2)),
          h: Number(item.h.toFixed(2)),
          rotation: Number((item.rotation || 0).toFixed(2)),
          z_index: Number(item.z_index || 1)
        };
      });

      const saveRes = await api('/api/me/equipped', 'POST', {
        wolf_id: state.selectedWolfId,
        items: payload
      });

      saveSucceeded = true;

      if (saveRes?.member) {
        state.me = saveRes.member;
      }

      if (Array.isArray(saveRes?.wolves)) {
        state.wolves = saveRes.wolves;
        if (state.me) {
          state.me.wolves = JSON.parse(JSON.stringify(saveRes.wolves));
        }
      } else {
        syncSelectedWolfInState();
        if (state.me && Array.isArray(state.wolves)) {
          state.me.wolves = JSON.parse(JSON.stringify(state.wolves));
        }
      }

      const selectedWolfMeta = Array.isArray(state.wolves)
        ? state.wolves.find((wolf) => Number(wolf.id) === Number(state.selectedWolfId))
        : null;

      if (selectedWolfMeta) {
        state.editorLayout = JSON.parse(JSON.stringify(selectedWolfMeta.equipped_items || [])).map((item) => ({
          ...item,
          z_index: Math.max(1, Number(item.z_index || 1))
        }));

        if (els.editorBaseWolf) {
          els.editorBaseWolf.src = selectedWolfMeta.base_image_url || '';
          els.editorBaseWolf.alt = selectedWolfMeta.rank_name || 'Wolf';
        }
      }

      if (saveToken === editorLastSaveToken) {
        editorHasUnsavedChanges = false;
      }

      if (state.me && state.me.rank && selectedWolfMeta && state.me.rank.key === selectedWolfMeta.rank_key && Number(selectedWolfMeta.is_current) === 1) {
        state.me.equipped_items = JSON.parse(JSON.stringify(state.editorLayout || []));
        state.me.equipped_count = (state.editorLayout || []).length;
        renderProfile();
      }

      // Sync only the logged-in member's own wolf payload before repainting their local cards.
      if (state.me && Array.isArray(state.wolves)) {
        state.me.wolves = JSON.parse(JSON.stringify(state.wolves));
      }

      renderWolfList();
      renderHomePackRail();
      renderOwnedList();
      renderStore();
      finalizeCollectionStoreRender();

      if (!silent) {
        showAlert('Wolf layout saved.');
      }
    } catch (err) {
      const saveMessage = err?.message || 'Failed to save wolf layout.';
      if (els.editorAutosaveNote) {
        els.editorAutosaveNote.textContent = silent ? `Autosave failed: ${saveMessage}` : saveMessage;
        els.editorAutosaveNote.classList.remove('is-saving');
      }
      if (!silent) {
        showAlert(saveMessage);
      }
    } finally {
      editorSaveBusy = false;

      if (els.editorAutosaveNote && saveSucceeded) {
        els.editorAutosaveNote.textContent = editorHasUnsavedChanges ? 'Changes not saved' : 'All changes saved';
        els.editorAutosaveNote.classList.remove('is-saving');
      }

      if (els.saveWolfLayout) {
        els.saveWolfLayout.disabled = false;
        els.saveWolfLayout.textContent = 'Save now';
      }

      const shouldRunQueuedSave = editorSaveQueued && editorInteractionDepth === 0;
      editorSaveQueued = false;

      if (shouldRunQueuedSave) {
        scheduleEditorAutosave();
      }
    }
  }

  function markEditorDirty() {
    editorHasUnsavedChanges = true;
    if (els.editorAutosaveNote) {
      els.editorAutosaveNote.textContent = editorInteractionDepth > 0 ? 'Editing...' : 'Changes not saved';
      els.editorAutosaveNote.classList.remove('is-saving');
    }
    if (editorInteractionDepth === 0) {
      scheduleEditorAutosave();
    }
  }

  async function closeCustomizeModal() {
    await flushEditorAutosave({ silent: true });
    if (els.customizeModal) els.customizeModal.hidden = true;
    if (els.backdrop) els.backdrop.hidden = true;
    state.selectedItemId = null;
  }



  function clearTrailsTimer() {
    if (state.trailsTimerId) {
      cancelAnimationFrame(state.trailsTimerId);
      state.trailsTimerId = null;
    }
    stopAudio(triviaTickAudio);
  }

  function setTrailsScreen(screen) {
    if (els.trailsScreenMenu) els.trailsScreenMenu.classList.remove('nw-trails-screen--active');
    if (els.trailsScreenGame) els.trailsScreenGame.classList.remove('nw-trails-screen--active');

    if (screen === 'menu' && els.trailsScreenMenu) els.trailsScreenMenu.classList.add('nw-trails-screen--active');
    if (screen === 'game' && els.trailsScreenGame) els.trailsScreenGame.classList.add('nw-trails-screen--active');
  }

  function getTrailsBiomeBackground(key) {
    return TRAILS_BIOME_BACKGROUNDS[key] || '';
  }

  function applyTrailsBackground(key) {
    if (!els.trailsStage) return;
    const url = getTrailsBiomeBackground(key);
    els.trailsStage.style.backgroundImage = url
      ? `url("${url}")`
      : 'none';
  }

  function formatTrailsAccuracy(value) {
  return `${Number(value || 0).toFixed(1)}%`;
}

function formatTrailsDate(value) {
  if (!value) return 'Not played yet';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Not played yet';
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}

function renderTrailsLifetimeStats() {
  if (!els.trailsLifetimeToggle || !els.trailsLifetimePanel || !els.trailsLifetimeSummary || !els.trailsLifetimeGrid) return;

  const lifetime = state.trailsState?.lifetime_stats || {};
  const overall = lifetime.overall || {};
  const byBiome = lifetime.by_biome || {};

  const biomeRows = TRAILS_BIOME_ORDER.map((biomeKey) => {
    const row = byBiome[biomeKey] || {};
    return {
      key: biomeKey,
      label: TRAILS_BIOME_LABELS[biomeKey] || biomeKey,
      answered: Number(row.answered || 0),
      correct: Number(row.correct || 0),
      wrong: Number(row.wrong || 0),
      timeouts: Number(row.timeouts || 0),
      stepsCorrect: Number(row.correct || 0),
      accuracy: Number(row.accuracy_pct || 0),
      avgSecondsLeft: Number(row.avg_seconds_left_on_correct || 0),
      lastPlayedAt: row.last_played_at || null
    };
  });

  const playedBiomes = biomeRows.filter((row) => row.answered > 0);
  const strongestCompleteBiomes = playedBiomes.filter((row) => row.answered >= 5);

  const mostPlayed = playedBiomes.slice().sort((a, b) => {
    return b.answered - a.answered || b.correct - a.correct;
  })[0] || null;

  const strongest = (strongestCompleteBiomes.length ? strongestCompleteBiomes : playedBiomes).slice().sort((a, b) => {
    return b.accuracy - a.accuracy || b.correct - a.correct || b.answered - a.answered;
  })[0] || null;

  const topBiome = playedBiomes.slice().sort((a, b) => {
    return b.correct - a.correct || b.answered - a.answered;
  })[0] || null;

  const expanded = Boolean(state.trailsStatsExpanded);

  els.trailsLifetimeToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  if (els.trailsLifetimeChevron) {
    els.trailsLifetimeChevron.textContent = expanded ? '▴' : '▾';
  }

  els.trailsLifetimePanel.hidden = !expanded;

  els.trailsLifetimeSummary.innerHTML = `
    <div class="nw-trails-lifetime-stat">
      <span>Rounds cleared</span>
      <strong>${Number(overall.rounds_completed || 0)}</strong>
    </div>
    <div class="nw-trails-lifetime-stat">
      <span>Total trail steps answered</span>
      <strong>${Number(overall.answered || 0)}</strong>
    </div>
    <div class="nw-trails-lifetime-stat">
      <span>Lifetime accuracy</span>
      <strong>${formatTrailsAccuracy(overall.accuracy_pct || 0)}</strong>
    </div>
    <div class="nw-trails-lifetime-stat">
      <span>Trail steps cleared</span>
      <strong>${Number(overall.correct || 0)}</strong>
    </div>
    <div class="nw-trails-lifetime-stat">
      <span>Most played biome</span>
      <strong>${mostPlayed ? escapeHtml(mostPlayed.label) : '—'}</strong>
    </div>
    <div class="nw-trails-lifetime-stat">
      <span>Strongest biome</span>
      <strong>${strongest ? `${escapeHtml(strongest.label)} • ${strongest.accuracy.toFixed(1)}%` : '—'}</strong>
    </div>
    <div class="nw-trails-lifetime-stat">
      <span>Top biome</span>
      <strong>${topBiome ? `${escapeHtml(topBiome.label)} • ${topBiome.correct} correct` : '—'}</strong>
    </div>
    <div class="nw-trails-lifetime-stat">
      <span>Last trail activity</span>
      <strong>${escapeHtml(formatTrailsDate(overall.last_played_at || null))}</strong>
    </div>
  `;

  els.trailsLifetimeGrid.innerHTML = biomeRows.map((row) => `
    <div class="nw-trails-record-card ${row.answered > 0 ? 'is-active' : ''}">
      <div class="nw-trails-record-card__head">
        <div class="nw-trails-record-card__title">${escapeHtml(row.label)}</div>
        <div class="nw-trails-record-card__pill">
          ${row.answered > 0 ? `${row.accuracy.toFixed(1)}% accuracy` : 'No data yet'}
        </div>
      </div>

      <div class="nw-trails-record-card__stats">
        <div class="nw-trails-record-stat">
          <span>Answered</span>
          <strong>${row.answered}</strong>
        </div>
        <div class="nw-trails-record-stat">
          <span>Correct</span>
          <strong>${row.correct}</strong>
        </div>
        <div class="nw-trails-record-stat">
          <span>Wrong</span>
          <strong>${row.wrong}</strong>
        </div>
        <div class="nw-trails-record-stat">
          <span>Timeouts</span>
          <strong>${row.timeouts}</strong>
        </div>
        <div class="nw-trails-record-stat">
          <span>Correct</span>
          <strong>${row.correct}</strong>
        </div>
        <div class="nw-trails-record-stat">
          <span>Avg time left on correct</span>
          <strong>${row.correct > 0 ? `${row.avgSecondsLeft.toFixed(1)}s` : '—'}</strong>
        </div>
      </div>

      <div class="nw-trails-record-card__footer">
        <div class="nw-trails-record-foot">Last played: <strong>${escapeHtml(formatTrailsDate(row.lastPlayedAt))}</strong></div>
      </div>
    </div>
  `).join('');
}

  function hideTrailsRoundComplete() {
    state.trailsRoundSummary = null;
    if (els.trailsRoundComplete) els.trailsRoundComplete.hidden = true;
  }

  function hideTrailsBiomeComplete() {
    state.trailsBiomeSummary = null;
    if (els.trailsBiomeComplete) els.trailsBiomeComplete.hidden = true;
  }
  async function claimEarnedSwagDrop(claim, button = null) {
    if (!claim || !claim.source) return;

    const originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Claiming...';
    }

    try {
      const body = {
        source: claim.source,
        ...(claim.metadata || {})
      };

      const res = await api('/api/store/claim-earned-swag', 'POST', body);

      if (res.member) {
        state.me = res.member;
        if (Array.isArray(res.member.wolves)) state.wolves = res.member.wolves;
      }

      if (Array.isArray(res.challenges)) state.challengesList = res.challenges;

      renderProfile();
      renderGoalsBalances();
      renderStore();
      finalizeCollectionStoreRender();

      if (typeof updateAwardNotification === 'function') updateAwardNotification();

      const swagUnlocks = Array.isArray(res.swag_unlocks)
        ? res.swag_unlocks
        : (res.swag_unlock ? [res.swag_unlock] : []);

      if (swagUnlocks.length) {
        showSwagUnlockRandomizer(swagUnlocks);
      }
    } catch (err) {
      showAlert(err.message || 'Unable to claim swag.');
      if (button) {
        button.disabled = false;
        button.textContent = originalText || 'Claim Swag';
      }
    }
  }

  async function claimPackXpSwag(button = null) {
    const originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Claiming...';
    }

    try {
      const res = await api('/api/store/claim-pack-xp-swag', 'POST');

      if (res.member) {
        state.me = res.member;
        if (Array.isArray(res.member.wolves)) state.wolves = res.member.wolves;
      }

      if (Array.isArray(res.challenges)) state.challengesList = res.challenges;

      renderProfile();
      renderGoalsBalances();
      renderStore();
      finalizeCollectionStoreRender();

      if (typeof updateAwardNotification === 'function') updateAwardNotification();

      const swagUnlocks = Array.isArray(res.swag_unlocks)
        ? res.swag_unlocks
        : (res.swag_unlock ? [res.swag_unlock] : []);

      if (swagUnlocks.length) {
        showSwagUnlockRandomizer(swagUnlocks);
      }
    } catch (err) {
      showAlert(err.message || 'Unable to claim swag.');
      if (button) {
        button.disabled = false;
        button.textContent = originalText || 'Claim Swag';
      }
    }
  }
  function showTrailsRoundComplete(summary) {
    if (!summary || !els.trailsRoundComplete) return;

    state.trailsRoundSummary = summary;
    hideTrailsBiomeComplete();

    if (els.trailsRoundCompleteRound) {
      els.trailsRoundCompleteRound.textContent = `Round ${Number(summary.round_number || 1)}`;
    }

    if (els.trailsRoundCompleteAccuracy) {
      els.trailsRoundCompleteAccuracy.textContent = formatTrailsAccuracy(summary.accuracy_pct || 0);
    }

    if (els.trailsRoundCompleteScore) {
      els.trailsRoundCompleteScore.textContent = `${Number(summary.correct || 0)}/${Number(summary.total_questions || 40)}`;
    }

    if (els.trailsRoundCompleteBonus) {
      els.trailsRoundCompleteBonus.textContent = `${Number(summary.correct || 0)}/${Number(summary.total_questions || 40)}`;
    }

    if (els.trailsRoundCompleteTotal) {
      els.trailsRoundCompleteTotal.textContent = `🐾 ${Number(summary.pack_xp_awarded || 0)} Pack XP`;
    }

    if (els.trailsRoundCompleteLabel) {
      els.trailsRoundCompleteLabel.textContent = summary.pack_xp_label || 'Pack XP awarded from round accuracy.';
    }

    if (els.trailsRoundCompleteContinue) {
      const hasNextRound = summary.has_next_round !== false;
      els.trailsRoundCompleteContinue.textContent = Number(state.trailsState?.hearts || 0) > 0 && hasNextRound
        ? `Continue to Round ${Number(summary.next_round_number || (Number(summary.round_number || 1) + 1))}`
        : 'Back to Trails Menu';
    }

    state.trailsPendingSwagClaim = summary.swag_claim || null;

    if (els.trailsRoundClaimSwag) {
      const canClaimSwag = !!state.trailsPendingSwagClaim;
      const swagCount = Math.max(1, Number(state.trailsPendingSwagClaim?.unlock_count || 1));

      els.trailsRoundClaimSwag.hidden = !canClaimSwag;
      els.trailsRoundClaimSwag.disabled = false;
      els.trailsRoundClaimSwag.textContent = canClaimSwag
        ? (swagCount > 1 ? `Claim ${swagCount} Swag Items` : 'Claim Swag')
        : 'Claim Swag';
    }

    els.trailsRoundComplete.hidden = false;
  }

  function showTrailsBiomeComplete(summary) {
    if (!summary || !els.trailsBiomeComplete) return;

    state.trailsBiomeSummary = summary;
    hideTrailsRoundComplete();

    if (els.trailsBiomeCompleteTitle) {
      els.trailsBiomeCompleteTitle.textContent = `${summary.biome_label || 'Biome'} cleared`;
    }

    if (els.trailsBiomeCompleteLabel) {
      els.trailsBiomeCompleteLabel.textContent = summary.label || 'You completed this biome route.';
    }

    if (els.trailsBiomeCompleteAccuracy) {
      els.trailsBiomeCompleteAccuracy.textContent = formatTrailsAccuracy(summary.accuracy_pct || 0);
    }

    if (els.trailsBiomeCompleteScore) {
      els.trailsBiomeCompleteScore.textContent = `${Number(summary.correct || 0)}/${Number(summary.total_questions || 5)}`;
    }

    if (els.trailsBiomeCompleteStars) {
      els.trailsBiomeCompleteStars.textContent = `${Number(summary.correct || 0)}/${Number(summary.total_questions || 5)}`;
    }

    if (els.trailsBiomeCompleteNext) {
      els.trailsBiomeCompleteNext.textContent = summary.next_biome_label || 'Next biome';
    }

    els.trailsBiomeComplete.hidden = false;
  }

  function renderTrailsBiomeGrid() {
  if (!els.trailsBiomeGrid) return;

  const trails = state.trailsState || {};
  const currentBiome = trails.current_biome || 'forest';
  const nextBiome = trails.next_biome || 'ocean';
  const currentStep = Number(trails.current_step_in_biome || 0);
  const progressByBiome = trails.round_progress || {};

  let clearedBiomes = 0;

  els.trailsBiomeGrid.innerHTML = TRAILS_BIOME_ORDER.map((biomeKey) => {
    const isCurrent = biomeKey === currentBiome;
    const isNext = biomeKey === nextBiome;
    const tag = isCurrent ? 'Current biome' : isNext ? 'Next biome' : 'On the trail';
    const tagClass = isCurrent ? 'is-current' : '';
    const cardClasses = ['nw-trails-biome-card'];
    if (isCurrent) cardClasses.push('is-clickable');
    if (isCurrent) cardClasses.push('is-current');
    if (isNext) cardClasses.push('is-next');

    const bg = getTrailsBiomeBackground(biomeKey);
    const biomeProgress = Array.isArray(progressByBiome[biomeKey])
      ? progressByBiome[biomeKey]
      : Array(5).fill('pending');

    const hasEnteredBiome = biomeProgress.some((status) => status !== 'pending');
    const isCleared = biomeProgress.every((status) => status !== 'pending');

    if (isCleared) {
      cardClasses.push('is-cleared');
      clearedBiomes += 1;
    }

    const steps = biomeProgress.map((status, index) => {
      const stepClasses = ['nw-trails-biome-card__step'];
      if (status === 'correct') stepClasses.push('is-correct');
      if (status === 'wrong') stepClasses.push('is-wrong');
      if (status === 'pending' && isCurrent && index === currentStep) stepClasses.push('is-current-step');

      const stepText = status === 'correct'
        ? '✓'
        : `${index + 1}`;

      return `<span class="${stepClasses.join(' ')}">${stepText}</span>`;
    }).join('');

    const actionAttrs = isCurrent
      ? `data-action="resume-trail" role="button" tabindex="0" aria-label="Open current biome challenge for ${escapeHtml(TRAILS_BIOME_LABELS[biomeKey] || biomeKey)}"`
      : '';

    return `
      <div class="${cardClasses.join(' ')}" ${actionAttrs} style="background-image:url('${escapeHtml(bg)}')">
        <div class="nw-trails-biome-card__route-dot"></div>
        <div class="nw-trails-biome-card__tag ${tagClass}">${escapeHtml(tag)}</div>
        <div class="nw-trails-biome-card__steps">${steps}</div>
        <div class="nw-trails-biome-card__name">${escapeHtml(TRAILS_BIOME_LABELS[biomeKey] || biomeKey)}</div>
        ${hasEnteredBiome ? `<div class="nw-trails-biome-card__earned">Correct steps: ${biomeProgress.filter((status) => status === 'correct').length} / ${biomeProgress.filter((status) => status !== 'pending').length}</div>` : ''}
        <div class="nw-trails-biome-card__meta">${isCurrent ? 'You are here now' : isNext ? 'Coming up next (LOCKED)' : isCleared ? 'Biome cleared this round' : '(LOCKED)'}</div>
      </div>
    `;
  }).join('');

  if (els.trailsRouteLineFill) {
    const pct = Math.max(0, Math.min(100, (clearedBiomes / TRAILS_BIOME_ORDER.length) * 100));
    els.trailsRouteLineFill.style.width = `${pct}%`;
  }

  if (els.trailsRouteCopy) {
    els.trailsRouteCopy.textContent = `${clearedBiomes}/${TRAILS_BIOME_ORDER.length} biomes cleared this round`;
  }
}

function renderTrailsMenu() {
  const trails = state.trailsState || {};
  const hearts = Number(trails.hearts || 0);
  const hasAvailableRound = trails.has_available_round !== false;
  const unavailableMessage = trails.unavailable_message || 'You have completed every available Trivia Trails round. The next round is not available yet. Stay tuned.';
  const roundNumber = Number(trails.round_number || 1);
  const roundCorrect = Number(trails.round_correct || 0);
  const roundAnswered = Number(trails.round_answered || 0);
  const roundTotalQuestions = Number(trails.round_total_questions || 40);
  const roundAccuracy = roundAnswered > 0 ? (roundCorrect / roundAnswered) * 100 : 0;
  const currentBiome = trails.current_biome_label || 'Forest';
  const nextBiome = trails.next_biome_label || 'Ocean';
  const remaining = Number(trails.questions_until_next_biome || 5);
  const currentStreak = Number(trails.current_streak || 0);
  const bestStreak = Number(trails.best_streak || 0);
  const bests = trails.personal_bests || {};
  const leaderboard = Array.isArray(trails.leaderboard) ? trails.leaderboard : [];

  if (els.trailsHeadRound) els.trailsHeadRound.textContent = String(roundNumber);
  if (els.trailsHeadHearts) els.trailsHeadHearts.textContent = String(hearts);
  if (els.trailsHeadStars) els.trailsHeadStars.textContent = String(getSharedPackXp());
  if (els.trailsHeadPackXp) els.trailsHeadPackXp.textContent = String(getSharedPackXp());



  if (els.trailsMenuNote) {
    const stepsCompleted = Math.max(0, roundAnswered);
    const stepsLeft = Math.max(0, roundTotalQuestions - roundAnswered);
    const answeredCopy = roundAnswered > 0
      ? `<strong>${roundCorrect}/${roundAnswered}</strong> correct so far • <strong>${formatTrailsAccuracy(roundAccuracy)}</strong> accuracy`
      : `No steps answered in this round yet.`;

    els.trailsMenuNote.innerHTML = !hasAvailableRound
      ? `
        <div class="nw-trails-menu-note__mark">✓</div>
        <div class="nw-trails-menu-note__copy">
          <strong>All available rounds completed.</strong>
          <span>${escapeHtml(unavailableMessage)}</span>
        </div>
      `
      : hearts > 0
        ? `
          <div class="nw-trails-menu-note__mark">➜</div>
          <div class="nw-trails-menu-note__copy">
            <strong>Round ${roundNumber} is ready.</strong>
            <span>${answeredCopy} ${stepsCompleted}/${roundTotalQuestions} trail steps complete, with ${stepsLeft} left in the full route. Current biome: <strong>${escapeHtml(currentBiome)}</strong>${remaining > 0 ? `, ${remaining} step${remaining === 1 ? '' : 's'} before ${escapeHtml(nextBiome)}.` : '.'}</span>
          </div>
        `
        : `
          <div class="nw-trails-menu-note__mark">♡</div>
          <div class="nw-trails-menu-note__copy">
            <strong>You need a heart to enter the trail.</strong>
            <span>Open the Heart Chest on the Den home page to claim +1 heart, then return here to continue.</span>
          </div>
        `;
  }

  if (els.trailsBestGrid) {
    const currentRunLabel = roundAnswered > 0
      ? `${roundCorrect}/${roundAnswered} • ${formatTrailsAccuracy(roundAccuracy)}`
      : 'Not started';

    const currentRunNote = roundAnswered > 0
      ? `${Math.max(0, roundTotalQuestions - roundAnswered)} trail steps left in this round.`
      : `Start the ${roundTotalQuestions}-step route to build your score.`;

    const bestRoundLabel = bests.best_round_accuracy_label || bests.best_forest_accuracy_label || '—';
    const bestRoundNote = bests.best_round_score_label || 'Complete a full round to set this mark.';
    const bestBiomeLabel = bests.best_biome_accuracy_label || '—';
    const bestBiomeName = bests.best_biome_name || 'Best biome';
    const cleanestRunLabel = bests.best_no_miss_run_label || '—';

    els.trailsBestGrid.innerHTML = `
      <div class="nw-trails-best-card nw-trails-best-card--current">
        <span>Current round</span>
        <strong>${escapeHtml(currentRunLabel)}</strong>
        <small>${escapeHtml(currentRunNote)}</small>
      </div>

      <div class="nw-trails-best-card">
        <span>Best full round</span>
        <strong>${escapeHtml(bestRoundLabel)}</strong>
        <small>${escapeHtml(bestRoundNote)}</small>
      </div>

      <div class="nw-trails-best-card">
        <span>Cleanest streak</span>
        <strong>${escapeHtml(cleanestRunLabel)}</strong>
        <small>Most correct trail steps before a miss or timeout.</small>
      </div>

      <div class="nw-trails-best-card">
        <span>${escapeHtml(bestBiomeName)}</span>
        <strong>${escapeHtml(bestBiomeLabel)}</strong>
        <small>${escapeHtml(bests.best_biome_score_label || 'Best biome accuracy so far.')}</small>
      </div>

      <div class="nw-trails-best-card">
        <span>Furthest trail</span>
        <strong>${escapeHtml(bests.highest_round_reached_label || '—')}</strong>
        <small>Highest Trivia Trails round reached.</small>
      </div>
    `;
  }

  if (els.trailsBoardList) {
    els.trailsBoardList.innerHTML = leaderboard.length
      ? leaderboard.map((row, index) => {
          const accuracyLabel = row.best_round_accuracy_label || (
            Number(row.best_round_accuracy_pct || 0) > 0
              ? `${Number(row.best_round_accuracy_pct || 0).toFixed(1)}%`
              : '—'
          );

          const scoreLabel = row.best_round_score_label || (
            Number(row.best_round_correct || 0) > 0
              ? `${Number(row.best_round_correct || 0)}/${Number(row.best_round_answered || 40)} best round`
              : 'No completed round yet'
          );

          const roundLabel = Number(row.highest_round_reached || 0) > 0
            ? `Round ${Number(row.highest_round_reached || 0)}`
            : 'Round —';

          const streakLabel = Number(row.best_streak || 0) > 0
            ? `Best streak ${Number(row.best_streak || 0)}`
            : 'No streak yet';

          return `
            <div class="nw-trails-board-row">
              <div class="nw-trails-board-rank">#${index + 1}</div>
              <div class="nw-trails-board-name">
                <strong>${escapeHtml(row.pack_name || 'Pack member')}</strong>
                <small>${escapeHtml(roundLabel)} • ${escapeHtml(scoreLabel)} • ${escapeHtml(streakLabel)}</small>
              </div>
              <div class="nw-trails-board-stat">
                <strong>${escapeHtml(accuracyLabel)}</strong>
                <span>best round</span>
              </div>
            </div>
          `;
        }).join('')
      : `<div class="nw-trails-best-card nw-trails-empty-board"><strong>No Trails paceboard data yet.</strong><small>Complete a round to put the first mark on the board.</small></div>`;
  }

  if (els.trailsStartBtn) {
    els.trailsStartBtn.disabled = !hasAvailableRound || hearts < 1;
    els.trailsStartBtn.textContent = !hasAvailableRound
      ? 'Next Round Coming Soon'
      : trails.active_question
        ? 'Resume Active Question'
        : `Start Round ${roundNumber} Step`;
    els.trailsStartBtn.classList.toggle('is-star-locked', !hasAvailableRound || hearts < 1);
  }

  renderTrailsBiomeGrid();
  renderTrailsLifetimeStats();
  setTrailsScreen('menu');
}

  function startTrailsTimer(deadlineMs) {
    clearTrailsTimer();
    if (typeof playTriviaTick === 'function') playTriviaTick();

    const initialRemainingMs = Math.max(0, Number(deadlineMs) - Date.now());
    const totalMs = Math.max(1, initialRemainingMs);

    if (els.trailsStage) {
      els.trailsStage.classList.remove('is-time-low', 'is-time-urgent');
    }

    if (els.trailsTimerCount) {
      els.trailsTimerCount.textContent = `${(initialRemainingMs / 1000).toFixed(1)}s`;
    }

    const tick = () => {
      const remainingMs = Math.max(0, Number(deadlineMs) - Date.now());
      const pct = Math.max(0, Math.min(1, remainingMs / totalMs));

      if (els.trailsTimerCount) {
        els.trailsTimerCount.textContent = `${(remainingMs / 1000).toFixed(1)}s`;
      }

      const isLow = pct <= 0.42;
      const isUrgent = pct <= 0.18;

      if (els.trailsStage) {
        els.trailsStage.classList.toggle('is-time-low', isLow && !isUrgent);
        els.trailsStage.classList.toggle('is-time-urgent', isUrgent);
      }

      if (remainingMs <= 0) {
        clearTrailsTimer();
        if (!state.trailsSubmitting) {
          submitTrailsAnswer(-1);
        }
        return;
      }

      state.trailsTimerId = requestAnimationFrame(tick);
    };

    tick();
  }

  function renderTrailsQuestion() {
    const q = state.trailsQuestion;
    if (!q) return;

    hideTrailsRoundComplete();
    hideTrailsBiomeComplete();
    applyTrailsBackground(q.biome);

    const roundNumber = Number(state.trailsState?.round_number || 1);
    const roundCorrect = Number(state.trailsState?.round_correct || 0);
    const roundAnswered = Number(state.trailsState?.round_answered || 0);
    const roundAccuracy = roundAnswered > 0 ? (roundCorrect / roundAnswered) * 100 : 0;
    const currentBiomeQuestion = Math.max(1, Math.min(5, 6 - Number(q.questions_until_next_biome || state.trailsState?.questions_until_next_biome || 5)));
    const currentStreak = Number(state.trailsState?.current_streak || 0);
    const biomeLabel = q.biome_label || 'Forest';
    const nextBiomeLabel = q.next_biome_label || 'Finish the route';

    if (els.trailsStage) {
      els.trailsStage.classList.remove('is-answer-correct', 'is-answer-wrong', 'is-time-low', 'is-time-urgent');
      els.trailsStage.classList.add('is-question-live');
    }

    if (els.trailsHeadRound) els.trailsHeadRound.textContent = String(roundNumber);
if (els.trailsHeadHearts) els.trailsHeadHearts.textContent = String(Number(q.hearts_left || state.trailsState?.hearts || 0));
if (els.trailsHeadStars) els.trailsHeadStars.textContent = String(getSharedPackXp());
if (els.trailsHeadPackXp) els.trailsHeadPackXp.textContent = String(getSharedPackXp());

    if (els.trailsGameRound) {
      els.trailsGameRound.textContent = `Round ${roundNumber}`;
    }

    if (els.trailsGameBiome) {
      els.trailsGameBiome.textContent = `${biomeLabel} • ${currentBiomeQuestion}/5`;
    }

    if (els.trailsGameNextBiome) {
      els.trailsGameNextBiome.textContent = `Next biome: ${nextBiomeLabel}`;
    }

    if (els.trailsGameQuestionNumber) {
      els.trailsGameQuestionNumber.textContent = `Score ${roundCorrect}/${roundAnswered} • ${formatTrailsAccuracy(roundAccuracy)} • Streak ${currentStreak}`;
    }

    if (els.trailsQuestionText) els.trailsQuestionText.textContent = q.prompt || '';

    if (els.trailsFeedback) {
      els.trailsFeedback.hidden = true;
      els.trailsFeedback.innerHTML = '';
    }

    if (els.trailsNextBtn) {
      els.trailsNextBtn.hidden = true;
      els.trailsNextBtn.disabled = false;
      els.trailsNextBtn.textContent = 'Continue Trail';
      els.trailsNextBtn.classList.remove('is-round-complete');
    }

    if (els.trailsAnswers) {
      els.trailsAnswers.innerHTML = '';
      const labels = ['A', 'B', 'C', 'D'];

      (q.choices || []).forEach((choice, index) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'nw-trivia-answer nw-trails-answer';
        btn.dataset.index = String(index);
        btn.setAttribute('aria-label', `${labels[index] || index + 1}: ${choice}`);

        const labelSpan = document.createElement('div');
        labelSpan.className = 'nw-trivia-answer-label';
        labelSpan.textContent = labels[index] || String(index + 1);

        const textSpan = document.createElement('div');
        textSpan.className = 'nw-trivia-answer-text';
        textSpan.textContent = choice;

        btn.appendChild(labelSpan);
        btn.appendChild(textSpan);
        btn.addEventListener('click', () => submitTrailsAnswer(index));
        els.trailsAnswers.appendChild(btn);
      });
    }

    setTrailsScreen('game');

    const shell = els.trailsStage ? els.trailsStage.closest('.nw-trails-shell') : null;
    if (shell) {
      shell.scrollTo({ top: 0, behavior: 'smooth' });
    }

    startTrailsTimer(q.deadline_ms);
  }

  async function loadTrailsState() {
    hideTrailsRoundComplete();
    hideTrailsBiomeComplete();
    const res = await api('/api/games/trails/state');
    state.trailsState = res.trivia_trails || res.trails || null;
    state.trailsQuestion = state.trailsState?.active_question || null;
    renderTrailsMenu();

    if (state.trailsQuestion) {
      renderTrailsQuestion();
    }
  }

  async function openTrailsModal() {
    hideAlert();

    if (!requireComingSoonPassword()) return;

    document.documentElement.classList.add('nw-modal-open');
    document.body.classList.add('nw-modal-open');

    if (els.goalsModal) els.goalsModal.hidden = true;
    if (els.trailsModal) els.trailsModal.hidden = false;
    if (els.backdrop) els.backdrop.hidden = false;
    await loadTrailsState();
  }

  function closeTrailsModal(reopenGames = true) {
    clearTrailsTimer();
    hideTrailsRoundComplete();
    state.trailsSubmitting = false;
    state.trailsQuestion = null;

    if (els.trailsModal) els.trailsModal.hidden = true;

    document.documentElement.classList.remove('nw-modal-open');
    document.body.classList.remove('nw-modal-open');

    if (reopenGames) {
      openGoalsModalToTab('games');
      return;
    }

    forceUnlockPageAfterModalClose();
  }

  async function startNextTrailsQuestion() {
    if (state.trailsSubmitting) return;
    hideAlert();
    hideTrailsRoundComplete();
    hideTrailsBiomeComplete();

    if (state.trailsState?.has_available_round === false) {
      showAlert(state.trailsState?.unavailable_message || 'You have completed every available Trivia Trails round. The next round is not available yet. Stay tuned.');
      renderTrailsMenu();
      return;
    }

    try {
      const res = await api('/api/games/trails/start-question', 'POST', {});
      state.trailsState = res.trivia_trails || res.trails || state.trailsState;
      state.trailsQuestion = res.question || state.trailsState?.active_question || null;
      renderTrailsQuestion();
    } catch (err) {
      showAlert(err.message || 'Unable to start the trail question.');
    }
  }

  async function submitTrailsAnswer(choiceIndex) {
    if (state.trailsSubmitting || !state.trailsQuestion) return;
    state.trailsSubmitting = true;
    clearTrailsTimer();

    try {
      const res = await api('/api/games/trails/answer', 'POST', {
        choice_index: Number(choiceIndex)
      });

      const buttons = els.trailsAnswers
        ? Array.from(els.trailsAnswers.querySelectorAll('.nw-trivia-answer'))
        : [];

      revealTriviaAnswerResult(buttons, res.result || {}, choiceIndex);

      if (res.result?.correct) {
        if (typeof safePlay === 'function' && typeof triviaCorrectAudio !== 'undefined') safePlay(triviaCorrectAudio);
      } else {
        if (typeof safePlay === 'function' && typeof triviaIncorrectAudio !== 'undefined') safePlay(triviaIncorrectAudio);
      }

      state.me = res.member || state.me;
      const answeredQuestion = state.trailsQuestion;
      state.trailsState = res.trivia_trails || state.trailsState;
      state.trailsQuestion = null;
const trailsEarnedNow = Number(res.result?.earned_now || 0);

if (state.me) {
  state.me.available_stars = 0;
  state.me.all_time_stars = 0;
}
      renderProfile();
      renderGoalsBalances();
      syncVisibleBalances();

      if (els.trailsHeadRound) els.trailsHeadRound.textContent = String(Number(state.trailsState?.round_number || 1));
if (els.trailsHeadHearts) els.trailsHeadHearts.textContent = String(Number(state.trailsState?.hearts || 0));
if (els.trailsHeadStars) els.trailsHeadStars.textContent = String(getSharedPackXp());
if (els.trailsHeadPackXp) els.trailsHeadPackXp.textContent = String(getSharedPackXp());

      if (els.trailsFeedback) {
        const earned = Number(res.result?.earned_now || 0);
        const secondsLeft = Number(res.result?.seconds_left || 0);
        const correctText = res.result?.correct_answer_text || '';
        const fact = res.result?.fact || '';
        const heartsLeft = Number(res.trivia_trails?.hearts || 0);
        const currentStreak = Number(res.trivia_trails?.current_streak || 0);

        const timedOut = Number(choiceIndex) < 0 && !res.result?.correct;
        const resultHeading = res.result?.correct
          ? 'Correct'
          : timedOut
            ? 'Incorrect. Time ran out.'
            : 'Incorrect';

        if (els.trailsStage) {
          els.trailsStage.classList.remove('is-question-live', 'is-time-low', 'is-time-urgent');
          els.trailsStage.classList.add(res.result?.correct ? 'is-answer-correct' : 'is-answer-wrong');
        }

        els.trailsFeedback.hidden = false;
        els.trailsFeedback.innerHTML = `
          <div class="nw-trails-feedback__head">
            <strong>${resultHeading}</strong>
            ${res.result?.correct ? `<span>+${earned} Pack XP</span>` : `<span>Trail step recorded</span>`}
          </div>

          <div class="nw-trails-feedback__body">
            ${timedOut ? '<p>No answer was submitted before the clock expired.</p>' : ''}
            ${res.result?.correct ? `<p>You cleared this trail step with <strong>${secondsLeft}</strong> second${secondsLeft === 1 ? '' : 's'} left.</p>` : ''}
            ${!res.result?.correct ? `<p>The correct answer was <strong>${escapeHtml(correctText)}</strong>.</p>` : ''}
            ${fact ? `<p><strong>Field note:</strong> ${escapeHtml(fact)}</p>` : ''}
          </div>

          <div class="nw-trails-feedback__meta">
            <span>❤️ Hearts ${heartsLeft}</span>
            <span>🔥 Streak ${currentStreak}</span>
          </div>
        `;
      }

      const previousQuestion = answeredQuestion;
      const pendingRoundSummary = res.result?.round_complete || null;
      const justFinishedBiome = previousQuestion && Number(previousQuestion.questions_until_next_biome || 0) === 1 && !pendingRoundSummary;
      let pendingBiomeSummary = null;

      if (justFinishedBiome) {
        const clearedBiome = previousQuestion.biome_label || 'Biome';
        const nextBiomeLabel = res.trivia_trails?.current_biome_label || previousQuestion.next_biome_label || 'Next biome';
        const updatedRoundProgress = res.trivia_trails?.round_progress || {};
        const updatedBiomeStatuses = Array.isArray(updatedRoundProgress[previousQuestion.biome]) ? updatedRoundProgress[previousQuestion.biome] : [];
        const biomeCorrect = updatedBiomeStatuses.filter((status) => status === 'correct').length;
        const biomeAnswered = updatedBiomeStatuses.filter((status) => status !== 'pending').length;
        const biomeAccuracy = biomeAnswered > 0 ? (biomeCorrect / biomeAnswered) * 100 : 0;

        pendingBiomeSummary = {
          biome_label: clearedBiome,
          label: `You cleared the ${clearedBiome} route. Next stop: ${nextBiomeLabel}.`,
          accuracy_pct: biomeAccuracy,
          correct: biomeCorrect,
          total_questions: biomeAnswered || 5,
          next_biome_label: nextBiomeLabel
        };
      }

      state.trailsRoundSummary = pendingRoundSummary;
      state.trailsBiomeSummary = pendingBiomeSummary;

      if (els.trailsNextBtn) {
        els.trailsNextBtn.hidden = false;
        els.trailsNextBtn.classList.toggle('is-round-complete', !!pendingRoundSummary);
        els.trailsNextBtn.classList.toggle('is-biome-complete', !!pendingBiomeSummary);

        if (pendingRoundSummary) {
          els.trailsNextBtn.textContent = 'View Round Results';
        } else if (pendingBiomeSummary) {
          els.trailsNextBtn.textContent = 'View Biome Results';
        } else {
          els.trailsNextBtn.textContent = Number(state.trailsState?.hearts || 0) > 0 ? 'Continue Trail' : 'Return to Trails Menu';
        }
      }

      state.trailsSubmitting = false;
    } catch (err) {
      showAlert(err.message || 'Unable to submit the trail answer.');
      state.trailsSubmitting = false;
    }
  }



  function renderGamesList() {
    if (!els.gcGamesList) return;

    els.gcGamesList.innerHTML = `
      <div class="nw-arcade-shell">
        <section class="nw-arcade-hero">
          <div class="nw-arcade-hero__copy">
            <div class="nw-arcade-hero__eyebrow">Nature games</div>
            <h3>Choose a wild challenge.</h3>
            <p>Play through wildlife questions, simulator runs, and future Den game modes. Use hearts to enter select challenges, earn Pack XP, and bring rewards back to your Pack.</p>
          </div>

          
        </section>

        <div class="nw-arcade-grid">
          <article class="nw-arcade-card nw-arcade-card--trails">
            <div class="nw-arcade-card__glow"></div>

            <div class="nw-arcade-card__top">
              <div class="nw-arcade-card__icon" aria-hidden="true">TT</div>
              <div class="nw-arcade-card__status">Live</div>
            </div>

            <div class="nw-arcade-card__eyebrow">Trail mode</div>
            <h3>Trivia Trails</h3>
            <p class="nw-arcade-card__desc">Walk a biome-by-biome wildlife route. Answer timed questions, learn as you go, and bring Pack XP back from the trail.</p>

            

            <div class="nw-arcade-metric-grid">
              <div class="nw-arcade-metric">
                <span>Format</span>
                <strong>Biome trail</strong>
              </div>
              <div class="nw-arcade-metric">
                <span>Timer</span>
                <strong>15s</strong>
              </div>
              <div class="nw-arcade-metric">
                <span>Entry</span>
                <strong>1 heart</strong>
              </div>
            </div>

            <button id="nw-open-trivia-trails-btn" class="nw-btn nw-btn--primary nw-arcade-card__cta" type="button">
              Open Trivia Trails
            </button>
          </article>

          <article class="nw-arcade-card nw-arcade-card--sim">
            <div class="nw-arcade-card__glow"></div>

            <div class="nw-arcade-card__top">
              <div class="nw-arcade-card__icon" aria-hidden="true">PS</div>
              <div class="nw-arcade-card__status">Live</div>
            </div>

            <div class="nw-arcade-card__eyebrow">Simulation mode</div>
            <h3>Pack Simulator</h3>
            <p class="nw-arcade-card__desc">Send your Pack into a timed wildlife run. Catch prey, manage pressure, earn Pack XP, and unlock reward chances for your collection.</p>

            

            <div class="nw-arcade-metric-grid">
              <div class="nw-arcade-metric">
                <span>Format</span>
                <strong>Timed run</strong>
              </div>
              <div class="nw-arcade-metric">
                <span>Uses</span>
                <strong>Your wolves</strong>
              </div>
              <div class="nw-arcade-metric">
                <span>Entry</span>
                <strong>1 heart</strong>
              </div>
            </div>

            <button id="nw-open-pack-sim-btn" class="nw-btn nw-btn--primary nw-arcade-card__cta" type="button">
              Open Pack Simulator
            </button>
          </article>
        </div>
      </div>
    `;

    const trailsLaunchBtn = document.getElementById('nw-open-trivia-trails-btn');
    if (trailsLaunchBtn) {
      trailsLaunchBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openTrailsModal();
      });
    }

    const simLaunchBtn = document.getElementById('nw-open-pack-sim-btn');
    if (simLaunchBtn) {
      simLaunchBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openSimModal();
      });
    }
  }


    function renderChallengesList() {
    if (!els.goalsList) return;
    els.goalsList.innerHTML = '';

    const challenges = Array.isArray(state.challengesList) ? state.challengesList : [];
    const activeFilter = String(state.gcChallengeFilter || 'all');
    const successfulReferralCount = getSuccessfulReferralCount();
    const shouldShowReferralStarter = activeFilter === 'referrals' && successfulReferralCount <= 0;

    const categoryFiltered = activeFilter === 'referrals'
      ? challenges.filter((c) => c.category === 'referral')
      : activeFilter === 'completed'
        ? challenges.filter((c) => c.status === 'completed')
        : challenges;

    const visible = activeFilter === 'completed'
      ? [...categoryFiltered]
      : categoryFiltered.filter((c) => c.status !== 'completed');

    const statusPriority = {
      available: 0,
      in_progress: 1,
      completed: 2
    };

    visible.sort((a, b) => {
      const aPriority = statusPriority[a.status] ?? 1;
      const bPriority = statusPriority[b.status] ?? 1;

      if (aPriority !== bPriority) return aPriority - bPriority;

      return String(a.title || '').localeCompare(String(b.title || ''));
    });

    const totalCount = categoryFiltered.length;
    const readyCount = categoryFiltered.filter((c) => c.status === 'available').length;
    const completedCount = categoryFiltered.filter((c) => c.status === 'completed').length;
    const inProgressCount = Math.max(0, totalCount - readyCount - completedCount);
    const completionPct = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;
    const isCompletedView = activeFilter === 'completed';
    const filterLabel =
      activeFilter === 'referrals'
        ? 'Referral rewards'
        : activeFilter === 'completed'
          ? 'Completed achievements'
          : 'All achievements';

    const overviewHeadline = isCompletedView
      ? (completedCount > 0
          ? `${completedCount} completed achievement${completedCount === 1 ? '' : 's'}`
          : 'No completed achievements yet')
      : (readyCount > 0
          ? `${readyCount} reward${readyCount === 1 ? '' : 's'} ready to claim`
          : 'No rewards waiting right now');

    const overviewSubcopy = isCompletedView
      ? 'Showing only finished rewards.'
      : `${completedCount.toLocaleString()} of ${totalCount.toLocaleString()} achievement${totalCount === 1 ? '' : 's'} completed.`;

    const progressCopyRight = isCompletedView
      ? `${completedCount.toLocaleString()} completed`
      : `${inProgressCount.toLocaleString()} still in progress`;

    const overview = document.createElement('div');
    overview.className = 'nw-achievements-overview';
    overview.innerHTML = `
      <div class="nw-achievements-overview__main">
        <div class="nw-achievements-overview__eyebrow">${escapeHtml(filterLabel)}</div>
        <strong>${escapeHtml(overviewHeadline)}</strong>
        <span>${escapeHtml(overviewSubcopy)}</span>

        <div class="nw-achievements-progress-track" aria-label="Achievement completion progress">
          <span style="width:${completionPct}%"></span>
        </div>

        <div class="nw-achievements-progress-copy">
          <b>${completionPct}% complete</b>
          <small>${escapeHtml(progressCopyRight)}</small>
        </div>
      </div>
    `;
    els.goalsList.appendChild(overview);

    if (shouldShowReferralStarter) {
      const starterWrap = document.createElement('div');
      starterWrap.innerHTML = buildReferralStarterCardHtml();
      const starterCard = starterWrap.firstElementChild;

      if (starterCard) {
        els.goalsList.appendChild(starterCard);
      }
    }

    const listWrap = document.createElement('div');
    listWrap.className = 'nw-achievements-list';

    if (!visible.length) {
      listWrap.innerHTML = `
        <div class="nw-empty nw-gc-empty">
          <div class="nw-gc-empty__eyebrow">All caught up</div>
          <strong>No achievements to show right now.</strong>
          <span>Complete Pack activities or turn on “Show completed” to review finished rewards.</span>
        </div>
      `;
      els.goalsList.appendChild(listWrap);
      return;
    }

    visible.forEach((def) => {
      const safeStatus = def.status === 'available' || def.status === 'completed'
        ? def.status
        : 'in_progress';

      const item = document.createElement('article');
      item.className = `nw-goal-item nw-achievement-card nw-achievement-card--${safeStatus} nw-goal-item--${safeStatus}`;

      const rewardLabel = def.reward_label || `Reward: ${Number(def.pack_xp || 0)} Pack XP`;
      const rewardAmount = Number(def.pack_xp || 0);
      const rewardText = String(rewardLabel || '').replace(/^Reward:\s*/i, '');
      const categoryLabel = def.category === 'referral' ? 'Referral' : 'Achievement';
      const statusLabel =
        safeStatus === 'completed'
          ? 'Completed'
          : safeStatus === 'available'
            ? 'Ready to claim'
            : 'In progress';

      const statusIcon =
        safeStatus === 'completed'
          ? '✓'
          : safeStatus === 'available'
            ? '✦'
            : '•';

      const progressLabel = def.progress_label || '';
      const description = def.description || progressLabel || 'Keep moving through the Den to finish this milestone.';

      item.innerHTML = `
        <div class="nw-achievement-card__mark nw-achievement-card__mark--${safeStatus}" aria-hidden="true">${statusIcon}</div>

        <div class="nw-goal-info nw-achievement-card__info">
          <div class="nw-achievement-card__top">
            <div class="nw-achievement-card__main">
              <div class="nw-achievement-card__eyebrow">${escapeHtml(categoryLabel)}</div>
              <strong class="nw-achievement-card__title">${escapeHtml(def.title || 'Achievement')}</strong>
            </div>

            <span class="nw-achievement-card__pill nw-achievement-card__pill--${safeStatus}">${escapeHtml(statusLabel)}</span>
          </div>

          <p class="nw-achievement-card__desc">${escapeHtml(description)}</p>

          <div class="nw-achievement-card__compact-meta">
            ${progressLabel ? `<span>${escapeHtml(progressLabel)}</span>` : ''}
            <span>${escapeHtml(rewardText)}</span>
          </div>
        </div>

        <div class="nw-achievement-card__reward">
          <span>Reward</span>
          <strong>${rewardAmount > 0 ? rewardAmount.toLocaleString() : '—'}</strong>
          <small>Pack XP</small>
        </div>

        <div class="nw-goal-actions nw-achievement-card__actions"></div>
      `;

      const actionsDiv = item.querySelector('.nw-achievement-card__actions');

      if (safeStatus === 'available') {
        const btn = document.createElement('button');
        btn.className = 'nw-btn nw-btn--primary nw-goal-claim-btn nw-achievement-card__claim';
        btn.type = 'button';

        const award = (state.pendingAwards || []).find((a) => a.reason === def.id || a.id === def.award_id);
        const receivePackXp = Number(award?.pack_xp ?? def.pack_xp ?? 0);

        btn.textContent = receivePackXp > 0
          ? `Claim ${receivePackXp.toLocaleString()} XP`
          : 'Claim';

        btn.addEventListener('click', () => {
          const award = (state.pendingAwards || []).find((a) => a.reason === def.id || a.id === def.award_id);
          if (!award) {
            showAlert('That reward is no longer available.');
            return;
          }

          state.currentAward = award;
          state.currentAwardSource = 'goals';
          state.currentAwardTriggerBtn = btn;

          claimCurrentAward().then(() => {
            fetchGamesAndChallenges().then(() => {
              updateGoalsList();
            });
          });
        });

        actionsDiv.appendChild(btn);
      } else {
        const status = document.createElement('span');
        status.className = `nw-goal-status nw-goal-status--${safeStatus}`;
        status.textContent = statusLabel;
        actionsDiv.appendChild(status);
      }

      listWrap.appendChild(item);
    });

    els.goalsList.appendChild(listWrap);
  }

  function updateGoalsList() {
    if (state.gcActiveTab === 'games') {
      renderGamesList();
      return;
    }
    renderChallengesList();
  }

  async function fetchGamesAndChallenges() {
    const meRes = await api('/api/me');
    state.me = meRes.member || meRes.user || meRes.profile || state.me;
    state.pendingAwards = Array.isArray(meRes.pending_awards) ? meRes.pending_awards : [];
    state.challengesList = Array.isArray(meRes.challenges) ? meRes.challenges : [];
    state.treasureChest = meRes.treasure_chest || state.treasureChest;

    try {
      const trailsRes = await api('/api/games/trails/state');
      const trails = trailsRes.trivia_trails || trailsRes.trails || null;
      if (trails) {
        state.trailsState = trails;
        if (state.me) state.me.trivia_trails = trails;
      }
    } catch (e) {}

    renderProfile();
    renderGoalsBalances();
    renderPackReferralCard();
    renderQuickAccessStates();
    updateAwardNotification();
  }

  async function openGoalsModal() {
    if (!els.goalsModal) return;

    document.documentElement.classList.add('nw-modal-open');
    document.body.classList.add('nw-modal-open');

    await fetchGamesAndChallenges();
    setGcTab(state.gcActiveTab || 'games');

    els.goalsModal.hidden = false;
    if (els.backdrop) els.backdrop.hidden = false;

    const modalCard = els.goalsModal.querySelector('.nw-gc-modal-card');
    if (modalCard) modalCard.scrollTop = 0;
  }

  function closeGoalsModal() {
    if (!els.goalsModal) return;

    els.goalsModal.hidden = true;
    if (els.backdrop) els.backdrop.hidden = true;

    document.documentElement.classList.remove('nw-modal-open');
    document.body.classList.remove('nw-modal-open');
  }

  function currentWolfMeta() {
    return member()?.current_wolf || member()?.rank || { name: 'Pup', image_url: '' };
  }

  function getMainStageWolves() {
    return Array.isArray(state.wolves) ? state.wolves : [];
  }

  function getMainStagePreviewIndex(defaultRankKey = null) {
    const wolves = getMainStageWolves();
    if (!wolves.length) return 0;

    if (!Number.isInteger(state.mainWolfPreviewIndex)) {
      const currentIndex = wolves.findIndex((wolf) => wolf.rank_key === defaultRankKey || wolf.is_current);
      state.mainWolfPreviewIndex = currentIndex >= 0 ? currentIndex : 0;
    }

    if (state.mainWolfPreviewIndex < 0 || state.mainWolfPreviewIndex >= wolves.length) {
      state.mainWolfPreviewIndex = 0;
    }

    return state.mainWolfPreviewIndex;
  }

  function getMainStagePreviewWolf(defaultRankKey = null) {
    const wolves = getMainStageWolves();
    if (!wolves.length) return null;
    const index = getMainStagePreviewIndex(defaultRankKey);
    return wolves[index] || wolves[0] || null;
  }

  function cycleMainStageWolf(direction = 1) {
    const wolves = getMainStageWolves();
    if (wolves.length <= 1) return;

    const currentIndex = getMainStagePreviewIndex();
    const total = wolves.length;
    state.mainWolfPreviewIndex = (currentIndex + direction + total) % total;
    renderProfile();
  }

  function renderProfile() {
    const me = member();
    if (!me) return;

    syncVisibleBalances();

    const rank = me.current_wolf || me.rank || { name: '', image_url: '' };
    const currentWolf = Array.isArray(state.wolves)
      ? state.wolves.find((wolf) => wolf.is_current) || state.wolves[0] || null
      : null;

    const previewWolf = getMainStagePreviewWolf(currentWolf?.rank_key || rank.key) || currentWolf;
    const previewLayout = JSON.parse(JSON.stringify(previewWolf?.equipped_items || me.equipped_items || []));
    const currentLayout = JSON.parse(JSON.stringify(currentWolf?.equipped_items || me.equipped_items || []));

    if (els.baseWolf) {
      els.baseWolf.src = (previewWolf?.base_image_url || currentWolf?.base_image_url || rank.image_url || '');
    }
    if (els.editorBaseWolf) {
      els.editorBaseWolf.src = (currentWolf?.base_image_url || rank.image_url || '');
    }

    const accountName = me.pack_name || 'Pack Member';
    if (els.profileWelcome) {
      els.profileWelcome.textContent = accountName;
    }
    if (els.packNameDisplay) {
      els.packNameDisplay.textContent = accountName;
    }

    const stagePrevBtn = document.getElementById('nw-stage-prev');
    const stageNextBtn = document.getElementById('nw-stage-next');
    const wolvesCount = getMainStageWolves().length;
    const disableStageNav = wolvesCount <= 1;

    if (stagePrevBtn) {
      stagePrevBtn.disabled = disableStageNav;
      if (!stagePrevBtn.dataset.bound) {
        stagePrevBtn.dataset.bound = '1';
        stagePrevBtn.addEventListener('click', () => cycleMainStageWolf(-1));
      }
    }

    if (stageNextBtn) {
      stageNextBtn.disabled = disableStageNav;
      if (!stageNextBtn.dataset.bound) {
        stageNextBtn.dataset.bound = '1';
        stageNextBtn.addEventListener('click', () => cycleMainStageWolf(1));
      }
    }

    const available = 0;
const allTime = 0;
const packXp = Number(me.pack_xp || 0);
const packPosition = Number(me.pack_position || 0);
const nextTarget = me.next_pack_target || null;

    syncCollectionHeaderCounts();
    els.nextRank.textContent = packPosition > 0 ? `#${packPosition}` : '#-';
    renderHomePackRail();

    if (packPosition === 1 || !nextTarget) {
  els.progressCopy.textContent = `You lead the Pack right now!`;
} else {
  const needed = Math.max(1, (Number(nextTarget.pack_xp || 0) - packXp) + 1);
  els.progressCopy.textContent = `${needed.toLocaleString()} more Pack XP to pass the next rank.`;
}

    me.equipped_items = JSON.parse(JSON.stringify(currentLayout));
    me.equipped_count = currentLayout.length;

    if (els.stage) {
      renderStage(els.stage, previewLayout || []);
    }

    if (!els.customizeModal || els.customizeModal.hidden) {
      state.editorLayout = JSON.parse(JSON.stringify(currentLayout || []));
      renderStage(els.editorStage, state.editorLayout, true);
    }

    state.lastRenderedRankKey = currentWolf?.rank_key || rank.key;

    renderOwnedList();
    renderStore();
    renderGoalsBalances();
  }

  function renderPack() {
    if (!els.packList) return;

    els.packList.innerHTML = '';

    if (!state.pack.length) {
      els.packList.innerHTML = '<div class="nw-empty">No active Pack members yet.</div>';
      return;
    }

    const preview = state.pack.slice(0, 5);

    preview.forEach((m, index) => {
      const absoluteRank = ((state.packPage - 1) * state.packPageSize) + index + 1;
      const packXpAmount = Number(m.pack_xp ?? 0);
      const lifetimeStars = Number(m.all_time_stars ?? 0);

      const row = document.createElement('div');
      row.className = 'nw-pack-item';
      row.innerHTML = `
        <div class="nw-pack-item__member">
          <button class="nw-pack-member-trigger" type="button">#${absoluteRank} ${escapeHtml(m.pack_name || 'Subscriber (No name yet)')}</button>
          <div class="nw-meta">🐾 ${packXpAmount.toLocaleString()} Pack XP</div>
        </div>

        <div class="nw-pack-score" aria-label="${packXpAmount.toLocaleString()} Pack XP">
          <strong>${packXpAmount.toLocaleString()}</strong>
          <span>Pack XP</span>
        </div>
      `;

      const trigger = row.querySelector('.nw-pack-member-trigger');
      if (trigger) {
        trigger.addEventListener('click', () => openPackMemberModal(m.id));
      }

      els.packList.appendChild(row);
    });

    const footer = document.createElement('div');
    footer.className = 'nw-meta';
    footer.style.marginTop = '8px';
    footer.textContent = state.packTotal
      ? `Showing top ${preview.length} on this page. Open full rankings to browse all ${state.packTotal} members.`
      : `Showing top ${preview.length} pack members.`;

    els.packList.appendChild(footer);
  }
  function renderPackModal() {
    if (!els.packModalList) return;

    els.packModalList.innerHTML = '';

    if (!state.pack.length) {
      els.packModalList.innerHTML = '<div class="nw-empty">No Pack members found for this page.</div>';
      els.packPageCopy.textContent = `Page ${state.packPage}`;
      if (els.packPrev) els.packPrev.disabled = state.packPage <= 1;
      if (els.packNext) els.packNext.disabled = !state.packHasNext;
      return;
    }

    state.pack.forEach((m, index) => {
      const absoluteRank = ((state.packPage - 1) * state.packPageSize) + index + 1;
      const packXpAmount = Number(m.pack_xp ?? 0);
      const lifetimeStars = Number(m.all_time_stars ?? 0);

      const row = document.createElement('div');
      row.className = 'nw-pack-item';
      row.innerHTML = `
        <div class="nw-pack-item__member">
          <button class="nw-pack-member-trigger" type="button">#${absoluteRank} ${escapeHtml(m.pack_name || 'Subscriber (No name yet)')}</button>
          <div class="nw-meta">🐾 ${packXpAmount.toLocaleString()} Pack XP</div>
        </div>

        <div class="nw-pack-score" aria-label="${packXpAmount.toLocaleString()} Pack XP">
          <strong>${packXpAmount.toLocaleString()}</strong>
          <span>Pack XP</span>
        </div>
      `;

      const trigger = row.querySelector('.nw-pack-member-trigger');
      if (trigger) {
        trigger.addEventListener('click', () => openPackMemberModal(m.id));
      }

      els.packModalList.appendChild(row);
    });

    const start = ((state.packPage - 1) * state.packPageSize) + 1;
    const end = start + state.pack.length - 1;
    const totalText = state.packTotal ? ` of ${state.packTotal}` : '';
    els.packPageCopy.textContent = `Showing ${start}-${end}${totalText}`;

    if (els.packPrev) els.packPrev.disabled = state.packPage <= 1;
    if (els.packNext) els.packNext.disabled = !state.packHasNext;
  }
  function normalizeEditorLayerOrder() {
    const front = [...(state.editorLayout || [])].sort((a, b) => Number(a.z_index || 0) - Number(b.z_index || 0));

    front.forEach((item, index) => {
      item.z_index = index + 1;
    });

    state.editorLayout = front;
  }

  function moveEditorLayerItem(dragItemId, targetItemId = null, placeAfter = false) {
    const dragId = Number(dragItemId);
    if (!dragId) return;

    const front = [...state.editorLayout].filter((item) => Number(item.purchase_id || item.item_id) !== dragId);
    const dragged = state.editorLayout.find((item) => Number(item.purchase_id || item.item_id) === dragId);
    if (!dragged) return;

    let insertIndex = front.length;

    if (targetItemId != null) {
      const foundIndex = front.findIndex((item) => Number(item.purchase_id || item.item_id) === Number(targetItemId));
      if (foundIndex >= 0) {
        insertIndex = foundIndex + (placeAfter ? 1 : 0);
      }
    }

    front.splice(insertIndex, 0, dragged);

    front.forEach((item, index) => {
      item.z_index = index + 1;
    });

    state.editorLayout = front;
    state.selectedItemId = dragId;

    renderStage(els.editorStage, state.editorLayout, true);
    renderEditorLayerStrip();
    renderOwnedList();
    markEditorDirty();
  }

  function renderEditorLayerStrip() {
    if (!els.editorLayerStrip) return;

    normalizeEditorLayerOrder();
    els.editorLayerStrip.innerHTML = '';

    const rail = document.createElement('div');
    rail.className = 'nw-editor-layer-rail nw-editor-layer-rail--front';

    function clearLayerDropMarkers() {
      rail.querySelectorAll('.nw-editor-layer-chip.is-drop-before, .nw-editor-layer-chip.is-drop-after').forEach((chip) => {
        chip.classList.remove('is-drop-before', 'is-drop-after');
      });
    }

    function getChipLayerId(chip) {
      return Number(chip?.dataset?.purchaseId || chip?.dataset?.itemId || 0);
    }

    function getLayerDropTarget(clientX) {
      const dragId = Number(state.layerDragItemId || 0);
      const chips = Array.from(rail.querySelectorAll('.nw-editor-layer-chip')).filter((chip) => {
        const chipId = getChipLayerId(chip);
        return chipId && chipId !== dragId;
      });

      if (!chips.length) {
        return { targetItemId: null, placeAfter: false, chip: null };
      }

      for (const chip of chips) {
        const rect = chip.getBoundingClientRect();
        const midpoint = rect.left + (rect.width / 2);

        if (clientX <= midpoint) {
          return {
            targetItemId: getChipLayerId(chip),
            placeAfter: false,
            chip
          };
        }
      }

      const lastChip = chips[chips.length - 1];

      return {
        targetItemId: getChipLayerId(lastChip),
        placeAfter: true,
        chip: lastChip
      };
    }

    function markLayerDropTarget(clientX) {
      clearLayerDropMarkers();

      const target = getLayerDropTarget(clientX);
      if (!target.chip) return;

      target.chip.classList.add(target.placeAfter ? 'is-drop-after' : 'is-drop-before');
    }

    rail.addEventListener('dragover', (event) => {
      event.preventDefault();

      if (event.dataTransfer) {
        event.dataTransfer.dropEffect = 'move';
      }

      rail.classList.add('is-drop-target');
      markLayerDropTarget(event.clientX);
    });

    rail.addEventListener('dragleave', (event) => {
      if (event.relatedTarget && rail.contains(event.relatedTarget)) return;

      rail.classList.remove('is-drop-target');
      clearLayerDropMarkers();
    });

    rail.addEventListener('drop', (event) => {
      event.preventDefault();
      event.stopPropagation();

      rail.classList.remove('is-drop-target');
      clearLayerDropMarkers();

      if (!state.layerDragItemId) return;

      const target = getLayerDropTarget(event.clientX);
      moveEditorLayerItem(state.layerDragItemId, target.targetItemId, target.placeAfter);
    });

    if (!state.editorLayout.length) {
      const empty = document.createElement('div');
      empty.className = 'nw-editor-layer-empty';
      empty.textContent = 'Added items will appear here. Drag left or right to change which item sits in front.';
      rail.appendChild(empty);
      els.editorLayerStrip.appendChild(rail);
      return;
    }

    state.editorLayout.forEach((item) => {
      const editorItemId = Number(item.purchase_id || item.item_id);
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'nw-editor-layer-chip' + (Number(state.selectedItemId) === editorItemId ? ' is-selected' : '');
      chip.draggable = true;
      chip.dataset.itemId = String(item.item_id);
      if (editorItemId) chip.dataset.purchaseId = String(editorItemId);
      chip.innerHTML = `
        <img src="${item.image_url}" alt="${item.name || 'Layer item'}">
        <span>${item.name || 'Item'}</span>
      `;

      chip.addEventListener('click', () => {
        state.selectedItemId = editorItemId;
        renderStage(els.editorStage, state.editorLayout, true);
        renderEditorLayerStrip();
      });

      chip.addEventListener('dragstart', (event) => {
        state.layerDragItemId = editorItemId;

        if (event.dataTransfer) {
          event.dataTransfer.effectAllowed = 'move';
          event.dataTransfer.setData('text/plain', String(editorItemId));
        }
      });

      chip.addEventListener('dragend', () => {
        state.layerDragItemId = null;

        document.querySelectorAll('.nw-editor-layer-rail.is-drop-target').forEach((el) => {
          el.classList.remove('is-drop-target');
        });

        document.querySelectorAll('.nw-editor-layer-chip.is-drop-before, .nw-editor-layer-chip.is-drop-after').forEach((el) => {
          el.classList.remove('is-drop-before', 'is-drop-after');
        });
      });

      chip.addEventListener('dragover', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (event.dataTransfer) {
          event.dataTransfer.dropEffect = 'move';
        }

        rail.classList.add('is-drop-target');
        markLayerDropTarget(event.clientX);
      });

      chip.addEventListener('dragleave', (event) => {
        if (event.relatedTarget && chip.contains(event.relatedTarget)) return;
        chip.classList.remove('is-drop-before', 'is-drop-after');
      });

      chip.addEventListener('drop', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!state.layerDragItemId || Number(state.layerDragItemId) === editorItemId) return;

        rail.classList.remove('is-drop-target');
        clearLayerDropMarkers();

        const rect = chip.getBoundingClientRect();
        const placeAfter = event.clientX > (rect.left + rect.width / 2);

        moveEditorLayerItem(state.layerDragItemId, editorItemId, placeAfter);
      });

      rail.appendChild(chip);
    });

    els.editorLayerStrip.appendChild(rail);
  }

  function renderStage(container, items, editable=false) {
    if (!container) return;
    [...container.querySelectorAll('.nw-swag-layer, .nw-swag-layer-editor')].forEach(el => el.remove());

    const grid = container.querySelector('.nw-stage-grid');
    const sortedItems = [...items].sort((a, b) => Number(a.z_index || 0) - Number(b.z_index || 0));

    if (editable) {
      container.onpointerdown = (event) => {
        if (state.drag) return;
        if (event.target.closest('.nw-swag-layer-editor, .nw-swag-layer')) return;
        if (state.selectedItemId == null) return;

        state.selectedItemId = null;
        renderStage(els.editorStage, state.editorLayout, true);
        renderEditorLayerStrip();
      };
    } else {
      container.onpointerdown = null;
    }

    function attachEditorControls(editorLayer, item) {
      const editorItemId = Number(item.purchase_id || item.item_id);

      const handle = document.createElement('button');
      handle.type = 'button';
      handle.className = 'nw-resize-handle';
      handle.title = 'Resize freely';
      editorLayer.appendChild(handle);

      const handleX = document.createElement('button');
      handleX.type = 'button';
      handleX.className = 'nw-resize-handle-x';
      handleX.title = 'Resize width';
      handleX.textContent = '↔';
      editorLayer.appendChild(handleX);

      const handleY = document.createElement('button');
      handleY.type = 'button';
      handleY.className = 'nw-resize-handle-y';
      handleY.title = 'Resize height';
      handleY.textContent = '↕';
      editorLayer.appendChild(handleY);

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'nw-remove-handle';
      removeBtn.title = 'Remove item';
      removeBtn.textContent = '✕';
      editorLayer.appendChild(removeBtn);

      const rotateBtn = document.createElement('button');
      rotateBtn.type = 'button';
      rotateBtn.className = 'nw-rotate-handle';
      rotateBtn.title = 'Rotate item';
      rotateBtn.textContent = '⟲';
      editorLayer.appendChild(rotateBtn);

      editorLayer.addEventListener('pointerdown', (event) => {
        state.selectedItemId = editorItemId;
        renderStage(els.editorStage, state.editorLayout, true);
        renderEditorLayerStrip();
        startDrag(event, editorLayer, 'move');
      });

      handle.addEventListener('pointerdown', (event) => startDrag(event, editorLayer, 'resize'));
      handleX.addEventListener('pointerdown', (event) => startDrag(event, editorLayer, 'resize-x'));
      handleY.addEventListener('pointerdown', (event) => startDrag(event, editorLayer, 'resize-y'));

      removeBtn.addEventListener('pointerdown', (event) => {
        event.preventDefault();
        event.stopPropagation();
      });

      removeBtn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        state.editorLayout = state.editorLayout.filter((x) => Number(x.purchase_id || x.item_id) !== editorItemId);
        state.selectedItemId = null;
        normalizeEditorLayerOrder();
        renderStage(els.editorStage, state.editorLayout, true);
        renderEditorLayerStrip();
        renderWolfList();
        renderOwnedList();
        markEditorDirty();
      });

      rotateBtn.addEventListener('pointerdown', (event) => {
        event.preventDefault();
        event.stopPropagation();
        startDrag(event, editorLayer, 'rotate');
      });
    }

    sortedItems.forEach((item, index) => {
      const editorItemId = Number(item.purchase_id || item.item_id);
      const layer = document.createElement('div');
      layer.className = 'nw-swag-layer';
      layer.dataset.itemId = String(item.item_id);
      if (editorItemId) layer.dataset.purchaseId = String(editorItemId);
      layer.style.left = `${item.x}%`;
      layer.style.top = `${item.y}%`;
      layer.style.width = `${item.w}%`;
      layer.style.height = `${item.h}%`;
      layer.style.transform = `rotate(${Number(item.rotation || 0)}deg)`;
      layer.style.zIndex = editable ? String(120 + index) : String(item.z_index || (index + 1));

      const img = document.createElement('img');
      img.src = item.image_url;
      img.alt = item.name || 'Wolf swag';
      layer.appendChild(img);

      container.appendChild(layer);

      if (editable && Number(state.selectedItemId) === editorItemId) {
        const editorLayer = document.createElement('div');
        editorLayer.className = 'nw-swag-layer-editor is-selected';
        editorLayer.dataset.itemId = String(item.item_id);
        if (editorItemId) editorLayer.dataset.purchaseId = String(editorItemId);
        editorLayer.style.left = `${item.x}%`;
        editorLayer.style.top = `${item.y}%`;
        editorLayer.style.width = `${item.w}%`;
        editorLayer.style.height = `${item.h}%`;
        editorLayer.style.transform = `rotate(${Number(item.rotation || 0)}deg)`;
        editorLayer.style.zIndex = '300';

        attachEditorControls(editorLayer, item);

        if (grid && grid.nextSibling) {
          container.insertBefore(editorLayer, grid.nextSibling);
        } else {
          container.appendChild(editorLayer);
        }
      } else if (editable) {
        layer.addEventListener('pointerdown', (event) => {
          state.selectedItemId = editorItemId;
          renderStage(els.editorStage, state.editorLayout, true);
          renderEditorLayerStrip();
          startDrag(event, layer, 'move');
        });
      }
    });
  }
  function getLiveWolfForPreview(wolf = {}, options = {}) {
    if (!wolf) return null;

    const useLiveSource = options.useLiveSource !== false;
    if (!useLiveSource) return wolf;

    const wolfId = Number(wolf.id || 0);
    const wolfSubscriberId = Number(wolf.subscriber_id || 0);
    const currentSubscriberId = Number(state.me?.id || member()?.id || 0);

    if (wolfSubscriberId && currentSubscriberId && wolfSubscriberId !== currentSubscriberId) {
      return wolf;
    }

    const liveWolf = Array.isArray(state.wolves)
      ? state.wolves.find((candidate) => {
          return wolfId && Number(candidate.id) === wolfId;
        })
      : null;

    return liveWolf || wolf;
  }

  function buildWolfPreviewStage(wolf, stageClass = 'nw-stage nw-stage--card', options = {}) {
    const previewWolf = getLiveWolfForPreview(wolf, options);
    if (!previewWolf) return document.createElement('div');

    const stage = document.createElement('div');
    stage.className = `${stageClass} nw-stage--preview-source`;
    stage.dataset.previewWolfId = String(previewWolf.id || '');
    stage.dataset.previewSubscriberId = String(previewWolf.subscriber_id || '');
    stage.dataset.previewRankKey = String(previewWolf.rank_key || '');

    const base = document.createElement('img');
    base.className = 'nw-base-wolf';
    base.src = previewWolf.base_image_url || '';
    base.alt = previewWolf.rank_name || 'Wolf';
    stage.appendChild(base);

    const grid = document.createElement('div');
    grid.className = 'nw-stage-grid';
    stage.appendChild(grid);

    const layout = JSON.parse(JSON.stringify(previewWolf.equipped_items || [])).map((item) => ({
      ...item,
      z_index: Math.max(1, Number(item.z_index || 1))
    }));

    renderStage(stage, layout);

    return stage;
  }

  function renderWolfCardPreview(container, wolf, extraClass = '') {
    if (!container || !wolf) return;

    container.innerHTML = '';

    const preview = document.createElement('div');
    preview.className = `nw-wolf-card-preview${extraClass ? ` ${extraClass}` : ''}`;

    preview.appendChild(buildWolfPreviewStage(wolf, 'nw-stage nw-stage--card'));

    container.appendChild(preview);
  }

  function getCollectionPackXp() {
    const me = member();
    return Number(me?.pack_xp ?? state.me?.pack_xp ?? 0);
  }

  function getCollectionWolfRequiredXp(wolf) {
    return Number(wolf?.required_pack_xp ?? 0);
  }

  function getCollectionWolfKey(wolf) {
    return String(wolf?.wolf_key || wolf?.rank_key || wolf?.key || '').trim();
  }

  function getCollectionWolfCatalog() {
    return (Array.isArray(state.wolfCatalog) ? state.wolfCatalog : [])
      .filter((wolf) => {
        const slot = String(wolf?.slot || '').toLowerCase().trim();
        return slot === 'wolf' || !!getCollectionWolfKey(wolf);
      })
      .sort((a, b) => {
        const aReq = getCollectionWolfRequiredXp(a);
        const bReq = getCollectionWolfRequiredXp(b);
        if (aReq !== bReq) return aReq - bReq;
        return String(a.name || '').localeCompare(String(b.name || ''));
      });
  }

  function getNextCollectionLockedWolf() {
    const ownedKeys = new Set(
      (state.wolves || [])
        .map((wolf) => String(wolf?.rank_key || '').trim())
        .filter(Boolean)
    );

    return getCollectionWolfCatalog().find((wolf) => {
      const key = getCollectionWolfKey(wolf);
      return key && !ownedKeys.has(key);
    }) || null;
  }

  function renderCollectionNextWolf() {
    const packXp = getCollectionPackXp();
    const packXpEl = document.getElementById('nw-collection-pack-xp');
    const nextWolfEl = document.getElementById('nw-collection-next-wolf');
    const card = document.getElementById('nw-collection-next-wolf-card');

    if (packXpEl) packXpEl.textContent = packXp.toLocaleString();

    const nextWolf = getNextCollectionLockedWolf();

    if (!nextWolf) {
      if (nextWolfEl) nextWolfEl.textContent = 'All visible wolves unlocked';
      if (card) {
        card.innerHTML = `
          <div class="nw-collection-next-wolf-card__copy">
            <span class="nw-modal-kicker">Wolf Path</span>
            <h4>All visible wolves are unlocked.</h4>
            <p>Your current Pack has caught up to every wolf currently available in the Den.</p>
          </div>
        `;
      }
      return;
    }

    const required = getCollectionWolfRequiredXp(nextWolf);
    const remaining = Math.max(0, required - packXp);
    const pct = required > 0 ? Math.max(4, Math.min(100, (packXp / required) * 100)) : 100;
    const wolfName = nextWolf.name || nextWolf.rank_name || 'Next Wolf';

    if (nextWolfEl) nextWolfEl.textContent = wolfName;

    if (card) {
      card.innerHTML = `
        <div class="nw-collection-next-wolf-card__art">
          <img src="${escapeHtml(nextWolf.image_url || nextWolf.base_image_url || '')}" alt="${escapeHtml(wolfName)} silhouette">
          <span>Next wolf unlock</span>
        </div>

        <div class="nw-collection-next-wolf-card__copy">
          <span class="nw-modal-kicker">Wolf Path</span>
          <h4>${escapeHtml(wolfName)}</h4>
          <p>${remaining.toLocaleString()} more Pack XP needed to unlock this wolf.</p>

          <div class="nw-collection-next-progress">
            <div class="nw-collection-next-progress__top">
              <span>${packXp.toLocaleString()} XP</span>
              <strong>${required.toLocaleString()} XP</strong>
            </div>
            <div class="nw-collection-next-progress__bar">
              <span style="width:${pct}%;"></span>
            </div>
          </div>
        </div>
      `;
    }
  }
  function getCollectionNextSwagState() {
    const me = member();
    const packXp = getCollectionPackXp();
    const serverState = me?.swag_claim_state || null;

    if (serverState) return serverState;

    const unlockedIds = getSwagUnlockedIds();
    const locked = (state.catalog || [])
      .filter((item) => {
        const itemId = Number(item?.id || 0);
        const required = Number(item?.required_pack_xp || 0);
        return itemId > 0 && required >= 0 && !unlockedIds.has(itemId) && !ownedIds().has(itemId);
      })
      .sort((a, b) => Number(a.required_pack_xp || 0) - Number(b.required_pack_xp || 0));

    if (!locked.length) {
      return {
        available: false,
        all_unlocked: true,
        current_pack_xp: packXp,
        required_pack_xp: 0,
        remaining_pack_xp: 0,
        progress_pct: 100,
        next_preview: null
      };
    }

    const next = locked[0];
    const required = Number(next.required_pack_xp || 0);
    const remaining = Math.max(0, required - packXp);

    return {
      available: remaining <= 0,
      all_unlocked: false,
      current_pack_xp: packXp,
      required_pack_xp: required,
      remaining_pack_xp: remaining,
      progress_pct: required > 0 ? Math.max(4, Math.min(100, (packXp / required) * 100)) : 100,
      next_preview: {
        image_url: next.image_url || '',
        name: next.name || 'Wolf Swag'
      }
    };
  }

  function renderCollectionNextSwag() {
    const card = els.collectionNextSwagCard || document.getElementById('nw-collection-next-swag-card');
    const label = els.collectionNextSwag || document.getElementById('nw-collection-next-swag');
    if (!card) return;

    const packXp = getCollectionPackXp();
    const claimState = getCollectionNextSwagState();

    if (claimState.all_unlocked) {
      if (label) label.textContent = 'All visible swag unlocked';

      card.innerHTML = `
        <div class="nw-collection-next-wolf-card__copy">
          <span class="nw-modal-kicker">Swag Path</span>
          <h4>All visible swag is unlocked.</h4>
          <p>Your collection has caught up to every current wolf swag item in the Den.</p>
        </div>
      `;
      return;
    }

    const preview = claimState.next_preview || {};
    const required = Number(claimState.required_pack_xp || 0);
    const remaining = Math.max(0, Number(claimState.remaining_pack_xp || 0));
    const pct = Math.max(4, Math.min(100, Number(claimState.progress_pct || 0)));
    const ready = !!claimState.available;

    if (label) label.textContent = ready ? 'Claim ready' : 'Mystery Swag';

    card.innerHTML = `
      <div class="nw-collection-next-wolf-card__art nw-collection-next-swag-card__art">
        <img src="${escapeHtml(preview.image_url || '')}" alt="Locked wolf swag silhouette">
        <span>Next swag unlock</span>
      </div>

      <div class="nw-collection-next-wolf-card__copy">
        <span class="nw-modal-kicker">Swag Path</span>
        <h4>${ready ? 'Claim Swag' : 'Mystery Swag'}</h4>
        <p>${ready ? (required <= 0 ? 'Your first wolf swag claim is ready. Open it to reveal a random starter item.' : 'Your Pack XP reached the next swag threshold. Claim a random locked item now.') : `${remaining.toLocaleString()} more Pack XP needed for the next swag claim.`}</p>

        <div class="nw-collection-next-progress">
          <div class="nw-collection-next-progress__top">
            <span>${packXp.toLocaleString()} XP</span>
            <strong>${required.toLocaleString()} XP</strong>
          </div>
          <div class="nw-collection-next-progress__bar">
            <span style="width:${pct}%;"></span>
          </div>
        </div>

        ${ready ? `<button class="nw-btn nw-btn--primary nw-collection-claim-swag" type="button" data-claim-pack-xp-swag>Claim Swag</button>` : ''}
      </div>
    `;

    const claimBtn = card.querySelector('[data-claim-pack-xp-swag]');
    if (claimBtn) {
      claimBtn.addEventListener('click', () => claimPackXpSwag(claimBtn));
    }
  }
  function getStoreCategoryLabel(slot) {
    const clean = String(slot || 'Swag').trim();
    if (!clean) return 'Swag';
    return clean
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  function groupSwagStoreGridBySlot() {
    const grid = els.storeGrid;
    if (!grid) return;

    const cards = Array.from(grid.children).filter((node) => node.classList && node.classList.contains('nw-store-card'));
    if (!cards.length) return;

    const groups = new Map();

    cards.forEach((card) => {
      const slotText = card.querySelector('.nw-slot')?.textContent || 'Swag';
      const label = getStoreCategoryLabel(slotText);
      if (!groups.has(label)) groups.set(label, []);
      groups.get(label).push(card);
    });

    grid.innerHTML = '';
    grid.classList.add('nw-store-grid--categorized');

    groups.forEach((items, label) => {
      const section = document.createElement('section');
      section.className = 'nw-store-category';

      const head = document.createElement('div');
      head.className = 'nw-store-category__head';
      head.innerHTML = `
        <span>${escapeHtml(label)}</span>
        <strong>${items.length} item${items.length === 1 ? '' : 's'}</strong>
      `;

      const list = document.createElement('div');
      list.className = 'nw-store-category__grid';

      items.forEach((item) => list.appendChild(item));

      section.appendChild(head);
      section.appendChild(list);
      grid.appendChild(section);
    });
  }

  function limitWolfUnlockGridToNextLocked() {
    const wolvesGrid = document.getElementById('nw-store-wolves-grid');
    if (!wolvesGrid) return;

    const lockedCards = Array.from(wolvesGrid.children).filter((node) => {
      return node.classList && node.classList.contains('is-locked');
    });

    lockedCards.forEach((card, index) => {
      if (index > 0) card.remove();
    });

    const remainingLocked = Array.from(wolvesGrid.children).find((node) => {
      return node.classList && node.classList.contains('is-locked');
    });

    const oldNote = wolvesGrid.querySelector('.nw-wolf-unlock-limit-note');
    if (oldNote) oldNote.remove();

    if (remainingLocked) {
      const note = document.createElement('div');
      note.className = 'nw-wolf-unlock-limit-note';
      note.innerHTML = `
        <strong>Next wolf shown only</strong>
        <span>Future locked wolves stay hidden until this one is unlocked.</span>
      `;
      wolvesGrid.insertBefore(note, remainingLocked);
    }
  }

  function finalizeCollectionStoreRender() {
    renderCollectionNextWolf();
    renderCollectionNextSwag();
    groupSwagStoreGridBySlot();
    limitWolfUnlockGridToNextLocked();
  }

    function renderWolfList() {
    if (!els.wolfList) return;
    const wolves = Array.isArray(state.wolves) ? state.wolves : [];
    els.wolfList.innerHTML = '';

    syncCollectionHeaderCounts();
    renderCollectionNextWolf();
    renderCollectionNextSwag();

    if (!wolves.length) {
      els.wolfList.innerHTML = '<div class="nw-empty">No wolves owned yet.</div>';
      return;
    }

    wolves.forEach(wolf => {
      const equippedCount = Array.isArray(wolf.equipped_items) ? wolf.equipped_items.length : 0;
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'nw-wolf-card nw-wolf-card--collection' + (Number(state.selectedWolfId) === Number(wolf.id) ? ' is-active' : '');
      card.innerHTML = `
        <div class="nw-wolf-card__preview"></div>
        <span class="nw-wolf-card__kicker">${wolf.is_current ? 'Current Wolf' : 'Owned Wolf'}</span>
        <strong>${escapeHtml(wolf.rank_name || 'Wolf')}</strong>
        <div class="nw-slot">${equippedCount} swag item${equippedCount === 1 ? '' : 's'} equipped</div>
      `;

      renderWolfCardPreview(card.querySelector('.nw-wolf-card__preview'), wolf);
      card.addEventListener('click', async () => {
        if (Number(wolf.id) !== Number(state.selectedWolfId)) {
          await flushEditorAutosave({ silent: true });
        }

        state.selectedWolfId = Number(wolf.id);
        state.editorLayout = JSON.parse(JSON.stringify(wolf.equipped_items || [])).map((item) => ({
          ...item,
          z_index: Math.max(1, Number(item.z_index || 1))
        }));
        if (els.editorBaseWolf) {
          els.editorBaseWolf.src = wolf.base_image_url || '';
          els.editorBaseWolf.alt = wolf.rank_name || 'Wolf';
        }
        resetEditorAutosaveState('All changes saved');
        normalizeEditorLayerOrder();
        renderWolfList();
        renderStage(els.editorStage, state.editorLayout, true);
        renderEditorLayerStrip();
        renderOwnedList();
      });
      els.wolfList.appendChild(card);
    });
  }
  function renderHomePackRail() {
    if (!els.homePackRail) return;

    const wolves = Array.isArray(state.wolves) ? state.wolves : [];
    els.homePackRail.innerHTML = '';

    if (!wolves.length) {
      els.homePackRail.innerHTML = '<div class="nw-empty">No wolves owned yet.</div>';
    }

    wolves.forEach((wolf) => {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'nw-home-pack-card' + (wolf.is_current ? ' is-current' : '');
      card.innerHTML = `
        <div class="nw-home-pack-card__frame">
          <div class="nw-home-pack-card__image-wrap nw-home-pack-card__preview"></div>
        </div>
        <div class="nw-home-pack-card__meta">
          <strong>${wolf.rank_name || 'Wolf'}</strong>
          <span>${wolf.is_current ? 'Current wolf' : 'Owned wolf'}</span>
        </div>
      `;

      renderWolfCardPreview(card.querySelector('.nw-home-pack-card__preview'), wolf);

      card.addEventListener('click', async () => {
        await openCustomizeForRank(Number(wolf.id || 0), wolf.rank_key || null);
      });

      els.homePackRail.appendChild(card);
    });

    const addCard = document.createElement('button');
    addCard.type = 'button';
    addCard.className = 'nw-home-pack-card nw-home-pack-card--add';
    addCard.innerHTML = `
      <div class="nw-home-pack-card__frame nw-home-pack-card__frame--add">
        <span class="nw-home-pack-card__add-art" aria-hidden="true"></span>
        <span class="nw-home-pack-card__add-plus" aria-hidden="true">+</span>
      </div>
      <div class="nw-home-pack-card__meta">
        <strong>Wolf Unlock Path</strong>
        <span>Earn with Pack XP</span>
      </div>
    `;

    addCard.addEventListener('click', () => {
      openModal('store');
    });

    els.homePackRail.appendChild(addCard);
  }

  function getOwnedUsageMap() {
    const usage = new Map();

    (state.wolves || []).forEach((wolf) => {
      (wolf.equipped_items || []).forEach((item) => {
        const purchaseId = Number(item.purchase_id || 0);
        const itemId = Number(item.item_id || 0);
        const entry = {
          wolf_id: Number(wolf.id),
          rank_key: wolf.rank_key,
          rank_name: wolf.rank_name
        };

        if (purchaseId > 0) {
          usage.set(`purchase:${purchaseId}`, entry);
        } else if (itemId > 0) {
          usage.set(`item:${itemId}`, entry);
        }
      });
    });

    return usage;
  }
  function renderOwnedList() {
    const me = member();
    const owned = me?.owned_items || [];
    const usage = getOwnedUsageMap();

    syncCollectionHeaderCounts();

    els.ownedList.innerHTML = '';

    if (!owned.length) {
      els.ownedList.innerHTML = '<div class="nw-empty">You do not own any swag yet. Claim mystery swag through Pack XP, Trivia Trails, achievements, and Pack rewards.</div>';
      return;
    }

    const availableItems = owned.filter((item) => {
      const purchaseId = Number(item.purchase_id || 0);
      const itemId = Number(item.item_id || 0);
      const inUse = purchaseId > 0
        ? usage.get(`purchase:${purchaseId}`)
        : itemId > 0 && usage.get(`item:${itemId}`);

      return !inUse;
    });

    if (!availableItems.length) {
      els.ownedList.innerHTML = '<div class="nw-empty">All owned swag is currently equipped on one of your wolves. Remove an item from a wolf to make it available here again.</div>';
      return;
    }

    availableItems.forEach(item => {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'nw-owned-item';
      card.innerHTML = `
        <img src="${item.image_url}" alt="${item.name}">
        <strong>${item.name}</strong>
        <div class="nw-slot">${item.slot || 'swag'}</div>
        <div class="nw-owned-meta">
          <span class="nw-badge">Available</span>
        </div>
      `;

      card.addEventListener('click', () => addOwnedItemToLayout(item));
      els.ownedList.appendChild(card);
    });
  }

  function getSwagUnlockedIds() {
    const ids = state.me?.swag_unlocked_item_ids;
    return new Set(Array.isArray(ids) ? ids.map((id) => Number(id)).filter(Boolean) : []);
  }

  function isSwagItemUnlocked(item) {
    const itemId = Number(item?.id || 0);
    if (!itemId) return false;

    if (ownedIds().has(itemId)) return true;

    return getSwagUnlockedIds().has(itemId);
  }

    function renderLockedSwagStoreCard(item) {
    const required = Number(item?.required_pack_xp ?? 0);

    return `
      <div class="nw-swag-locked-preview">
        <img src="${escapeHtml(item.image_url || '')}" alt="Locked wolf swag silhouette">
        <div class="nw-swag-lock-badge">🔒 Locked</div>
      </div>

      <strong>Mystery Swag</strong>
      <div class="nw-slot">Wolf Swag</div>

      <div class="nw-swag-lock-copy">
        <strong>${required <= 0 ? 'Starter swag claim' : 'Locked behind Pack progress'}</strong>
        <span>${required <= 0 ? 'Claim your first mystery swag item from the Next Swag box in Pack Collection.' : 'Track the next claim in the Pack Collection unlock card. Individual locked swag items stay hidden until revealed.'}</span>
      </div>

      <div class="nw-store-row">
        <button class="nw-btn nw-btn--ghost" type="button" disabled>Locked</button>
      </div>
    `;
  }

  function renderUnlockedSwagStoreCard(item, isOwned, canAfford, ownedQuantity = 0) {
    const safeOwnedQuantity = Math.max(0, Number(ownedQuantity || 0));

    return `
      <img src="${escapeHtml(item.image_url || '')}" alt="${escapeHtml(item.name || 'Wolf Swag')}">
      <strong>${escapeHtml(item.name || 'Wolf Swag')}</strong>
      <div class="nw-slot">Wolf Swag</div>

      ${
        safeOwnedQuantity > 0
          ? `<div class="nw-swag-owned-quantity">Owned</div>`
          : ''
      }

      <div class="nw-swag-unlocked-copy">
        ${
          safeOwnedQuantity > 0
            ? 'Unlocked and in your Pack Collection. Use it in the styling room.'
            : Number(item.required_pack_xp || 0) > 0
              ? `Unlocked from ${escapeHtml(item.unlock_label || 'Pack progress')}.`
              : 'Unlocked and ready for your collection.'
        }
      </div>
      <div class="nw-store-row">
        <button class="nw-btn nw-btn--ghost" type="button" disabled>${safeOwnedQuantity > 0 ? 'Owned' : 'Unlocked'}</button>
      </div>
    `;
  }

  function renderStore() {
    const me = member();
    const owned = ownedIds();
    const ownedWolfKeys = new Set((state.wolves || []).map((wolf) => wolf.rank_key));

    const swagTabBtn = document.getElementById('nw-store-tab-swag');
    const wolvesTabBtn = document.getElementById('nw-store-tab-wolves');
    const swagGrid = els.storeGrid;
    const wolvesGrid = document.getElementById('nw-store-wolves-grid');

    if (!state.storeTab) state.storeTab = 'swag';

    function isWolfEntry(item) {
      const slot = String(item?.slot || '').toLowerCase().trim();
      const slug = String(item?.slug || '').toLowerCase().trim();
      const name = String(item?.name || '').toLowerCase().trim();
      const id = String(item?.id || '').toLowerCase().trim();
      const wolfKey = String(item?.wolf_key || '').toLowerCase().trim();

      return (
        slot === 'wolf' ||
        !!wolfKey ||
        slug.startsWith('wolf-') ||
        id.startsWith('wolf:') ||
        /^wolf[\s:-]/.test(name) ||
        /\b(pup|juvenile|scout|hunter|alpha|beta|elder)\b/.test(name)
      );
    }

    function getWolfShopStatValue(wolf, key) {
      return Number(wolf?.stats?.[key] || 0);
    }

    function renderWolfShopStat(label, value, maxValue, suffix = '') {
      const safeValue = Number(value || 0);
      const safeMax = Math.max(1, Number(maxValue || 1));
      const pct = clamp((safeValue / safeMax) * 100, 4, 100);
      const display = suffix ? `${safeValue}${suffix}` : String(safeValue);

      return `
        <div class="nw-wolf-shop-stat">
          <div class="nw-wolf-shop-stat__top">
            <span>${escapeHtml(label)}</span>
            <strong>${escapeHtml(display)}</strong>
          </div>
          <div class="nw-wolf-shop-stat__bar">
            <span style="width:${pct}%;"></span>
          </div>
        </div>
      `;
    }

    function renderWolfShopStats(wolf) {
      const stats = wolf?.stats || {};
      if (!stats || !Object.keys(stats).length) {
        return '<div class="nw-wolf-shop-stats-empty">Simulator stats loading...</div>';
      }

      const attackCooldown = Number(stats.attack_cooldown_sec || 0);
      const attacksPerSecond = attackCooldown > 0 ? (1 / attackCooldown).toFixed(2) : '0.00';

      return `
        <div class="nw-wolf-shop-stats">
          <div class="nw-wolf-shop-stats__title">Simulator Stats</div>
          ${renderWolfShopStat('Health', getWolfShopStatValue(wolf, 'health'), 240)}
          ${renderWolfShopStat('Strength', getWolfShopStatValue(wolf, 'strength'), 62)}
          ${renderWolfShopStat('Speed', getWolfShopStatValue(wolf, 'speed'), 156)}
          ${renderWolfShopStat('Stamina', getWolfShopStatValue(wolf, 'stamina_max'), 14, 's')}
          ${renderWolfShopStat('Vision Range', getWolfShopStatValue(wolf, 'fov'), 460)}
          <div class="nw-wolf-shop-stat-pair">
            <span>Sprint ×${Number(stats.sprint_mult || 0).toFixed(2)}</span>
            <span>Attack every ${attackCooldown.toFixed(2)}s</span>
          </div>
          <div class="nw-wolf-shop-stat-note">Approx. ${attacksPerSecond} attacks/sec in simulator combat.</div>
        </div>
      `;
    }
    function isWolfShopUnlocked(wolf) {
      const required = Number(wolf?.required_pack_xp ?? 0);
      const packXp = getSharedPackXp();
      return packXp >= required;
    }

    function renderLockedWolfPreview(wolf) {
      const required = Number(wolf?.required_pack_xp ?? 0);
      const current = getSharedPackXp();
      const remaining = Math.max(0, required - current);

      return `
        <div class="nw-wolf-shop-locked-preview">
          <img src="${escapeHtml(wolf.image_url || '')}" alt="Locked wolf silhouette">
          <div class="nw-wolf-shop-lock-badge">🔒 Locked</div>
          <div class="nw-wolf-shop-lock-copy">
            <strong>Reach ${required.toLocaleString()} Pack XP</strong>
            <span>${remaining.toLocaleString()} more Pack XP needed</span>
          </div>
        </div>
      `;
    }

    function syncStoreTabButtons() {
      if (!swagTabBtn || !wolvesTabBtn || !swagGrid || !wolvesGrid) return;

      const swagActive = state.storeTab === 'swag';

      swagGrid.hidden = !swagActive;
      wolvesGrid.hidden = swagActive;

      swagGrid.style.display = swagActive ? 'grid' : 'none';
      wolvesGrid.style.display = swagActive ? 'none' : 'grid';

      swagTabBtn.className = `nw-btn ${swagActive ? 'nw-btn--primary' : 'nw-btn--ghost'}`;
      wolvesTabBtn.className = `nw-btn ${swagActive ? 'nw-btn--ghost' : 'nw-btn--primary'}`;
    }

    if (swagTabBtn && !swagTabBtn.dataset.bound) {
      swagTabBtn.dataset.bound = '1';
      swagTabBtn.addEventListener('click', () => {
        state.storeTab = 'swag';
        renderStore();
        finalizeCollectionStoreRender();
      });
    }

    if (wolvesTabBtn && !wolvesTabBtn.dataset.bound) {
      wolvesTabBtn.dataset.bound = '1';
      wolvesTabBtn.addEventListener('click', () => {
        state.storeTab = 'wolves';
        renderStore();
        finalizeCollectionStoreRender();
      });
    }

    swagGrid.innerHTML = '';
    if (wolvesGrid) wolvesGrid.innerHTML = '';

    const swagItems = (state.catalog || [])
      .filter(item => !isWolfEntry(item))
      .filter(item => String(item?.slot || '').toLowerCase().trim() !== 'wolf')
      .filter(item => !String(item?.wolf_key || '').trim())
      .sort((a, b) => {
        const aUnlocked = owned.has(Number(a.id || 0)) || isSwagItemUnlocked(a);
        const bUnlocked = owned.has(Number(b.id || 0)) || isSwagItemUnlocked(b);

        if (aUnlocked !== bUnlocked) return aUnlocked ? -1 : 1;

        return String(a.name || '').localeCompare(String(b.name || ''));
      });

    const wolvesForSale = (state.wolfCatalog || [])
      .filter(wolf => String(wolf?.slot || '').toLowerCase().trim() === 'wolf')
      .filter(wolf => !!String(wolf?.wolf_key || '').trim())
      .sort((a, b) => {
        return String(a.name || '').localeCompare(String(b.name || ''));
      });

    const ownedWolfCounts = (state.wolves || []).reduce((map, wolf) => {
      const key = String(wolf?.rank_key || '').trim();
      if (!key) return map;
      map.set(key, (map.get(key) || 0) + 1);
      return map;
    }, new Map());

    if (state.storeTab === 'swag') {
      swagItems.forEach(item => {
        const card = document.createElement('div');
        const ownedQuantity = getOwnedItemQuantity(item.id);
        const isOwned = ownedQuantity > 0 || owned.has(item.id);
        const unlocked = isOwned || isSwagItemUnlocked(item);
        const canAfford = false;

        card.className = `nw-store-card nw-swag-store-card${unlocked ? ' is-unlocked' : ' is-locked'}`;
        card.innerHTML = unlocked
          ? renderUnlockedSwagStoreCard(item, isOwned, canAfford, ownedQuantity)
          : renderLockedSwagStoreCard(item);

        swagGrid.appendChild(card);
      });

    } else if (wolvesGrid) {
      const currentPackXp = getSharedPackXp();

      const intro = document.createElement('div');
      intro.className = 'nw-wolf-unlock-path-intro';
      intro.innerHTML = `
        <div>
          <span class="nw-modal-kicker">Wolf Unlock Path</span>
          <h4>Track your progress towards unlocking new wolves.</h4>
          <p>Every wolf joins your Pack automatically when your Pack XP reaches its requirement. Pack XP is what grows the Pack and unlocks new collection paths.</p>
        </div>
        <div class="nw-wolf-unlock-path-intro__xp">
          <span>Your Pack XP</span>
          <strong>${Number(currentPackXp || 0).toLocaleString()}</strong>
        </div>
      `;
      wolvesGrid.appendChild(intro);

      wolvesForSale.forEach(wolf => {
        const card = document.createElement('div');
        const required = Number(wolf?.required_pack_xp ?? 0);
        const ownedAlready = ownedWolfKeys.has(wolf.wolf_key);
        const unlocked = isWolfShopUnlocked(wolf);
        const remaining = Math.max(0, required - currentPackXp);
        const progressPct = required > 0 ? clamp((currentPackXp / required) * 100, 0, 100) : 100;

        card.className = `nw-store-card nw-wolf-shop-card nw-wolf-unlock-card${ownedAlready ? ' is-owned' : unlocked ? ' is-ready' : ' is-locked'}`;

        if (ownedAlready) {
          card.innerHTML = `
            <div class="nw-wolf-unlock-card__image">
              <img src="${escapeHtml(wolf.image_url || '')}" alt="${escapeHtml(wolf.name || 'Wolf')}">
              <span class="nw-wolf-unlock-card__seal">Joined Pack</span>
            </div>
            <strong>${escapeHtml(wolf.name || 'Wolf')}</strong>
            <div class="nw-slot">Unlocked Wolf</div>
            ${renderWolfShopStats(wolf)}
            <div class="nw-wolf-unlock-progress">
              <div class="nw-wolf-unlock-progress__top">
                <span>Required Pack XP</span>
                <strong>${required.toLocaleString()}</strong>
              </div>
              <div class="nw-wolf-unlock-progress__bar"><span style="width:100%;"></span></div>
            </div>
            <div class="nw-store-owned-copy">Already part of your Pack</div>
          `;
        } else if (unlocked) {
          card.innerHTML = `
            <div class="nw-wolf-unlock-card__image">
              <img src="${escapeHtml(wolf.image_url || '')}" alt="${escapeHtml(wolf.name || 'Wolf')}">
              <span class="nw-wolf-unlock-card__seal">Ready</span>
            </div>
            <strong>${escapeHtml(wolf.name || 'Wolf')}</strong>
            <div class="nw-slot">Unlock pending refresh</div>
            ${renderWolfShopStats(wolf)}
            <div class="nw-wolf-unlock-progress">
              <div class="nw-wolf-unlock-progress__top">
                <span>Required Pack XP reached</span>
                <strong>${required.toLocaleString()}</strong>
              </div>
              <div class="nw-wolf-unlock-progress__bar"><span style="width:100%;"></span></div>
            </div>
            <button class="nw-btn nw-btn--primary nw-wolf-refresh-unlocks" type="button">Refresh Unlocks</button>
          `;
        } else {
          card.innerHTML = `
            ${renderLockedWolfPreview(wolf)}
            <strong>Mystery Wolf</strong>
            <div class="nw-slot">Locked Wolf</div>
            <div class="nw-wolf-shop-locked-stats">
              Stats revealed at ${required.toLocaleString()} Pack XP
            </div>
            <div class="nw-wolf-unlock-progress">
              <div class="nw-wolf-unlock-progress__top">
                <span>${remaining.toLocaleString()} Pack XP to go</span>
                <strong>${Math.round(progressPct)}%</strong>
              </div>
              <div class="nw-wolf-unlock-progress__bar"><span style="width:${progressPct}%;"></span></div>
            </div>
            <div class="nw-store-owned-copy">Keep playing, reading, and claiming rewards to unlock this wolf.</div>
          `;
        }

        wolvesGrid.appendChild(card);
      });

      wolvesGrid.querySelectorAll('.nw-wolf-refresh-unlocks').forEach(btn => {
        btn.addEventListener('click', async () => {
          btn.disabled = true;
          btn.textContent = 'Checking...';
          try {
            await refreshMemberState();
            showAlert('Wolf unlocks refreshed.');
          } catch (err) {
            showAlert(err.message);
          } finally {
            btn.disabled = false;
            btn.textContent = 'Refresh Unlocks';
          }
        });
      });
    }

    syncStoreTabButtons();
  }

  function addOwnedItemToLayout(item) {
    const purchaseId = Number(item.purchase_id || 0);
    if (!purchaseId) return;

    const usage = getOwnedUsageMap();
    const currentUsage = usage.get(purchaseId);

    if (currentUsage && Number(currentUsage.wolf_id) !== Number(state.selectedWolfId)) {
      showAlert(`${item.name} is already equipped on your ${currentUsage.rank_name} wolf. Remove it there first.`);
      return;
    }

    const existingIndex = state.editorLayout.findIndex(x => Number(x.purchase_id) === purchaseId);
    if (existingIndex >= 0) {
      state.selectedItemId = purchaseId;
      renderStage(els.editorStage, state.editorLayout, true);
      renderEditorLayerStrip();
      return;
    }

    const frontCount = state.editorLayout.filter((x) => Number(x.z_index || 0) >= 0).length;

    state.editorLayout.push({
      purchase_id: purchaseId,
      item_id: item.item_id,
      name: item.name,
      image_url: item.image_url,
      x: 33,
      y: 28,
      w: 22,
      h: 22,
      rotation: 0,
      z_index: frontCount + 1
    });

    state.selectedItemId = purchaseId;
    normalizeEditorLayerOrder();
    renderStage(els.editorStage, state.editorLayout, true);
    renderEditorLayerStrip();
    renderOwnedList();
    markEditorDirty();
  }

  function getPointerAngleDegrees(clientX, clientY, centerX, centerY) {
    return Math.atan2(clientY - centerY, clientX - centerX) * (180 / Math.PI);
  }

  function normalizeDegrees(deg) {
    let value = Number(deg || 0);
    while (value > 180) value -= 360;
    while (value < -180) value += 360;
    return value;
  }

  function stopDragOnVisibilityChange() {
    if (document.hidden) {
      stopDrag();
    }
  }

  function releaseDragPointerCapture() {
    if (!state.drag || !state.drag.captureEl) return;
    try {
      if (
        Number.isFinite(state.drag.pointerId) &&
        typeof state.drag.captureEl.hasPointerCapture === 'function' &&
        state.drag.captureEl.hasPointerCapture(state.drag.pointerId)
      ) {
        state.drag.captureEl.releasePointerCapture(state.drag.pointerId);
      }
    } catch (_) {}
  }

  function startDrag(event, layer, mode) {
    event.preventDefault();
    event.stopPropagation();

    beginEditorInteraction();

    const itemId = Number(layer.dataset.purchaseId || layer.dataset.itemId);
    state.selectedItemId = itemId;
    renderStage(els.editorStage, state.editorLayout, true);

    const activeLayer =
      els.editorStage.querySelector(`.nw-swag-layer-editor[data-purchase-id="${itemId}"]`) ||
      els.editorStage.querySelector(`.nw-swag-layer[data-purchase-id="${itemId}"]`) ||
      els.editorStage.querySelector(`.nw-swag-layer-editor[data-item-id="${itemId}"]`) ||
      els.editorStage.querySelector(`.nw-swag-layer[data-item-id="${itemId}"]`) ||
      layer;

    const rect = els.editorStage.getBoundingClientRect();
    const current = state.editorLayout.find((x) => Number(x.purchase_id || x.item_id) === itemId);
    if (!current) {
      endEditorInteraction();
      return;
    }

    const startX = event.clientX;
    const startY = event.clientY;
    const origin = { ...current };

    const centerXPct = Number(current.x || 0) + (Number(current.w || 0) / 2);
    const centerYPct = Number(current.y || 0) + (Number(current.h || 0) / 2);
    const centerX = rect.left + (rect.width * centerXPct / 100);
    const centerY = rect.top + (rect.height * centerYPct / 100);

    const captureEl = activeLayer;
    const pointerId = Number(event.pointerId);

    try {
      if (
        captureEl &&
        typeof captureEl.setPointerCapture === 'function' &&
        Number.isFinite(pointerId)
      ) {
        captureEl.setPointerCapture(pointerId);
      }
    } catch (_) {}

    state.drag = {
      itemId,
      mode,
      rect,
      startX,
      startY,
      origin,
      centerX,
      centerY,
      startAngle: getPointerAngleDegrees(event.clientX, event.clientY, centerX, centerY),
      startRotation: Number(current.rotation || 0),
      pointerId,
      captureEl,
      didChange: false
    };

    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', stopDrag);
    window.addEventListener('pointercancel', stopDrag);
    window.addEventListener('blur', stopDrag);
    document.addEventListener('visibilitychange', stopDragOnVisibilityChange);
  }

  function onPointerMove(event) {
    if (!state.drag) return;

    if (Number.isFinite(state.drag.pointerId) && Number.isFinite(event.pointerId) && event.pointerId !== state.drag.pointerId) {
      return;
    }

    const drag = state.drag;
    const item = state.editorLayout.find((x) => Number(x.purchase_id || x.item_id) === Number(drag.itemId));
    if (!item) return;

    const dxPct = ((event.clientX - drag.startX) / drag.rect.width) * 100;
    const dyPct = ((event.clientY - drag.startY) / drag.rect.height) * 100;

    if (drag.mode === 'move') {
      item.x = clamp(drag.origin.x + dxPct, -80, 180);
      item.y = clamp(drag.origin.y + dyPct, -80, 180);
    } else if (drag.mode === 'resize-x') {
      item.w = clamp(drag.origin.w + dxPct, 4, 140);
      item.h = drag.origin.h;
    } else if (drag.mode === 'resize-y') {
      item.h = clamp(drag.origin.h + dyPct, 4, 140);
      item.w = drag.origin.w;
    } else if (drag.mode === 'rotate') {
      const currentAngle = getPointerAngleDegrees(event.clientX, event.clientY, drag.centerX, drag.centerY);
      const delta = currentAngle - drag.startAngle;
      item.rotation = normalizeDegrees(drag.startRotation + delta);
    } else {
      item.w = clamp(drag.origin.w + dxPct, 4, 140);
      item.h = clamp(drag.origin.h + dyPct, 4, 140);
    }

    drag.didChange =
      Math.abs(Number(item.x || 0) - Number(drag.origin.x || 0)) > 0.01 ||
      Math.abs(Number(item.y || 0) - Number(drag.origin.y || 0)) > 0.01 ||
      Math.abs(Number(item.w || 0) - Number(drag.origin.w || 0)) > 0.01 ||
      Math.abs(Number(item.h || 0) - Number(drag.origin.h || 0)) > 0.01 ||
      Math.abs(Number(item.rotation || 0) - Number(drag.origin.rotation || 0)) > 0.01;

    renderStage(els.editorStage, state.editorLayout, true);
    renderEditorLayerStrip();
  }

  function stopDrag(event) {
    if (!state.drag) return;

    if (
      event &&
      event.type &&
      event.type.startsWith('pointer') &&
      Number.isFinite(state.drag.pointerId) &&
      Number.isFinite(event.pointerId) &&
      event.pointerId !== state.drag.pointerId
    ) {
      return;
    }

    const didChange = !!state.drag.didChange;

    releaseDragPointerCapture();

    state.drag = null;
    window.removeEventListener('pointermove', onPointerMove);
    window.removeEventListener('pointerup', stopDrag);
    window.removeEventListener('pointercancel', stopDrag);
    window.removeEventListener('blur', stopDrag);
    document.removeEventListener('visibilitychange', stopDragOnVisibilityChange);

    normalizeEditorLayerOrder();
    renderStage(els.editorStage, state.editorLayout, true);
    renderEditorLayerStrip();

    if (didChange) {
      renderOwnedList();
      markEditorDirty();
    }

    endEditorInteraction();
  }
  function setCombinedModalTab(tab) {
    state.combinedModalTab = tab === 'shop' ? 'shop' : 'wolves';

    if (els.combinedTabWolves) {
      els.combinedTabWolves.classList.toggle('nw-btn--ghost', state.combinedModalTab === 'wolves');
      els.combinedTabWolves.classList.toggle('nw-btn--primary', state.combinedModalTab !== 'wolves');
    }

    if (els.combinedTabShop) {
      els.combinedTabShop.classList.toggle('nw-btn--ghost', state.combinedModalTab === 'shop');
      els.combinedTabShop.classList.toggle('nw-btn--primary', state.combinedModalTab !== 'shop');
    }

    if (els.combinedPanelWolves) {
      els.combinedPanelWolves.hidden = state.combinedModalTab !== 'wolves';
    }

    if (els.combinedPanelShop) {
      els.combinedPanelShop.hidden = state.combinedModalTab !== 'shop';
    }

    if (els.combinedModalTitle) {
      els.combinedModalTitle.textContent = 'Pack Collection';
    }

    syncCollectionHeaderCounts();
    renderCollectionNextWolf();

    if (state.combinedModalTab === 'wolves') {
      normalizeEditorLayerOrder();
      renderWolfList();
      renderStage(els.editorStage, state.editorLayout, true);
      renderEditorLayerStrip();
      renderOwnedList();
    } else {
      renderStore();
      finalizeCollectionStoreRender();
    }
  }

  function openModal(type) {
    els.backdrop.hidden = false;

    if (type === 'customize' || type === 'store') {
      trackFirstDenAction('collection_opened', {
        source: type === 'store' ? 'store_modal' : 'customize_modal',
        modal_type: type
      });

      trackEvent('collection_opened', {
        source: type === 'store' ? 'store_modal' : 'customize_modal',
        modal_type: type
      });

      els.customizeModal.hidden = false;

      if (!state.selectedWolfId && Array.isArray(state.wolves) && state.wolves.length) {
        const currentWolf = state.wolves.find(w => w.is_current) || state.wolves[0];
        state.selectedWolfId = Number(currentWolf.id);
        state.editorLayout = JSON.parse(JSON.stringify(currentWolf.equipped_items || []));
        if (els.editorBaseWolf) {
          els.editorBaseWolf.src = currentWolf.base_image_url || '';
          els.editorBaseWolf.alt = currentWolf.rank_name || 'Wolf';
        }
      }

      setCombinedModalTab(type === 'store' ? 'shop' : 'wolves');
    }

    if (type === 'pack') {
      els.packModal.hidden = false;
      renderPackModal();
    }
  }

  async function closeModals() {
    if (els.customizeModal && !els.customizeModal.hidden) {
      try {
        await flushEditorAutosave({ silent: true });
      } catch (err) {}
    }

    clearTrailsTimer();
    closeTreasureChestModal();

    if (els.backdrop) els.backdrop.hidden = true;
    if (els.customizeModal) els.customizeModal.hidden = true;
    if (els.storeModal) els.storeModal.hidden = true;
    if (els.shareModal) els.shareModal.hidden = true;
    if (els.packModal) els.packModal.hidden = true;
    if (els.packMemberModal) els.packMemberModal.hidden = true;
    if (els.goalsModal) els.goalsModal.hidden = true;
    if (els.trailsModal) els.trailsModal.hidden = true;
    if (els.simModal) els.simModal.hidden = true;

    document.documentElement.classList.remove('nw-modal-open');
    document.body.classList.remove('nw-modal-open');
  }

  async function closeFromMobileModalButton(modal) {
    if (!modal) {
      await closeModals();
      return;
    }

    if (modal.id === 'nw-award-popup') {
      closeAwardPopup();
      if (els.backdrop) els.backdrop.hidden = true;
      return;
    }

    if (modal.id === 'nw-rank-unlock-popup') {
      hideRankUnlockPopup();
      return;
    }

    if (modal.id === 'nw-swag-unlock-popup') {
      hideSwagUnlockPopup();
      return;
    }

    if (modal.id === 'nw-treasure-chest-modal') {
      closeTreasureChestModal();
      return;
    }

    if (modal.id === 'nw-share-modal') {
      closeArchiveShareModal();
      return;
    }

    if (modal.id === 'nw-customize-modal') {
      await closeCustomizeModal();
      maybeShowQueuedRankUnlock();
      return;
    }

    if (modal.id === 'nw-goals-modal') {
      closeGoalsModal();
      return;
    }

    if (modal.id === 'nw-trails-modal') {
      closeTrailsModal(true);
      return;
    }

    if (modal.id === 'nw-sim-modal') {
      closeSimModal(true);
      return;
    }

    await closeModals();
  }

  function ensureMobileModalCloseButtons() {
    document.querySelectorAll('#nw-pack-den .nw-modal > .nw-modal-card').forEach((card) => {
      if (card.querySelector('.nw-mobile-modal-close')) return;

      const modal = card.closest('.nw-modal');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nw-mobile-modal-close';
      btn.textContent = 'Close Window';

      btn.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        await closeFromMobileModalButton(modal);
      });

      card.appendChild(btn);
    });
  }

  async function loadPackPage(page = 1) {
    const safePage = Math.max(1, Number(page) || 1);
    const limit = state.packPageSize;

    const packRes = await api(`/api/pack?page=${safePage}&limit=${limit}`);

    const incomingMembers = Array.isArray(packRes.members)
      ? packRes.members
      : Array.isArray(packRes)
        ? packRes
        : [];

    state.packPage = safePage;

    const backendSeemsPaginated =
      incomingMembers.length <= limit &&
      (typeof packRes.has_next === 'boolean' || Number(packRes.total || 0) > 0);

    if (backendSeemsPaginated) {
      state.fullPack = [];
      state.pack = incomingMembers;
      state.packTotal = Number(packRes.total || incomingMembers.length);

      if (typeof packRes.has_next === 'boolean') {
        state.packHasNext = packRes.has_next;
      } else {
        state.packHasNext = incomingMembers.length === limit;
      }
    } else {
      if (safePage === 1 || !state.fullPack.length) {
        state.fullPack = incomingMembers;
      }

      const start = (safePage - 1) * limit;
      const end = start + limit;

      state.pack = state.fullPack.slice(start, end);
      state.packTotal = Number(packRes.total || state.fullPack.length);
      state.packHasNext = end < state.fullPack.length;
    }

    renderPack();
    renderPackModal();
  }

  async function loadPackMember(memberId) {
    const res = await api(`/api/pack/member?id=${Number(memberId)}`);
    state.selectedPackMember = res.member || null;
    renderPackMemberModal();
  }

  function renderPackMemberModal() {
    const member = state.selectedPackMember;

    if (!els.packMemberTitle || !els.packMemberMeta || !els.packMemberStatus || !els.packMemberWolves) return;

    if (!member) {
      els.packMemberTitle.textContent = 'Pack Member';
      els.packMemberMeta.textContent = 'Unable to load member.';
      els.packMemberStatus.textContent = 'No wolves available.';
      els.packMemberWolves.innerHTML = '';
      return;
    }


    const packXpAmount = Number(member.pack_xp ?? 0);

    els.packMemberTitle.textContent = member.pack_name || 'Subscriber (No name yet)';
    els.packMemberMeta.textContent = `🐾 ${packXpAmount.toLocaleString()} Pack XP`;

    const wolves = Array.isArray(member.wolves) ? member.wolves : [];
    els.packMemberWolves.innerHTML = '';

    if (!wolves.length) {
      els.packMemberStatus.textContent = 'This member has no saved wolves yet.';
      return;
    }

    els.packMemberStatus.textContent = `Showing ${wolves.length} wolf${wolves.length === 1 ? '' : 'ves'}.`;

    wolves.forEach((wolf, index) => {
      const card = document.createElement('div');
      card.className = 'nw-pack-member-wolf-card';

      card.innerHTML = `
        <div class="nw-pack-member-wolf-head">
          <strong>${wolf.rank_name || `Wolf ${index + 1}`}</strong>
        </div>
      `;

      card.appendChild(buildWolfPreviewStage(wolf, 'nw-stage nw-stage--card nw-pack-member-wolf-stage', {
        useLiveSource: false
      }));

      els.packMemberWolves.appendChild(card);
    });
  }

  async function openPackMemberModal(memberId) {
    if (!memberId) return;

    els.backdrop.hidden = false;
    els.packMemberModal.hidden = false;
    els.packMemberTitle.textContent = 'Loading...';
    els.packMemberMeta.textContent = 'Fetching member showcase...';
    els.packMemberStatus.textContent = 'Loading wolves...';
    els.packMemberWolves.innerHTML = '';

    try {
      await loadPackMember(memberId);
    } catch (err) {
      els.packMemberTitle.textContent = 'Pack Member';
      els.packMemberMeta.textContent = 'Unable to load this member.';
      els.packMemberStatus.textContent = err.message || 'Something went wrong.';
      els.packMemberWolves.innerHTML = '';
    }
  }

  async function refreshData() {
    const meRes = await api('/api/me');
      state.me = meRes.member || meRes.user || meRes.profile || meRes;
      renderPackPlusSurface();
    if (els.denRoot) els.denRoot.classList.add('nw-pack-den--member');
    state.pendingAwards = Array.isArray(meRes.pending_awards) ? meRes.pending_awards : [];
    state.challengesList = Array.isArray(meRes.challenges) ? meRes.challenges : [];
    state.treasureChest = meRes.treasure_chest || state.treasureChest;
    state.heartChest = meRes.heart_chest || state.heartChest;
    queueWolfUnlocks(state.me?.wolf_unlocks || meRes.wolf_unlocks || []);
    state.wolves = Array.isArray(meRes.wolves)
      ? meRes.wolves
      : Array.isArray(state.me?.wolves)
        ? state.me.wolves
        : [];
    updateAwardNotification();
    const catalogRes = await api('/api/catalog');
    state.catalog = catalogRes.items || [];
    state.wolfCatalog = catalogRes.wolves || [];
    await loadPackPage(1);
    renderProfile();
    renderWolfList();
    renderHomePackRail();
    renderGoalsBalances();
    renderPackReferralCard();
    renderTreasureChest();
    renderHeartChest();
    bindDenSummaryToggle();
    setDenSummaryOpen(true);
    if (els.guestJoinCard) els.guestJoinCard.hidden = true;
    if (els.guestLandingShell) els.guestLandingShell.hidden = true;
    if (els.archiveShell) els.archiveShell.hidden = false;
    setArchiveExpanded(false);
    await ensureArchivePanelOpen();
    if (els.archiveMemberLogin) els.archiveMemberLogin.hidden = true;
    if (els.publicPreviewShell) els.publicPreviewShell.hidden = true;
    if (els.app) els.app.hidden = false;
    if (els.authCard) els.authCard.hidden = true;

    trackRepeatDenVisit();
  }
  if (els.gcTabGames) {
    els.gcTabGames.addEventListener('click', () => setGcTab('games'));
  }

  if (els.gcTabChallenges) {
    els.gcTabChallenges.addEventListener('click', () => setGcTab('challenges'));
  }

  if (els.gcShowCompleted) {
    els.gcShowCompleted.addEventListener('change', () => {
      state.gcShowCompleted = !!els.gcShowCompleted.checked;
      if (state.gcActiveTab === 'challenges') updateGoalsList();
    });
  }

  if (els.gcChallengeFilter) {
    els.gcChallengeFilter.addEventListener('change', () => {
      state.gcChallengeFilter = els.gcChallengeFilter.value || 'all';
      if (state.gcActiveTab === 'challenges') updateGoalsList();
    });
  }
  if (els.archiveToggle) {
    els.archiveToggle.addEventListener('click', async () => {
      const nextExpanded = !state.archiveExpanded;
      setArchiveExpanded(nextExpanded);

      if (nextExpanded) {
        trackFirstDenAction('archive_opened', {
          source: 'archive_toggle'
        });

        trackEvent('archive_opened', {
          source: 'archive_toggle'
        });

        await ensureArchivePanelOpen({ force: true });
      }
    });
  }

  async function boot() {
    ensureMobileModalCloseButtons();

    const params = new URLSearchParams(window.location.search);
    const openParam = params.get('open');
    const sourceParam = params.get('source') || '';
    const setupParam = params.get('setup') || '';

    let storedEmail = '';

    try {
      storedEmail = window.sessionStorage.getItem('nw_den_prefill_email') || '';
    } catch (err) {
      storedEmail = '';
    }

    storedEmail = cleanEmail(storedEmail);

    if (els.denRoot) els.denRoot.classList.add('nw-pack-den--checking-auth');
    if (els.app) els.app.hidden = true;
    if (els.guestLandingShell) els.guestLandingShell.hidden = true;
    if (els.guestJoinCard) els.guestJoinCard.hidden = true;
    if (els.authCard) els.authCard.hidden = true;
    if (els.archiveShell) els.archiveShell.hidden = true;
    if (els.publicPreviewShell) els.publicPreviewShell.hidden = true;

    try {
      await refreshData();

      if (openParam === 'achievements') {
        setTimeout(() => openGoalsModalToTab('challenges'), 250);
      }
    } catch (err) {
      if (sourceParam === 'landing-login') {
        try {
          await new Promise((resolve) => setTimeout(resolve, 700));
          await refreshData();

          if (openParam === 'achievements') {
            setTimeout(() => openGoalsModalToTab('challenges'), 250);
          }

          try {
            window.history.replaceState({}, document.title, window.location.pathname);
          } catch (historyErr) {}

          return;
        } catch (retryErr) {}
      }

      // not logged in yet
      if (els.denRoot) els.denRoot.classList.remove('nw-pack-den--member');
      if (els.app) els.app.hidden = true;
      if (els.guestLandingShell) els.guestLandingShell.hidden = false;
      if (els.guestJoinCard) els.guestJoinCard.hidden = false;
      if (els.authCard) els.authCard.hidden = false;
      if (els.archiveShell) els.archiveShell.hidden = false;
      if (els.archiveMemberLogin) els.archiveMemberLogin.hidden = false;
      if (els.publicPreviewShell) els.publicPreviewShell.hidden = true;

      setArchiveExpanded(false);
      await ensureArchivePanelOpen();

      if (storedEmail && els.email) {
        els.email.value = storedEmail;
      }

      if (setupParam === '1') {
        showSetupForEmail(storedEmail);

        if (els.authCard) {
          setTimeout(function () {
            els.authCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (els.setupPackName) els.setupPackName.focus();
          }, 120);
        }
      } else {
        resetGuestAuth();

        if (storedEmail && els.email) {
          els.email.value = storedEmail;
        }

        if (sourceParam === 'subscriber-login' && els.authCard) {
          setTimeout(function () {
            els.authCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (els.email) els.email.focus();
          }, 120);
        }
      }
    } finally {
      if (els.denRoot) els.denRoot.classList.remove('nw-pack-den--checking-auth');
    }
  }

  const packNameInlineError = document.getElementById('nw-pack-name-error');

  function hidePackNameError() {
    if (!packNameInlineError) return;
    packNameInlineError.textContent = '';
    packNameInlineError.hidden = true;
  }

  function showPackNameError(message) {
    if (!packNameInlineError) return;
    packNameInlineError.textContent = message || '';
    packNameInlineError.hidden = !message;
  }

    function cleanEmail(value) {
    return String(value || '').trim().toLowerCase();
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function setInlineBusy(btn, busy, text) {
    if (!btn) return;

    if (busy) {
      btn.dataset.originalText = btn.textContent;
      btn.textContent = text || 'Working...';
      btn.disabled = true;
    } else {
      btn.textContent = btn.dataset.originalText || btn.textContent;
      btn.disabled = false;
    }
  }

  function showAuthStep(step) {
    if (els.stepRequest) els.stepRequest.hidden = step !== 'request';
    if (els.setupStep) els.setupStep.hidden = step !== 'setup';
    if (els.stepVerify) els.stepVerify.hidden = step !== 'verify';
    if (els.stepSubscribe) els.stepSubscribe.hidden = step !== 'subscribe';
  }

  function setDenEntryCopy(mode) {
    const topTitle = document.querySelector('#nw-guest-landing-shell .nw-den-entry-top-copy h1');
    const topCopy = document.querySelector('#nw-guest-landing-shell .nw-den-entry-top-copy p:not(.nw-den-entry-kicker)');
    const authTitle = els.authCard ? els.authCard.querySelector('h2') : null;
    const authCopy = els.authCard ? els.authCard.querySelector('h2 + p') : null;

    if (mode === 'setup') {
      if (topTitle) topTitle.textContent = 'Finish your Den access.';
      if (topCopy) topCopy.textContent = 'Choose your Pack name, confirm your email, and we will send your Den code.';
      if (authTitle) authTitle.textContent = 'Create your Pack name.';
      if (authCopy) authCopy.textContent = 'You are already on the Pack list. Choose your Pack name and we will send your Den code.';
      return;
    }

    if (topTitle) topTitle.textContent = 'Step into the Den.';
    if (topCopy) topCopy.textContent = 'Subscriber access for the letter archive, games, Pack XP, wolves, rewards, and member extras.';
    if (authTitle) authTitle.textContent = 'Enter the Den.';
    if (authCopy) authCopy.textContent = 'Your Den access starts here. Open the archive, games, rewards, wolves, and Pack progress with your newsletter email.';
  }

  function setDenSetupMode(active) {
    if (els.denRoot) {
      els.denRoot.classList.toggle('nw-pack-den--setup-mode', !!active);
    }

    if (els.guestJoinCard) {
      els.guestJoinCard.hidden = !!active;
    }

    setDenEntryCopy(active ? 'setup' : 'default');
  }

  function getPackNameValidationMessage(value, required = false) {
    const raw = String(value || '');
    const clean = raw.trim();

    if (!clean) {
      return required ? 'Pack name is required.' : '';
    }

    if (/\s/.test(raw)) {
      return 'No spaces allowed in your Pack name.';
    }

    if (/[^A-Za-z0-9._]/.test(raw)) {
      return 'Only letters, numbers, periods, and underscores are allowed. No other special characters.';
    }

    if (clean.length < 5) {
      return 'Must be at least 5 characters or longer.';
    }

    if (clean.length > 30) {
      return 'Pack name must be 30 characters or fewer.';
    }

    return '';
  }

  function resetGuestAuth() {
    hideAlert();
    hidePackNameError();
    setDenSetupMode(false);

    state.authEmailChecked = false;
    state.authRequiresPackName = false;
    state.pendingPackName = '';
    state.lastAuthEmail = '';

    if (els.packNameWrap) els.packNameWrap.hidden = true;
    if (els.sendCode) els.sendCode.hidden = true;
    if (els.checkEmail) els.checkEmail.hidden = false;
    if (els.packName) els.packName.value = '';
    if (els.setupPackName) els.setupPackName.value = '';
    if (els.code) els.code.value = '';

    showAuthStep('request');
  }

  function showSetupForEmail(email) {
    const clean = cleanEmail(email);

    hideAlert();
    hidePackNameError();
    setDenSetupMode(true);

    state.authEmailChecked = false;
    state.authRequiresPackName = false;
    state.pendingPackName = '';
    state.lastAuthEmail = clean;

    if (els.setupEmail) els.setupEmail.value = clean;
    showAuthStep('setup');

    if (els.setupPackName) els.setupPackName.focus();
  }

  if (els.joinForm) {
    els.joinForm.addEventListener('submit', function (event) {
      const email = cleanEmail(els.joinEmail && els.joinEmail.value);

      if (!validEmail(email)) {
        event.preventDefault();
        if (els.joinNote) els.joinNote.textContent = 'Enter a valid email first.';
        if (els.joinEmail) els.joinEmail.focus();
        return;
      }

      event.preventDefault();

      if (els.joinNote) els.joinNote.textContent = 'Adding your email...';
      setInlineBusy(els.joinSubmit, true, 'Joining...');

      try {
        HTMLFormElement.prototype.submit.call(els.joinForm);
      } catch (err) {
        if (els.joinNote) els.joinNote.textContent = 'Something blocked the signup. Try again.';
        setInlineBusy(els.joinSubmit, false);
        return;
      }

      setTimeout(function () {
        setInlineBusy(els.joinSubmit, false);

        if (els.joinNote) els.joinNote.textContent = 'You are in. The Den is ready when you are.';
        if (els.joinCardMain) els.joinCardMain.hidden = true;
        if (els.afterSubscribe) els.afterSubscribe.hidden = false;
        if (els.setupEmail) els.setupEmail.value = email;

        state.lastAuthEmail = email;

        if (els.afterSubscribe) {
          els.afterSubscribe.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 650);
    });
  }

  if (els.startDenSetup) {
    els.startDenSetup.addEventListener('click', function () {
      const email = cleanEmail(
        state.lastAuthEmail ||
        (els.joinEmail && els.joinEmail.value) ||
        (els.email && els.email.value)
      );

      showSetupForEmail(email);

      if (els.authCard) {
        els.authCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  if (els.skipDenSetup) {
    els.skipDenSetup.addEventListener('click', function () {
      if (!els.afterSubscribe) return;

      const heading = els.afterSubscribe.querySelector('h2');
      const paragraph = els.afterSubscribe.querySelector('p:not(.nw-den-entry-kicker)');

      if (heading) heading.textContent = 'You can enter later.';
      if (paragraph) paragraph.textContent = 'Use this same email whenever you want the archive, games, wolves, and Pack progress.';
    });
  }

  if (els.packName) {
    els.packName.addEventListener('input', () => {
      if (!state.authRequiresPackName) {
        hidePackNameError();
        return;
      }

      const message = getPackNameValidationMessage(els.packName.value, true);
      if (message) showPackNameError(message);
      else hidePackNameError();
    });
  }

  if (els.checkEmail) {
    els.checkEmail.addEventListener('click', async () => {
      hideAlert();
      hidePackNameError();

      state.authEmailChecked = false;
      state.authRequiresPackName = false;
      state.pendingPackName = '';

      if (els.packNameWrap) els.packNameWrap.hidden = true;
      if (els.sendCode) els.sendCode.hidden = true;
      if (els.checkEmail) els.checkEmail.hidden = false;
      if (els.packName) els.packName.value = '';

      const email = cleanEmail(els.email && els.email.value);

      if (!validEmail(email)) {
        showAlert('Enter your newsletter email first.');
        return;
      }

      state.lastAuthEmail = email;

      trackEvent('den_login_started', {
        source: 'check_email_button'
      });

      setInlineBusy(els.checkEmail, true, 'Checking...');

      try {
        const result = await api('/api/auth/check-email', 'POST', {
          email,
          referral_context: {
            ...getReferralContext(),
            source: 'den_check_email'
          }
        });

        if (!result.subscribed) {
          state.authEmailChecked = false;
          state.authRequiresPackName = false;
          state.pendingPackName = '';

          if (els.joinEmail) {
            els.joinEmail.value = email;
          }

          showAuthStep('subscribe');
          showAlert('That email is not currently subscribed to the Nature Wolf Pack letter. Join the free letter again before entering the Den.');

          if (els.guestJoinCard) {
            els.guestJoinCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }

          return;
        }

        state.authEmailChecked = true;
        state.authRequiresPackName = !!result.requires_pack_name;

        if (state.authRequiresPackName) {
          if (els.packNameWrap) els.packNameWrap.hidden = false;
          if (els.sendCode) els.sendCode.hidden = false;
          if (els.checkEmail) els.checkEmail.hidden = true;

          showAlert('First time in the Den. Choose your Pack name, then send your code.');
          if (els.packName) els.packName.focus();
          return;
        }

        await api('/api/auth/request-code', 'POST', {
          email,
          referral_context: {
            ...getReferralContext(),
            source: 'den_auto_request_code'
          }
        });

        showAuthStep('verify');
        showAlert('Your 6-digit Den code was sent. Check your email.');
        if (els.code) els.code.focus();
      } catch (err) {
        const msg = String(err.message || '').toLowerCase();

        if (msg.includes('not in the pack')) {
          showAuthStep('request');

          if (els.joinEmail) {
            els.joinEmail.value = email;
          }

          showAlert('That email is not active in the Pack. Use the email you subscribed with, or join the free letter first.');

          if (els.guestJoinCard) {
            els.guestJoinCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        } else {
          showAlert(err.message);
        }
      } finally {
        setInlineBusy(els.checkEmail, false);
      }
    });
  }

  if (els.sendCode) {
    els.sendCode.addEventListener('click', async () => {
      hideAlert();
      hidePackNameError();

      if (!state.authEmailChecked) {
        showAlert('Enter your newsletter email first, then continue.');
        return;
      }

      const packNameValue = els.packName ? els.packName.value : '';
      const validationMessage = getPackNameValidationMessage(packNameValue, true);

      if (validationMessage) {
        showPackNameError(validationMessage);
        return;
      }

      state.pendingPackName = String(packNameValue || '').trim();

      trackEvent('den_login_started', {
        source: 'send_code_button',
        requires_pack_name: !!state.authRequiresPackName
      });

      setInlineBusy(els.sendCode, true, 'Sending...');

      try {
        await api('/api/auth/request-code', 'POST', {
          email: cleanEmail(els.email && els.email.value),
          referral_context: {
            ...getReferralContext(),
            source: 'den_request_code'
          }
        });

        showAuthStep('verify');
        showAlert('Your 6-digit Den code was sent. Check your email.');
        if (els.code) els.code.focus();
      } catch (err) {
        showAlert(err.message);
      } finally {
        setInlineBusy(els.sendCode, false);
      }
    });
  }

  if (els.setupSend) {
    els.setupSend.addEventListener('click', async () => {
      hideAlert();
      hidePackNameError();

      const email = cleanEmail(els.setupEmail && els.setupEmail.value);
      const packName = String(els.setupPackName && els.setupPackName.value || '').trim();
      const validationMessage = getPackNameValidationMessage(packName, true);

      if (!validEmail(email)) {
        showAlert('Enter a valid email first.');
        if (els.setupEmail) els.setupEmail.focus();
        return;
      }

      if (validationMessage) {
        showAlert(validationMessage);
        if (els.setupPackName) els.setupPackName.focus();
        return;
      }

      setInlineBusy(els.setupSend, true, 'Sending...');

      try {
        await api('/api/auth/subscribe-request-code', 'POST', {
          email,
          pack_name: packName,
          referral_context: {
            ...getReferralContext(),
            source: 'den_members_only_setup'
          }
        });

        state.lastAuthEmail = email;
        state.pendingPackName = packName;
        state.authEmailChecked = true;
        state.authRequiresPackName = true;

        if (els.email) els.email.value = email;
        if (els.packName) els.packName.value = packName;

        showAuthStep('verify');
        showAlert('Your 6-digit Den code was sent. Check your email.');
        if (els.code) els.code.focus();
      } catch (err) {
        showAlert(err.message);
      } finally {
        setInlineBusy(els.setupSend, false);
      }
    });
  }

  if (els.verify) {
    els.verify.addEventListener('click', async () => {
      hideAlert();
      hidePackNameError();

      const email = cleanEmail(
        state.lastAuthEmail ||
        (els.email && els.email.value) ||
        (els.setupEmail && els.setupEmail.value)
      );

      const code = String(els.code && els.code.value || '').trim();
      const packName = String(
        state.pendingPackName ||
        (els.packName && els.packName.value) ||
        (els.setupPackName && els.setupPackName.value) ||
        ''
      ).trim();

      if (!validEmail(email)) {
        showAlert('Email is missing. Go back and enter it again.');
        return;
      }

      if (!code) {
        showAlert('Enter the 6-digit code from your email.');
        return;
      }

      const payload = {
        email,
        code,
        referral_context: {
          ...getReferralContext(),
          source: 'den_verify_code'
        }
      };

      if (state.authRequiresPackName || packName) {
        const validationMessage = getPackNameValidationMessage(packName, true);

        if (validationMessage) {
          showPackNameError(validationMessage);
          return;
        }

        payload.pack_name = packName;
      }

      setInlineBusy(els.verify, true, 'Entering...');

      try {
        await api('/api/auth/verify-code', 'POST', payload);
        await refreshData();

        trackEvent('den_login_completed', {
          source: 'verify_code_button',
          created_pack_name: !!packName
        });

        showAuthStep('request');
      } catch (err) {
        const msg = String(err.message || '');

        if (msg.toLowerCase().includes('name unavailable')) {
          showPackNameError('That Pack name is already taken. Try another.');
          return;
        }

        showAlert(err.message);
      } finally {
        setInlineBusy(els.verify, false);
      }
    });
  }

  if (els.back) {
    els.back.addEventListener('click', resetGuestAuth);
  }

  if (els.setupBack) {
    els.setupBack.addEventListener('click', function () {
      const email = cleanEmail(els.setupEmail && els.setupEmail.value);
      resetGuestAuth();
      if (els.email) els.email.value = email;
    });
  }



  if (els.archiveSearch) {
    els.archiveSearch.addEventListener('input', () => {
      filterArchivePosts(els.archiveSearch.value);
    });
  }
  if (els.archiveTypeFilters) {
  els.archiveTypeFilters.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-archive-type]');
    if (!btn) return;

    state.archiveTypeFilter = String(btn.dataset.archiveType || 'all').trim().toLowerCase();

    els.archiveTypeFilters.querySelectorAll('[data-archive-type]').forEach((item) => {
      item.classList.toggle('is-active', item === btn);
    });

    filterArchivePosts(els.archiveSearch ? els.archiveSearch.value : '');
  });
}

  if (els.archivePrev) {
    els.archivePrev.addEventListener('click', () => {
      if (state.archivePage <= 1) return;
      state.archivePage -= 1;
      renderArchiveList();
    });
  }

  if (els.archiveNext) {
    els.archiveNext.addEventListener('click', () => {
      const totalPages = Math.max(1, Math.ceil((state.archiveFiltered || []).length / state.archivePageSize));
      if (state.archivePage >= totalPages) return;
      state.archivePage += 1;
      renderArchiveList();
    });
  }

  async function openCustomizeForRank(wolfId = null, rankKey = null) {
    await refreshMemberState();

    const fallbackWolf =
      (wolfId && Array.isArray(state.wolves)
        ? state.wolves.find((entry) => Number(entry.id) === Number(wolfId))
        : null) ||
      (rankKey && Array.isArray(state.wolves)
        ? state.wolves.find((entry) => entry.rank_key === rankKey)
        : null) ||
      (Array.isArray(state.wolves)
        ? state.wolves.find((wolf) => Number(wolf.id) === Number(state.selectedWolfId))
        : null) ||
      state.wolves?.find((wolf) => wolf.is_current) ||
      state.wolves?.[0] ||
      null;

    if (fallbackWolf) {
      state.selectedWolfId = Number(fallbackWolf.id);
      const wolf = fallbackWolf;

      if (wolf) {
        state.editorLayout = JSON.parse(JSON.stringify(wolf.equipped_items || [])).map((item) => ({
          ...item,
          z_index: Math.max(1, Number(item.z_index || 1))
        }));

        if (els.editorBaseWolf) {
          els.editorBaseWolf.src = wolf.base_image_url || '';
          els.editorBaseWolf.alt = wolf.rank_name || 'Wolf';
        }
      }
    }

    resetEditorAutosaveState('All changes saved');

    normalizeEditorLayerOrder();
    openModal('customize');
    renderWolfList();
    renderStage(els.editorStage, state.editorLayout, true);
    renderEditorLayerStrip();
    renderOwnedList();
  }

  if (els.openCustomize) {
    els.openCustomize.addEventListener('click', async () => {
      await openCustomizeForRank();
    });
  }

  if (els.stage) {
    els.stage.addEventListener('click', async () => {
      const currentWolf = Array.isArray(state.wolves)
        ? state.wolves.find((wolf) => wolf.is_current) || state.wolves[0] || null
        : null;
      const previewWolf = getMainStagePreviewWolf(currentWolf?.rank_key || state.me?.rank?.key || null) || currentWolf;
      await openCustomizeForRank(Number(previewWolf?.id || 0), previewWolf?.rank_key || null);
    });
  }

  if (els.saveWolfLayout) {
    els.saveWolfLayout.addEventListener('click', async () => {
      await saveEditorLayout({ silent: false });
    });
  }

  if (els.openStore) {
    els.openStore.addEventListener('click', () => openModal('store'));
  }

  if (els.previewOpenStyling) {
    els.previewOpenStyling.addEventListener('click', async () => {
      await openCustomizeForRank();
    });
  }

  if (els.previewOpenShop) {
    els.previewOpenShop.addEventListener('click', () => openModal('store'));
  }

  if (els.combinedTabWolves) {
    els.combinedTabWolves.addEventListener('click', (e) => {
      e.preventDefault();
      setCombinedModalTab('wolves');
    });
  }

  if (els.combinedTabShop) {
    els.combinedTabShop.addEventListener('click', (e) => {
      e.preventDefault();
      setCombinedModalTab('shop');
    });
  }

  if (els.storeCloseSide) {
    els.storeCloseSide.addEventListener('click', () => closeModals());
  }

  if (els.openPackModal) {
    els.openPackModal.addEventListener('click', () => openModal('pack'));
  }

  if (els.summaryViewLeaderboard) {
    els.summaryViewLeaderboard.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openModal('pack');
    });
  }

  if (els.packMemberClose) {
    els.packMemberClose.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      await closeModals();
    });
  }

  if (els.packPrev) {
    els.packPrev.addEventListener('click', async () => {
      if (state.packPage <= 1) return;
      await loadPackPage(state.packPage - 1);
    });
  }

  if (els.packNext) {
    els.packNext.addEventListener('click', async () => {
      if (!state.packHasNext) return;
      await loadPackPage(state.packPage + 1);
    });
  }

  els.backdrop.addEventListener('click', async () => {
    if (els.shareModal && !els.shareModal.hidden) {
      closeArchiveShareModal();
      forceUnlockPageAfterModalClose();
      return;
    }

    if (els.treasureChestModal && !els.treasureChestModal.hidden) {
      closeTreasureChestModal();
      forceUnlockPageAfterModalClose();
      return;
    }

    if (els.customizeModal && !els.customizeModal.hidden) {
      await closeCustomizeModal();
      forceUnlockPageAfterModalClose();
      return;
    }

    await closeModals();
    forceUnlockPageAfterModalClose();
  });

  if (els.shareClose) {
    els.shareClose.addEventListener('click', closeArchiveShareModal);
  }

  if (els.shareCopy) {
    els.shareCopy.addEventListener('click', () => {
      shareArchiveLetter('copy').catch((err) => setShareStatus(err.message || 'Could not copy link.', false));
    });
  }

  [
    ['shareNative', 'native'],
    ['shareEmail', 'email'],
    ['shareSms', 'sms'],
    ['shareFacebook', 'facebook'],
    ['shareX', 'x'],
    ['shareWhatsapp', 'whatsapp'],
    ['shareReddit', 'reddit'],
    ['shareLinkedin', 'linkedin']
  ].forEach(([key, channel]) => {
    const btn = els[key];
    if (!btn) return;

    btn.addEventListener('click', () => {
      shareArchiveLetter(channel).catch((err) => {
        setShareStatus(err.message || 'Share could not be completed.', false);
      });
    });
  });

  document.querySelectorAll('[data-close-modal]').forEach(btn => {
    btn.addEventListener('click', async (event) => {
      if (event.target && event.target.closest('#nw-customize-modal')) {
        await closeCustomizeModal();
        forceUnlockPageAfterModalClose();
        return;
      }

      await closeModals();
      forceUnlockPageAfterModalClose();
    });
  });
    document.querySelectorAll('[data-close-modal]').forEach(btn => {
    btn.addEventListener('click', async (event) => {
      if (event.target && event.target.closest('#nw-customize-modal')) {
        await closeCustomizeModal();
        forceUnlockPageAfterModalClose();
        return;
      }

      await closeModals();
      forceUnlockPageAfterModalClose();
    });
  });

  if (els.customizeCloseBottom) {
    els.customizeCloseBottom.addEventListener('click', async () => {
      await closeCustomizeModal();
      maybeShowQueuedRankUnlock();
    });
  }

  if (els.rankUnlockClose) {
    els.rankUnlockClose.addEventListener('click', () => hideRankUnlockPopup());
  }

  if (els.rankUnlockContinue) {
    els.rankUnlockContinue.addEventListener('click', () => hideRankUnlockPopup());
  }

  if (els.rankUnlockOpenCustomize) {
    els.rankUnlockOpenCustomize.addEventListener('click', async () => {
      const rankKey = state.lastRenderedRankKey || state.me?.rank?.key || null;
      hideRankUnlockPopup();
      await openCustomizeForRank(rankKey);
    });
  }
    if (els.swagUnlockClose) {
    els.swagUnlockClose.addEventListener('click', () => hideSwagUnlockPopup());
  }

  if (els.swagUnlockContinue) {
    els.swagUnlockContinue.addEventListener('click', () => hideSwagUnlockPopup());
  }

  function openSwagUnlockStoreFromPopup() {
    hideSwagUnlockPopup();
    state.storeTab = 'swag';
    openModal('store');
    renderStore();
    finalizeCollectionStoreRender();
  }

  if (els.swagUnlockOpenStore) {
    els.swagUnlockOpenStore.addEventListener('click', () => {
      openSwagUnlockStoreFromPopup();
    });
  }

  if (els.swagUnlockImage) {
    els.swagUnlockImage.addEventListener('click', () => {
      const storeButtonVisible = els.swagUnlockOpenStore && !els.swagUnlockOpenStore.hidden;
      const itemRevealed = els.swagUnlockImage.classList.contains('is-revealed');

      if (!storeButtonVisible || !itemRevealed) return;

      openSwagUnlockStoreFromPopup();
    });
  }

  if (els.swagUnlockNext) {
  els.swagUnlockNext.addEventListener('click', () => {
    const queue = Array.isArray(state.activeSwagUnlockQueue)
      ? state.activeSwagUnlockQueue
      : [];

    const nextIndex = Number(state.activeSwagUnlockIndex || 0) + 1;
    if (!queue[nextIndex]) return;

    showSwagUnlockRandomizer(queue, nextIndex);
  });
}
  if (els.trailsRoundClaimSwag) {
    els.trailsRoundClaimSwag.addEventListener('click', () => {
      if (!state.trailsPendingSwagClaim) return;
      claimEarnedSwagDrop(state.trailsPendingSwagClaim, els.trailsRoundClaimSwag);
    });
  }

  if (els.simResultClaimSwag) {
    els.simResultClaimSwag.addEventListener('click', () => {
      if (!state.simPendingSwagClaim) return;
      claimEarnedSwagDrop(state.simPendingSwagClaim, els.simResultClaimSwag);
    });
  }
  if (els.treasureChestButton) {
    els.treasureChestButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      handleTreasureChestOpen();
    });
  }

  if (els.heartChestButton) {
    els.heartChestButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      handleHeartChestOpen();
    });
  }

  if (els.treasureChestClose) {
    els.treasureChestClose.addEventListener('click', () => {
      closeTreasureChestModal();
    });
  }

  [els.customizeModal, els.packModal, els.packMemberModal, els.goalsModal, els.trailsModal, els.treasureChestModal].forEach(modal => {
        if (!modal) return;
    modal.addEventListener('click', async (event) => {
      if (event.target !== modal) return;

      if (modal === els.customizeModal) {
        await closeCustomizeModal();
        return;
      }

      if (modal === els.treasureChestModal) {
        closeTreasureChestModal();
        return;
      }

      closeModals();
    });
  });

  els.removeSelected.addEventListener('click', () => {
    if (!state.selectedItemId) return;
    state.editorLayout = state.editorLayout.filter((x) => Number(x.purchase_id || x.item_id) !== Number(state.selectedItemId));
    state.selectedItemId = null;
    normalizeEditorLayerOrder();
    renderStage(els.editorStage, state.editorLayout, true);
    renderEditorLayerStrip();
    renderWolfList();
    renderOwnedList();
    markEditorDirty();
  });

  els.clearAll.addEventListener('click', () => {
    state.editorLayout = [];
    state.selectedItemId = null;
    renderStage(els.editorStage, state.editorLayout, true);
    renderEditorLayerStrip();
    renderOwnedList();
    markEditorDirty();
  });


  // Goals modal open/close events
  async function openGoalsModalToTab(tab) {
    trackFirstDenAction(tab === 'challenges' ? 'achievements_opened' : 'games_opened', {
      source: 'goals_modal',
      tab
    });

    trackEvent(tab === 'challenges' ? 'achievements_opened' : 'game_opened', {
      source: 'goals_modal',
      tab
    });

    await openGoalsModal();

    try {
      const res = await api('/api/games/trails/state');
      const trails = res.trivia_trails || res.trails || null;
      if (trails) {
        state.trailsState = trails;
        if (state.me) state.me.trivia_trails = trails;
      }
    } catch (e) {}

    renderGoalsBalances();
    refreshSimMenu();
    setGcTab(tab);
  }

  if (els.openGoals) {
    els.openGoals.addEventListener('click', (e) => {
      e.preventDefault();
      openGoalsModalToTab('games');
    });
  }

  const openTriviaMainBtn = document.getElementById('nw-open-trivia-main');
  if (openTriviaMainBtn) {
    openTriviaMainBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openGoalsModalToTab('games');
    });
  }

  const openAchievementsMainBtn = document.getElementById('nw-open-achievements-main');
  if (openAchievementsMainBtn) {
    openAchievementsMainBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openGoalsModalToTab('challenges');
    });
  }

  if (els.denRoot && !els.denRoot.__nwReferralCopyBound) {
    els.denRoot.__nwReferralCopyBound = true;

    els.denRoot.addEventListener('click', async (event) => {
      const copyBtn = event.target.closest('[data-nw-copy-referral]');
      if (!copyBtn) return;

      event.preventDefault();
      event.stopPropagation();

      await copyPackReferralUrl(copyBtn);
    });
  }

  if (els.goalsClose) {
    els.goalsClose.addEventListener('click', (e) => {
      e.preventDefault();
      closeGoalsModal();
    });
  }



  if (els.trailsClose) {
    els.trailsClose.addEventListener('click', (e) => {
      e.preventDefault();
      closeTrailsModal(true);
    });
  }

  if (els.trailsBackBtn) {
    els.trailsBackBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeTrailsModal(true);
    });
  }

  if (els.trailsMenuBtn) {
    els.trailsMenuBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      clearTrailsTimer();
      await loadTrailsState();
    });
  }

  if (els.trailsStartBtn) {
    els.trailsStartBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      await startNextTrailsQuestion();
    });
  }
if (els.trailsBiomeGrid) {
  els.trailsBiomeGrid.addEventListener('click', async (e) => {
    const trigger = e.target.closest('[data-action="resume-trail"]');
    if (!trigger) return;
    e.preventDefault();

    if (Number(state.trailsState?.hearts || 0) < 1) {
      await loadTrailsState();
      return;
    }

    await startNextTrailsQuestion();
  });

  els.trailsBiomeGrid.addEventListener('keydown', async (e) => {
    const trigger = e.target.closest('[data-action="resume-trail"]');
    if (!trigger) return;
    if (e.key !== 'Enter' && e.key !== ' ') return;

    e.preventDefault();

    if (Number(state.trailsState?.hearts || 0) < 1) {
      await loadTrailsState();
      return;
    }

    await startNextTrailsQuestion();
  });
}

if (els.trailsLifetimeToggle) {
  els.trailsLifetimeToggle.addEventListener('click', (e) => {
    e.preventDefault();
    state.trailsStatsExpanded = !state.trailsStatsExpanded;
    renderTrailsLifetimeStats();
  });
}

  if (els.trailsNextBtn) {
    els.trailsNextBtn.addEventListener('click', async (e) => {
      e.preventDefault();

      if (state.trailsRoundSummary) {
        showTrailsRoundComplete(state.trailsRoundSummary);
        return;
      }

      if (state.trailsBiomeSummary) {
        showTrailsBiomeComplete(state.trailsBiomeSummary);
        return;
      }

      if (Number(state.trailsState?.hearts || 0) < 1) {
        await loadTrailsState();
        return;
      }

      await startNextTrailsQuestion();
    });
  }

  if (els.trailsRoundCompleteContinue) {
    els.trailsRoundCompleteContinue.addEventListener('click', async () => {
      hideTrailsRoundComplete();
      if (Number(state.trailsState?.hearts || 0) > 0 && state.trailsState?.has_available_round !== false) {
        await startNextTrailsQuestion();
      } else {
        renderTrailsMenu();
      }
    });
  }

  if (els.trailsBiomeCompleteContinue) {
    els.trailsBiomeCompleteContinue.addEventListener('click', async () => {
      hideTrailsBiomeComplete();
      if (Number(state.trailsState?.hearts || 0) > 0) {
        await startNextTrailsQuestion();
      } else {
        renderTrailsMenu();
      }
    });
  }

  if (els.trailsRoundCompleteClose) {
    els.trailsRoundCompleteClose.addEventListener('click', async (e) => {
      e.preventDefault();
      hideTrailsRoundComplete();
      await loadTrailsState();
    });
  }




  // Cancel subscription flow and return to login
  if (els.subscribeCancel) {
    els.subscribeCancel.addEventListener('click', () => {
      resetGuestAuth();
    });
  }

  // Log out of the current session and reset UI
  if (els.logout) {
    els.logout.addEventListener('click', async () => {
      hideAlert();
      try {
        await api('/api/auth/logout', 'POST');
        state.me = null;
        state.pendingAwards = [];
        if (els.denRoot) els.denRoot.classList.remove('nw-pack-den--member');
        // Hide logged-in sections and show the auth card
        if (els.app) els.app.hidden = true;
        if (els.guestLandingShell) els.guestLandingShell.hidden = false;
        if (els.guestJoinCard) els.guestJoinCard.hidden = false;
        if (els.authCard) els.authCard.hidden = false;
        if (els.archiveMemberLogin) els.archiveMemberLogin.hidden = false;
        setArchiveExpanded(true);
        if (els.publicPreviewShell) els.publicPreviewShell.hidden = true;
        if (els.archiveShell) els.archiveShell.hidden = false;
        await ensureArchivePanelOpen();
        // Reset auth steps
        resetGuestAuth();
        if (els.stepSubscribe) els.stepSubscribe.hidden = true;
        if (els.setupStep) els.setupStep.hidden = true;

        if (els.joinCardMain) els.joinCardMain.hidden = false;
        if (els.afterSubscribe) els.afterSubscribe.hidden = true;

        // Clear input fields
        if (els.packName) els.packName.value = '';
        if (els.setupPackName) els.setupPackName.value = '';
        if (els.code) els.code.value = '';
        showAlert('Logged out.');
      } catch (err) {
        showAlert(err.message);
      }
    });
  }

 // ===================================================================
  // ============ NATURE WOLF PACK SIMULATOR (client engine) ===========
  // ===================================================================
  // Server controls levels, map size, prey counts, predator counts,
  // time limit, rewards, wolf stats, animal stats, and saved wolf layouts.
  // Client controls real-time movement, drawing, health bars, stamina,
  // attacks, fleeing, predator pressure, and the visible simulation.
  // -------------------------------------------------------------------

  const SIM_ASSETS = {
    grass: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/Realgrass.background.png?v=1756933447',
    caterpillar: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/caterpillar_final.png?v=1772680787',
    bison: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/bisongraphic.png?v=1765827427',
    beaver: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/beavergraphic.png?v=1772677372',
    bullfrog: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/bullfroggraphic.png?v=1772677697',
    mouse: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/mouse.prey.png?v=1755624075',
    rabbit: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/rabbit.prey.png?v=1755625149',
    deer: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/deer.prey.png?v=1755624925',
    elk: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/elk.prey.png?v=1755624934',
    moose: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/moose.prey.png?v=1755625078',
    grizzly: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/grizzlyb.png?v=1765826156',
    mountainlion: 'https://cdn.shopify.com/s/files/1/0686/5764/3564/files/mountainliongraphic.png?v=1770873089'
  };

  const SIM_SPECIES_LABELS = {
    caterpillar: 'Caterpillar',
    mouse: 'Mouse',
    rabbit: 'Rabbit',
    bullfrog: 'Bullfrog',
    beaver: 'Beaver',
    deer: 'Deer',
    elk: 'Elk',
    moose: 'Moose',
    bison: 'Bison',
    grizzly: 'Grizzly',
    mountainlion: 'Mountain Lion'
  };

  const simImageCache = new Map();
  function simLoadImage(url) {
    if (!url) return Promise.resolve(null);
    if (simImageCache.has(url)) return simImageCache.get(url);
    const p = new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = () => resolve(null);
      img.src = url;
    });
    simImageCache.set(url, p);
    return p;
  }

  async function buildWolfPortraitCanvas(wolf, size = 220) {
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');

    const base = await simLoadImage(wolf.base_image_url);
    if (base) {
      const pad = size * 0.0725;
      ctx.drawImage(base, pad, pad, size - pad * 2, size - pad * 2);
    }

    const items = (wolf.equipped_items || []).slice().sort(
      (a, b) => (Number(a.z_index || 1) - Number(b.z_index || 1))
    );

    for (const item of items) {
      const img = await simLoadImage(item.image_url);
      if (!img) continue;

      const x = (Number(item.x || 0) / 100) * size;
      const y = (Number(item.y || 0) / 100) * size;
      const w = (Number(item.w || 0) / 100) * size;
      const h = (Number(item.h || 0) / 100) * size;
      const rot = (Number(item.rotation || 0) * Math.PI) / 180;

      ctx.save();
      ctx.translate(x + w / 2, y + h / 2);
      ctx.rotate(rot);
      ctx.drawImage(img, -w / 2, -h / 2, w, h);
      ctx.restore();
    }

    return canvas;
  }

  function createPackSimEngine(opts) {
    const canvas = opts.canvas;
    const ctx = canvas.getContext('2d');
    const snapshot = opts.snapshot;
    const level = snapshot.level;
    const stats = snapshot.animal_stats || {};
    const onTick = typeof opts.onTick === 'function' ? opts.onTick : () => {};
    const onEnd = typeof opts.onEnd === 'function' ? opts.onEnd : () => {};

    const WORLD_W = Number(level.world_w || 1000);
    const WORLD_H = Number(level.world_h || 600);
    const MAX_DT = 0.05;

    const dpr = Math.max(1, window.devicePixelRatio || 1);

    function resize() {
      const rect = canvas.getBoundingClientRect();
      canvas.width = Math.max(1, Math.floor(rect.width * dpr));
      canvas.height = Math.max(1, Math.floor(rect.height * dpr));
    }

    resize();
    window.addEventListener('resize', resize);

    let grassImg = null;
    const animalImages = new Map();
    const wolfPortraits = new Map();

    function statForSpecies(species, fallback = 'caterpillar') {
      return stats[species] || stats[fallback] || {
        health: 10,
        strength: 1,
        speed: 50,
        sprint_mult: 1.2,
        stamina_max: 2,
        stamina_regen: 1,
        fov: 100,
        radius: 12,
        behavior: 'wander'
      };
    }

    function statForWolf(wolf) {
      return wolf.stats || stats[wolf.rank_key] || stats.wolf || {
        health: 72,
        strength: 16,
        speed: 126,
        sprint_mult: 1.82,
        stamina_max: 7.4,
        stamina_regen: 1.45,
        fov: 300,
        radius: 22
      };
    }

    function dist(a, b) {
      return Math.hypot(Number(a.x || 0) - Number(b.x || 0), Number(a.y || 0) - Number(b.y || 0));
    }

    function angleTo(a, b) {
      return Math.atan2(Number(b.y || 0) - Number(a.y || 0), Number(b.x || 0) - Number(a.x || 0));
    }

    function clampWorld(entity) {
      const r = Number(entity.radius || 12);
      const oldX = Number(entity.x || 0);
      const oldY = Number(entity.y || 0);

      entity.x = clamp(oldX, r, WORLD_W - r);
      entity.y = clamp(oldY, r, WORLD_H - r);

      const hitX = entity.x !== oldX;
      const hitY = entity.y !== oldY;

      if (hitX || hitY) {
        const current = Number(entity.heading || 0);

        if (hitX && hitY) {
          entity.heading = current + Math.PI + ((Math.random() - 0.5) * 0.8);
        } else if (hitX) {
          entity.heading = Math.PI - current + ((Math.random() - 0.5) * 0.55);
        } else if (hitY) {
          entity.heading = -current + ((Math.random() - 0.5) * 0.55);
        }

        entity.wanderTimer = 0;
        entity.edgeRecoverUntil = performance.now() + 650;
      }
    }

    function moveEntity(entity, angle, speed, dt) {
      const r = Number(entity.radius || 12);
      const nearLeft = Number(entity.x || 0) < r + 38;
      const nearRight = Number(entity.x || 0) > WORLD_W - r - 38;
      const nearTop = Number(entity.y || 0) < r + 38;
      const nearBottom = Number(entity.y || 0) > WORLD_H - r - 38;

      let finalAngle = angle;

      if (nearLeft || nearRight || nearTop || nearBottom || Number(entity.edgeRecoverUntil || 0) > performance.now()) {
        const centerAngle = Math.atan2((WORLD_H / 2) - Number(entity.y || 0), (WORLD_W / 2) - Number(entity.x || 0));
        finalAngle = (angle * 0.35) + (centerAngle * 0.65);
      }

      entity.heading = finalAngle;
      entity.vx = Math.cos(finalAngle) * speed;
      entity.vy = Math.sin(finalAngle) * speed;
      entity.x += entity.vx * dt;
      entity.y += entity.vy * dt;
      clampWorld(entity);
    }

    function nearestLiving(from, list, maxRange = Infinity) {
      let best = null;
      let bestDist = maxRange;
      for (const item of list) {
        if (!item.alive) continue;
        const d = dist(from, item);
        if (d < bestDist) {
          best = item;
          bestDist = d;
        }
      }
      return best;
    }

    function useSprint(entity, st, wantsSprint, dt) {
      if (!entity.alive) return 1;
      if (wantsSprint && entity.stamina > 0.05) {
        entity.stamina = Math.max(0, entity.stamina - dt);
        return Number(st.sprint_mult || 1.3);
      }
      entity.stamina = Math.min(
        Number(st.stamina_max || 2),
        Number(entity.stamina || 0) + Number(st.stamina_regen || 1) * dt
      );
      return 1;
    }

    function hurtEntity(entity, damage) {
      if (!entity || !entity.alive) return false;
      entity.health = Math.max(0, Number(entity.health || 0) - Number(damage || 0));
      if (entity.health <= 0) {
        entity.alive = false;
        return true;
      }
      return false;
    }

    function drawVitalsBars(entity, sx, sy, sw, statBlock) {
      const maxHealth = Math.max(1, Number(entity.max_health || entity.health || 1));
      const health = clamp(Number(entity.health || 0), 0, maxHealth);
      const healthRatio = health / maxHealth;

      const maxStamina = Math.max(1, Number(statBlock?.stamina_max || entity.stamina_max || 1));
      const stamina = clamp(Number(entity.stamina || 0), 0, maxStamina);
      const staminaRatio = stamina / maxStamina;

      const barW = Math.max(24, Math.min(64, sw * 0.72));
      const healthH = 5;
      const staminaH = 3;
      const x = sx - barW / 2;
      const y = sy - sw * 0.56 - 14;

      ctx.save();

      ctx.fillStyle = 'rgba(0,0,0,0.58)';
      ctx.fillRect(x - 1, y - 1, barW + 2, healthH + 2);
      ctx.fillStyle = 'rgba(130,22,22,0.92)';
      ctx.fillRect(x, y, barW, healthH);
      ctx.fillStyle = healthRatio > 0.55 ? 'rgba(104,222,79,0.95)' : healthRatio > 0.25 ? 'rgba(241,188,55,0.95)' : 'rgba(255,78,62,0.95)';
      ctx.fillRect(x, y, barW * healthRatio, healthH);

      const staminaY = y + healthH + 4;
      ctx.fillStyle = 'rgba(0,0,0,0.48)';
      ctx.fillRect(x - 1, staminaY - 1, barW + 2, staminaH + 2);
      ctx.fillStyle = 'rgba(34,62,86,0.88)';
      ctx.fillRect(x, staminaY, barW, staminaH);
      ctx.fillStyle = 'rgba(124,210,255,0.95)';
      ctx.fillRect(x, staminaY, barW * staminaRatio, staminaH);

      ctx.restore();
    }

    const wolves = (snapshot.wolves || []).map((w, idx) => {
      const wolfStats = statForWolf(w);
      const angle = (idx / Math.max(1, snapshot.wolves.length)) * Math.PI * 2;
      const maxHealth = Number(w.max_health || w.health || wolfStats.health || 72);
      return {
        wolf_id: w.wolf_id,
        species: String(w.rank_key || 'wolf'),
        role: 'wolf',
        meta: w,
        x: WORLD_W / 2 + Math.cos(angle) * 44,
        y: WORLD_H / 2 + Math.sin(angle) * 44,
        vx: 0,
        vy: 0,
        heading: angle,
        stamina: Number(wolfStats.stamina_max || 6),
        health: maxHealth,
        max_health: maxHealth,
        radius: Number(wolfStats.radius || 22),
        alive: true,
        target: null,
        attackCooldown: 0,
        hitFlash: 0
      };
    });

    const rawAnimals = Array.isArray(snapshot.animals) && snapshot.animals.length
      ? snapshot.animals
      : (snapshot.prey || []).map((p) => ({ ...p, role: 'prey' }));

    const animals = rawAnimals.map((p) => {
      const st = statForSpecies(p.species);
      const maxHealth = Number(p.max_health || p.health || st.health || 10);
      return {
        id: p.id,
        species: p.species,
        role: p.role || 'prey',
        x: Number(p.x || 0),
        y: Number(p.y || 0),
        vx: 0,
        vy: 0,
        heading: Number(p.heading || 0),
        stamina: Number(st.stamina_max || 1.5),
        health: maxHealth,
        max_health: maxHealth,
        radius: Number(st.radius || 12),
        alive: true,
        wanderTimer: 0,
        attackCooldown: 0,
        hitFlash: 0,
        behavior: st.behavior || (p.role === 'predator' ? 'predator' : 'wander')
      };
    });

    const captures = [];
    let startTime = 0;
    let lastTime = 0;
    let running = false;
    let rafId = 0;

    const prey = animals.filter((a) => a.role === 'prey');
    const predators = animals.filter((a) => a.role === 'predator');

    async function preload() {
      grassImg = await simLoadImage(SIM_ASSETS.grass);

      const neededSpecies = new Set(animals.map((a) => a.species));
      for (const species of neededSpecies) {
        const img = await simLoadImage(SIM_ASSETS[species]);
        if (img) animalImages.set(species, img);
      }

      for (const w of wolves) {
        const portrait = await buildWolfPortraitCanvas(w.meta, 220);
        wolfPortraits.set(w.wolf_id, portrait);
      }
    }

    function updateWolves(dt) {
      for (const wolf of wolves) {
        if (!wolf.alive) continue;

        const wolfStats = statForWolf(wolf.meta);
        wolf.attackCooldown = Math.max(0, Number(wolf.attackCooldown || 0) - dt);
        wolf.hitFlash = Math.max(0, Number(wolf.hitFlash || 0) - dt);

        const closestPredator = nearestLiving(wolf, predators, Number(wolfStats.fov || 300) * 0.9);
        const closestVisiblePrey = nearestLiving(wolf, prey, Number(wolfStats.fov || 300) * 1.35);
        const closestAnyPrey = nearestLiving(wolf, prey, Infinity);

        let target = closestVisiblePrey || closestAnyPrey;
        let isTrackingDistantPrey = !closestVisiblePrey && !!closestAnyPrey;
        let fleeFrom = null;

        if (closestPredator) {
          const predatorStats = statForSpecies(closestPredator.species, 'grizzly');
          const danger = Number(predatorStats.strength || 0) > Number(wolfStats.strength || 0) * 1.15;
          if (danger && dist(wolf, closestPredator) < Number(predatorStats.fov || 260) * 0.55) {
            fleeFrom = closestPredator;
            target = null;
          }
        }

        if (fleeFrom) {
          const away = angleTo(fleeFrom, wolf);
          const sprintMult = useSprint(wolf, wolfStats, true, dt);
          moveEntity(wolf, away, Number(wolfStats.speed || 110) * sprintMult, dt);
          continue;
        }

        if (target) {
          const d = dist(wolf, target);
          const sprintMult = useSprint(wolf, wolfStats, !isTrackingDistantPrey && d < Number(wolfStats.fov || 300), dt);
          moveEntity(wolf, angleTo(wolf, target), Number(wolfStats.speed || 110) * sprintMult, dt);

          const collisionDist = Number(wolf.radius || 22) + Number(target.radius || 12);
          if (d <= collisionDist + 4 && wolf.attackCooldown <= 0) {
            wolf.attackCooldown = Number(wolfStats.attack_cooldown_sec || 0.52);
            target.hitFlash = 0.18;
            const killed = hurtEntity(target, Number(wolfStats.strength || 10));
            if (killed) {
              captures.push({
                id: target.id,
                species: target.species,
                at_ms: Math.round(performance.now() - startTime)
              });
            }
          }
        } else {
          wolf.wanderTimer = Number(wolf.wanderTimer || 0) - dt;
          if (wolf.wanderTimer <= 0) {
            wolf.wanderTimer = 0.7 + Math.random() * 1.4;
            wolf.heading += (Math.random() - 0.5) * 1.4;
          }
          const sprintMult = useSprint(wolf, wolfStats, false, dt);
          moveEntity(wolf, wolf.heading, Number(wolfStats.speed || 110) * 0.35 * sprintMult, dt);
        }
      }
    }

    function updatePreyAnimal(animal, dt) {
      const st = statForSpecies(animal.species);
      animal.attackCooldown = Math.max(0, Number(animal.attackCooldown || 0) - dt);
      animal.hitFlash = Math.max(0, Number(animal.hitFlash || 0) - dt);

      const nearestWolf = nearestLiving(animal, wolves, Number(st.fov || 120));
      const behavior = animal.behavior || st.behavior || 'wander';

      if (nearestWolf) {
        const d = dist(animal, nearestWolf);
        let angle = angleTo(nearestWolf, animal);
        let wantsSprint = true;

        if (behavior === 'zigzag_flee') {
          angle += Math.sin(performance.now() / 135) * 0.95;
        }

        if (behavior === 'burst_flee') {
          wantsSprint = Math.sin(performance.now() / 190) > -0.25;
          angle += Math.sin(performance.now() / 220) * 0.55;
        }

        if (behavior === 'defensive_flee' && d < Number(animal.radius || 18) + Number(nearestWolf.radius || 22) + 8) {
          if (animal.attackCooldown <= 0) {
            animal.attackCooldown = Number(st.attack_cooldown_sec || 1.05);
            nearestWolf.hitFlash = 0.2;
            hurtEntity(nearestWolf, Number(st.strength || 4));
          }
          angle = angleTo(nearestWolf, animal);
        }

        if (behavior === 'panic_kick' && d < Number(animal.radius || 23) + Number(nearestWolf.radius || 22) + 8) {
          if (animal.attackCooldown <= 0) {
            animal.attackCooldown = Number(st.attack_cooldown_sec || 1.35);
            nearestWolf.hitFlash = 0.2;
            hurtEntity(nearestWolf, Number(st.strength || 10));
          }
          angle += Math.sin(performance.now() / 120) * 0.7;
        }

        if (behavior === 'stand_ground') {
          if (d < Number(animal.radius || 28) + Number(nearestWolf.radius || 22) + 12 && animal.attackCooldown <= 0) {
            animal.attackCooldown = Number(st.attack_cooldown_sec || 1.20);
            nearestWolf.hitFlash = 0.2;
            hurtEntity(nearestWolf, Number(st.strength || 18));
          }
          if (d < Number(st.fov || 280) * 0.42) {
            angle = angleTo(animal, nearestWolf);
            wantsSprint = false;
          }
        }

        if (behavior === 'charge' || behavior === 'herd_charge') {
          if (d < Number(st.fov || 300) * 0.55) {
            angle = angleTo(animal, nearestWolf);
            wantsSprint = true;
          }
          if (d < Number(animal.radius || 34) + Number(nearestWolf.radius || 22) + 16 && animal.attackCooldown <= 0) {
            animal.attackCooldown = Number(st.attack_cooldown_sec || 1.45);
            nearestWolf.hitFlash = 0.25;
            hurtEntity(nearestWolf, Number(st.strength || 30));
          }
        }

        const sprintMult = useSprint(animal, st, wantsSprint, dt);
        moveEntity(animal, angle, Number(st.speed || 50) * sprintMult, dt);
        return;
      }

      animal.wanderTimer = Number(animal.wanderTimer || 0) - dt;
      if (animal.wanderTimer <= 0) {
        animal.wanderTimer = 0.8 + Math.random() * 2.4;
        animal.heading += (Math.random() - 0.5) * 1.7;
      }

      const sprintMult = useSprint(animal, st, false, dt);
      moveEntity(animal, animal.heading, Number(st.speed || 50) * 0.32 * sprintMult, dt);
    }

    function updatePredatorAnimal(animal, dt) {
      const st = statForSpecies(animal.species, 'grizzly');
      animal.attackCooldown = Math.max(0, Number(animal.attackCooldown || 0) - dt);
      animal.hitFlash = Math.max(0, Number(animal.hitFlash || 0) - dt);

      const targetWolf = nearestLiving(animal, wolves, Number(st.fov || 280));

      if (targetWolf) {
        const d = dist(animal, targetWolf);
        const ambush = animal.behavior === 'ambush_predator';
        let angle = angleTo(animal, targetWolf);

        if (ambush && d > Number(st.fov || 300) * 0.55) {
          angle += Math.sin(performance.now() / 260) * 0.4;
        }

        const sprintMult = useSprint(animal, st, d < Number(st.fov || 280) * 0.75, dt);
        moveEntity(animal, angle, Number(st.speed || 120) * sprintMult, dt);

        if (d < Number(animal.radius || 30) + Number(targetWolf.radius || 22) + 10 && animal.attackCooldown <= 0) {
          animal.attackCooldown = Number(st.attack_cooldown_sec || (ambush ? 0.72 : 1.05));
          targetWolf.hitFlash = 0.25;
          hurtEntity(targetWolf, Number(st.strength || 30));
        }

        return;
      }

      animal.wanderTimer = Number(animal.wanderTimer || 0) - dt;
      if (animal.wanderTimer <= 0) {
        animal.wanderTimer = 0.9 + Math.random() * 2.2;
        animal.heading += (Math.random() - 0.5) * 1.2;
      }

      const sprintMult = useSprint(animal, st, false, dt);
      moveEntity(animal, animal.heading, Number(st.speed || 120) * 0.28 * sprintMult, dt);
    }

    function updateAnimals(dt) {
      for (const animal of prey) {
        if (!animal.alive) continue;
        updatePreyAnimal(animal, dt);
      }

      for (const animal of predators) {
        if (!animal.alive) continue;
        updatePredatorAnimal(animal, dt);
      }
    }

    function render() {
      const cw = canvas.width;
      const ch = canvas.height;
      ctx.clearRect(0, 0, cw, ch);

      const scale = Math.min(cw / WORLD_W, ch / WORLD_H);
      const ox = (cw - WORLD_W * scale) / 2;
      const oy = (ch - WORLD_H * scale) / 2;

      function sx(x) { return ox + x * scale; }
      function sy(y) { return oy + y * scale; }
      function ss(v) { return v * scale; }

      ctx.save();
      ctx.fillStyle = '#4b7d25';
      ctx.fillRect(0, 0, cw, ch);

      if (grassImg) {
        ctx.drawImage(grassImg, ox, oy, WORLD_W * scale, WORLD_H * scale);
      } else {
        ctx.fillStyle = '#5f8f27';
        ctx.fillRect(ox, oy, WORLD_W * scale, WORLD_H * scale);
      }

      ctx.strokeStyle = 'rgba(255,255,255,0.35)';
      ctx.lineWidth = Math.max(1, 2 * scale);
      ctx.strokeRect(ox, oy, WORLD_W * scale, WORLD_H * scale);

      const renderAnimals = animals
        .filter((a) => a.alive)
        .slice()
        .sort((a, b) => Number(a.y || 0) - Number(b.y || 0));

      for (const animal of renderAnimals) {
        const st = statForSpecies(animal.species);
        const img = animalImages.get(animal.species);
        const size = ss(Math.max(28, Number(st.radius || animal.radius || 12) * 3.2));
        const x = sx(animal.x);
        const y = sy(animal.y);

        ctx.save();
        ctx.globalAlpha = animal.hitFlash > 0 ? 0.72 : 1;
        ctx.translate(x, y);
        ctx.rotate(Number(animal.heading || 0));

        if (img) {
          ctx.drawImage(img, -size / 2, -size / 2, size, size);
        } else {
          ctx.fillStyle = animal.role === 'predator' ? '#7b2f22' : '#e6d3a7';
          ctx.beginPath();
          ctx.arc(0, 0, size / 2, 0, Math.PI * 2);
          ctx.fill();
        }

        ctx.restore();

        drawVitalsBars(animal, x, y, size, st);

        if (animal.role === 'predator') {
          ctx.save();
          ctx.fillStyle = 'rgba(0,0,0,0.55)';
          ctx.font = `${Math.max(10, 11 * scale)}px system-ui, sans-serif`;
          ctx.textAlign = 'center';
          ctx.fillText('⚠', x, y - size * 0.62 - 17);
          ctx.restore();
        }
      }

      for (const wolf of wolves.filter((w) => w.alive).sort((a, b) => a.y - b.y)) {
        const wolfStats = statForWolf(wolf.meta);
        const portrait = wolfPortraits.get(wolf.wolf_id);
        const size = ss(Math.max(48, Number(wolfStats.radius || wolf.radius || 22) * 3.35));
        const x = sx(wolf.x);
        const y = sy(wolf.y);

        ctx.save();
        ctx.globalAlpha = wolf.hitFlash > 0 ? 0.75 : 1;

        if (portrait) {
          ctx.drawImage(portrait, x - size / 2, y - size / 2, size, size);
        } else {
          ctx.fillStyle = '#e8e0cf';
          ctx.beginPath();
          ctx.arc(x, y, size / 2, 0, Math.PI * 2);
          ctx.fill();
        }

        ctx.restore();

        drawVitalsBars(wolf, x, y, size, wolfStats);
      }

      ctx.restore();
    }

    function frame(now) {
      if (!running) return;

      const elapsedMs = now - startTime;
      const dt = Math.min(MAX_DT, Math.max(0.001, (now - lastTime) / 1000));
      lastTime = now;

      updateWolves(dt);
      updateAnimals(dt);
      render();

      const remainingPrey = prey.filter((p) => p.alive).length;
      const remainingWolves = wolves.filter((w) => w.alive).length;
      const totalPrey = prey.length;
      const totalWolves = wolves.length;

      onTick({
        elapsedMs,
        remainingPrey,
        remainingWolves,
        totalPrey,
        totalWolves,
        remainingPredators: predators.filter((p) => p.alive).length,
        totalPredators: predators.length
      });

      const cleared = remainingPrey <= 0;
      const wiped = remainingWolves <= 0;
      const timedOut = elapsedMs >= Number(level.duration_ms || 90000);

      if (cleared || wiped || timedOut) {
        stop({
          elapsed_ms: Math.round(elapsedMs),
          captures,
          wolves_alive: remainingWolves,
          reason: cleared ? 'cleared' : (wiped ? 'wiped' : 'time')
        });
        return;
      }

      rafId = requestAnimationFrame(frame);
    }

    async function start() {
      await preload();
      running = true;
      startTime = performance.now();
      lastTime = startTime;
      rafId = requestAnimationFrame(frame);
    }

    function stop(result) {
      if (!running) return;
      running = false;
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', resize);
      onEnd(result || {
        elapsed_ms: Math.round(performance.now() - startTime),
        captures,
        wolves_alive: wolves.filter(w => w.alive).length,
        reason: 'manual'
      });
    }

    return { start, stop };
  }

  // ---- Modal wiring ------------------------------------------------
  let simEngine = null;
  let simRunToken = null;

  async function openSimModal() {
    if (!els.simModal) return;
    hideAlert();

    if (!requireComingSoonPassword()) return;

    document.documentElement.classList.add('nw-modal-open');
    document.body.classList.add('nw-modal-open');
    if (els.goalsModal) els.goalsModal.hidden = true;
    if (els.backdrop) els.backdrop.hidden = false;
    els.simModal.hidden = false;
    showSimScreen('menu');

    refreshSimMenu();

    try {
      const res = await api('/api/games/trails/state');
      const trails = res.trivia_trails || res.trails || null;
      if (trails) {
        state.trailsState = trails;
        if (state.me) state.me.trivia_trails = trails;
      }
    } catch (e) {}

    refreshSimMenu();
  }

  function closeSimModal(reopenGames = true) {
    if (simEngine) { simEngine.stop(); simEngine = null; }
    simRunToken = null;
    if (els.simModal) els.simModal.hidden = true;
    document.documentElement.classList.remove('nw-modal-open');
    document.body.classList.remove('nw-modal-open');
    if (reopenGames) {
      openGoalsModalToTab('games');
    } else if (els.backdrop) {
      els.backdrop.hidden = true;
    }
  }

  function showSimScreen(name) {
    if (els.simScreenMenu)   els.simScreenMenu.hidden   = name !== 'menu';
    if (els.simScreenGame)   els.simScreenGame.hidden   = name !== 'game';
    if (els.simScreenResult) els.simScreenResult.hidden = name !== 'result';
  }

  function runSimCountdown() {
    return new Promise((resolve) => {
      if (!els.simCanvas) {
        resolve();
        return;
      }

      const canvas = els.simCanvas;
      const rect = canvas.getBoundingClientRect();

      const overlay = document.createElement('div');
      overlay.className = 'nw-sim-countdown-overlay';
      overlay.style.position = 'fixed';
      overlay.style.left = `${rect.left}px`;
      overlay.style.top = `${rect.top}px`;
      overlay.style.width = `${rect.width}px`;
      overlay.style.height = `${rect.height}px`;
      overlay.style.zIndex = '999999';
      overlay.style.display = 'flex';
      overlay.style.alignItems = 'center';
      overlay.style.justifyContent = 'center';
      overlay.style.pointerEvents = 'none';
      overlay.style.borderRadius = '18px';
      overlay.style.background = 'radial-gradient(circle at center, rgba(0,0,0,0.28), rgba(0,0,0,0.08), transparent 68%)';
      overlay.style.backdropFilter = 'blur(1px)';

      const number = document.createElement('div');
      number.style.width = '118px';
      number.style.height = '118px';
      number.style.borderRadius = '999px';
      number.style.display = 'flex';
      number.style.alignItems = 'center';
      number.style.justifyContent = 'center';
      number.style.background = 'rgba(7,22,13,0.86)';
      number.style.border = '2px solid rgba(142,220,89,0.85)';
      number.style.boxShadow = '0 0 34px rgba(142,220,89,0.45), 0 22px 70px rgba(0,0,0,0.35)';
      number.style.color = '#ffffff';
      number.style.fontSize = '58px';
      number.style.fontWeight = '950';
      number.style.lineHeight = '1';
      number.style.fontFamily = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
      number.style.transform = 'scale(0.72)';
      number.style.opacity = '0';

      overlay.appendChild(number);
      document.body.appendChild(overlay);

      const beats = ['3', '2', '1', 'GO'];
      let index = 0;

      function pulse() {
        number.textContent = beats[index];
        number.animate([
          { transform: 'scale(0.72)', opacity: 0 },
          { transform: 'scale(1.1)', opacity: 1, offset: 0.32 },
          { transform: 'scale(1)', opacity: 1, offset: 0.72 },
          { transform: 'scale(0.86)', opacity: 0 }
        ], {
          duration: 720,
          easing: 'cubic-bezier(.2,.8,.2,1)'
        });

        index += 1;

        if (index >= beats.length) {
          setTimeout(() => {
            overlay.remove();
            resolve();
          }, 720);
        } else {
          setTimeout(pulse, 760);
        }
      }

      pulse();
    });
  }

  function refreshSimMenu() {
    const hearts = getSharedHeartBalance();
    if (els.simHearts) els.simHearts.textContent = String(hearts);
    if (els.simPackXp) els.simPackXp.textContent = String(getSharedPackXp());
    if (els.goalsHeartsAvailable) els.goalsHeartsAvailable.textContent = String(hearts);

    const levelButtons = els.simScreenMenu
      ? els.simScreenMenu.querySelectorAll('[data-sim-level]')
      : [];

    levelButtons.forEach((btn) => {
      btn.disabled = hearts < 1;
      btn.classList.toggle('is-disabled', hearts < 1);
    });

    if (els.simStartBtn && !els.simStartBtn.matches('[data-sim-level]')) {
      els.simStartBtn.disabled = hearts < 1;
      els.simStartBtn.textContent = hearts < 1 ? 'Need 1 heart to enter' : 'Start Level 1 — First Crawl';
    }
  }

  async function startPackSimLevel(levelNumber) {
    try {
      const safeLevel = Math.max(1, Number(levelNumber || 1));
      const res = await api('/api/games/pack-sim/start', 'POST', { level: safeLevel });
      simRunToken = res.run_token;

      const newHearts = Number(res.hearts_left || 0);
      if (!state.trailsState) state.trailsState = {};
      state.trailsState.hearts = newHearts;
      if (state.me && state.me.trivia_trails) state.me.trivia_trails.hearts = newHearts;

      showSimScreen('game');

      const totalPrey = Array.isArray(res.prey)
        ? res.prey.length
        : (Array.isArray(res.animals) ? res.animals.filter((a) => a.role !== 'predator').length : 0);

      if (els.simHudPrey)   els.simHudPrey.textContent   = `0 / ${totalPrey}`;
      if (els.simHudWolves) els.simHudWolves.textContent = `${res.wolves.length} / ${res.wolves.length}`;
      if (els.simHudTimer)  els.simHudTimer.textContent  = `${Math.ceil(res.level.duration_ms / 1000)}s`;

      if (simEngine) simEngine.stop();

      simEngine = createPackSimEngine({
        canvas: els.simCanvas,
        snapshot: res,
        onTick: ({ elapsedMs, remainingPrey, remainingWolves, totalPrey, totalWolves }) => {
          if (els.simHudPrey)   els.simHudPrey.textContent   = `${totalPrey - remainingPrey} / ${totalPrey}`;
          if (els.simHudWolves) els.simHudWolves.textContent = `${remainingWolves} / ${totalWolves}`;
          if (els.simHudTimer)  els.simHudTimer.textContent  = `${Math.max(0, Math.ceil((res.level.duration_ms - elapsedMs) / 1000))}s`;
        },
        onEnd: async (result) => {
          await finishPackSim(result);
        }
      });

      await runSimCountdown();
      await simEngine.start();
    } catch (err) {
      window.alert(err.message || 'Could not start the simulator.');
    }
  }

  async function finishPackSim(result) {
    if (!simRunToken) return;
    const token = simRunToken;
    simRunToken = null;

    try {
      const res = await api('/api/games/pack-sim/finish', 'POST', {
        run_token: token,
        captures: result.captures,
        wolves_alive: result.wolves_alive,
        elapsed_ms: result.elapsed_ms
      });

      showSimScreen('result');

      if (els.simResultTitle) {
        els.simResultTitle.textContent = res.cleared ? 'Pack Simulator Cleared' : 'Pack Simulator Run Ended';
      }

      state.simPendingSwagClaim = res.swag_claim || null;

      if (els.simResultBody) {
        const lines = [
          `Prey caught: ${res.captures_count} / ${res.prey_total}`,
          res.cleared ? `Pack XP earned: +${Number(res.pack_xp_awarded || 0)} 🐾` : 'No Pack XP earned this run.',
          res.cleared ? 'Your heart was returned.' : 'One heart was used for this run.',
          state.simPendingSwagClaim ? 'A swag claim is ready for your collection.' : 'No new swag claim unlocked from this level.',
          `Hearts remaining: ${res.hearts_left} ❤️`
        ];
        els.simResultBody.innerHTML = lines.map(l => `<div>${escapeHtml(l)}</div>`).join('');
      }

      if (els.simResultClaimSwag) {
        els.simResultClaimSwag.hidden = !state.simPendingSwagClaim;
        els.simResultClaimSwag.disabled = false;
        els.simResultClaimSwag.textContent = 'Claim Swag';
      }

      const newHearts = Number(res.hearts_left || 0);
      if (!state.trailsState) state.trailsState = {};
      state.trailsState.hearts = newHearts;
      if (state.me && state.me.trivia_trails) state.me.trivia_trails.hearts = newHearts;
      if (state.me) state.me.pack_xp = Number(res.pack_xp || state.me.pack_xp || 0);

      refreshSimMenu();
      syncVisibleBalances();



      try {
        const meRes = await api('/api/me', 'GET');
        state.me = meRes.member || meRes.user || meRes.profile || state.me;
        state.pendingAwards = Array.isArray(meRes.pending_awards) ? meRes.pending_awards : [];
        renderProfile();
        renderGoalsBalances();
        if (typeof updateAwardNotification === 'function') updateAwardNotification();
      } catch (e) {}
    } catch (err) {
      window.alert(err.message || 'Could not finalize the run.');
      showSimScreen('menu');
    }
  }

  // Bindings
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('#nw-open-pack-sim-btn');
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      openSimModal();
      return;
    }

    const levelBtn = e.target.closest('[data-sim-level]');
    if (levelBtn && els.simScreenMenu && els.simScreenMenu.contains(levelBtn)) {
      e.preventDefault();
      e.stopPropagation();

      const hearts = getSharedHeartBalance();
      if (hearts < 1) {
        window.alert('You need at least 1 heart to enter the simulator.');
        refreshSimMenu();
        return;
      }

      startPackSimLevel(Number(levelBtn.getAttribute('data-sim-level') || 1));
    }
  });

  if (els.simClose)       els.simClose.addEventListener('click', () => closeSimModal(true));
  if (els.simBackBtn)     els.simBackBtn.addEventListener('click', () => closeSimModal(true));
  if (els.simResultClose) els.simResultClose.addEventListener('click', () => closeSimModal(true));

  if (els.simStartBtn && !els.simStartBtn.matches('[data-sim-level]')) {
    els.simStartBtn.addEventListener('click', () => startPackSimLevel(1));
  }

  // ===================================================================
  // ============ END NATURE WOLF PACK SIMULATOR (client) ==============
  // ===================================================================

  captureReferralContextFromUrl();
  attachNewsletterReferralCapture();
  attachPackPlusButtons();
  renderPackPlusSurface();
  trackEvent('den_page_view', {
    source: 'den_script_boot'
  });
  boot();
})();